module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "021d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_distillery_Documents_Work_roshydromet_packages_visary_infrastructure_vue_v1_2_0_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ade3");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("14d9");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cebe");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ __webpack_exports__["a"] = ({
  source: axios__WEBPACK_IMPORTED_MODULE_2___default.a.CancelToken.source,
  isCancel: axios__WEBPACK_IMPORTED_MODULE_2___default.a.isCancel,
  sources: () => new class {
    constructor() {
      Object(_Users_distillery_Documents_Work_roshydromet_packages_visary_infrastructure_vue_v1_2_0_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, "sources", []);
    }
    token() {
      const source = axios__WEBPACK_IMPORTED_MODULE_2___default.a.CancelToken.source();
      this.sources.push(source);
      return source.token;
    }
    cancel(message = null) {
      this.sources.forEach(source => source.cancel(message));
      this.sources = [];
    }
  }()
});

/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var NATIVE_BIND = __webpack_require__("40d5");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "04f8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d26":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "0d51":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "0f0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (millis => new Promise(resolve => setTimeout(resolve, millis)));

/***/ }),

/***/ "0faf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1203":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_add_drive_permission_vue_vue_type_style_index_0_id_75507717_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69b9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_add_drive_permission_vue_vue_type_style_index_0_id_75507717_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_add_drive_permission_vue_vue_type_style_index_0_id_75507717_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var CHROME_VERSION = __webpack_require__("2d00");
var IS_NODE = __webpack_require__("605d");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "1429":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_dialog_vue_vue_type_style_index_0_id_531201bc_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6c7d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_dialog_vue_vue_type_style_index_0_id_531201bc_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_dialog_vue_vue_type_style_index_0_id_531201bc_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "14d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var setArrayLength = __webpack_require__("3a34");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var fails = __webpack_require__("d039");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "1626":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "182d":
/***/ (function(module, exports, __webpack_require__) {

var toPositiveInteger = __webpack_require__("f8cd");

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ "195c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: ./src/utils/configure-params-serializer.js
var configure_params_serializer = __webpack_require__("d49b");

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__("cebe");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// CONCATENATED MODULE: ./src/api/osm-api/repository.js



let axiosInstance = null;
const configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  axiosInstance = axios;
};
configure(external_axios_default.a.create({
  baseURL: "https://nominatim.openstreetmap.org"
}));
/* harmony default export */ var repository = ({
  get instance() {
    if (!axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return axiosInstance;
  }
});
// EXTERNAL MODULE: external "devextreme/core/utils/dependency_injector"
var dependency_injector_ = __webpack_require__("2214");
var dependency_injector_default = /*#__PURE__*/__webpack_require__.n(dependency_injector_);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: external "@mapbox/polyline"
var polyline_ = __webpack_require__("ff9b");
var polyline_default = /*#__PURE__*/__webpack_require__.n(polyline_);

// CONCATENATED MODULE: ./src/api/osm-api/converters.js


function convertOsmRoutesResponse(response) {
  var _response$routes;
  const routes = (_response$routes = response === null || response === void 0 ? void 0 : response.routes) !== null && _response$routes !== void 0 ? _response$routes : [];
  if (!routes[0] || !Array.isArray(routes[0].legs)) {
    return [];
  }
  const result = routes[0].legs.map(convertToRouteModel);
  return result;
}
function convertToRouteModel({
  steps,
  distance,
  duration,
  summary
}) {
  var _getNameFromSteps;
  return createRouteModel(distance, duration, getNameFromSteps(steps !== null && steps !== void 0 ? steps : [], "start"), (_getNameFromSteps = getNameFromSteps(steps !== null && steps !== void 0 ? steps : [], "end")) !== null && _getNameFromSteps !== void 0 ? _getNameFromSteps : summary, getGeometryFromSteps(steps !== null && steps !== void 0 ? steps : []));
}
function getNameFromSteps(steps, dir) {
  const arr = dir === "start" ? steps : steps.slice().reverse();
  for (let i = 0; i < arr.length; i++) {
    const step = arr[i];
    if (step.name) {
      return step.name;
    }
  }
  return null;
}
function getGeometryFromSteps(steps) {
  const coordinates = [];
  for (let i = 0; i < steps.length; i++) {
    const step = steps[i];
    if (step.geometry) {
      const points = polyline_default.a.decode(step.geometry);
      if (Array.isArray(points)) {
        coordinates.push.apply(coordinates, points.filter(p => !!p));
      }
    }
  }
  for (let k = 0, c = coordinates.length; k < c; k++) {
    swap(coordinates[k], 0, 1);
  }
  return {
    type: "LineString",
    coordinates
  };
}
function createRouteModel(totalDistance, totalTime, startName, endName, geometry) {
  return {
    totalDistance,
    totalTime,
    startName,
    endName,
    geometry
  };
}
function swap(arr, i1, i2) {
  const tmp = arr[i1];
  arr[i1] = arr[i2];
  arr[i2] = tmp;
}
// CONCATENATED MODULE: ./src/api/osm-api/routes.js



function getRouteCoords(startLatLng, stopLatLng) {
  return encodeURIComponent(`${startLatLng[1]},${startLatLng[0]};${stopLatLng[1]},${stopLatLng[0]}`);
}
/* harmony default export */ var routes = (dependency_injector_default()({
  findRoutes: async (startLatLng, stopLatLng, cancelToken = null) => convertOsmRoutesResponse((await repository.instance.get(`routed-car/route/v1/driving/${getRouteCoords(startLatLng, stopLatLng)}`, {
    baseURL: "https://routing.openstreetmap.de",
    params: {
      overview: false,
      geometries: "polyline",
      steps: true
    },
    cancelToken
  })).data)
}));
// CONCATENATED MODULE: ./src/api/osm-api/search.js


/* harmony default export */ var search = (dependency_injector_default()({
  reverseSearch: async (lat, lon, zoom = undefined, isPolygon = false, cancelToken = null) => (await repository.instance.get("reverse", {
    params: {
      format: "json",
      lat: lat != null ? lat : undefined,
      lon: lon != null ? lon : undefined,
      zoom: zoom != null ? zoom : undefined,
      "accept-language": "ru_RU",
      polygon_geojson: isPolygon ? 1 : 0
    },
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/osm-api/index.js



/* harmony default export */ var osm_api = __webpack_exports__["a"] = ({
  configure: configure,
  search: search,
  routes: routes
});

/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("3a9b");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1a63":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1b62":
/***/ (function(module, exports) {



/***/ }),

/***/ "1d02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("ebb5");
var $findLastIndex = __webpack_require__("a258").findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "1d41":
/***/ (function(module, exports) {



/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("7234");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1deb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_dialog_vue_vue_type_style_index_0_id_251e9f26_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b696");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_dialog_vue_vue_type_style_index_0_id_251e9f26_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_dialog_vue_vue_type_style_index_0_id_251e9f26_prod_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* unused harmony default export */ var _unused_webpack_default_export = (null);


/***/ }),

/***/ "2214":
/***/ (function(module, exports) {

module.exports = require("devextreme/core/utils/dependency_injector");

/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2af9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "VisMapView", function() { return /* reexport */ vis_map_view; });
__webpack_require__.d(__webpack_exports__, "VisFileStorage", function() { return /* reexport */ vis_file_storage; });

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-view.vue?vue&type=template&id=6032ae7e&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map', {
    ref: "map",
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "min-zoom": _vm.minZoom,
      "max-zoom": _vm.maxZoom,
      "bounds": _vm.bounds,
      "max-bounds": _vm.maxBounds,
      "use-fly-to": _vm.useFlyTo,
      "zoom-control": false,
      "map-options": _vm.mergedMapOptions
    }
  }, [_vm._t("controls", function () {
    return [_vm.zoomControl ? _c('v-map-zoom-control') : _vm._e(), _vm.searchControl ? _c('v-map-search-control', {
      attrs: {
        "data-source": _vm.searchPlace
      }
    }) : _vm._e(), _vm.routesControl ? _c('v-map-routes-control', {
      attrs: {
        "data-source": _vm.fetchRoutes
      }
    }) : _vm._e(), _vm.printControl ? _c('v-map-print-control', {
      attrs: {
        "visible": _vm.printControlVisible,
        "with-sidebar": _vm.printWithSidebar,
        "with-controls": "",
        "only-scale-control": ""
      }
    }) : _vm._e(), _vm.saveAsImageControl ? _c('v-map-print-control', {
      attrs: {
        "visible": _vm.printControlVisible,
        "with-sidebar": _vm.printWithSidebar,
        "save-file-name": _vm.saveFileName,
        "save-as": "",
        "with-controls": "",
        "only-scale-control": ""
      }
    }) : _vm._e(), _vm.heatmapControl ? _c('v-map-heatmap-control') : _vm._e(), _vm.rulerControl ? _c('v-map-ruler-control') : _vm._e(), _vm.fullscreenControl ? _c('v-map-fullscreen-control', {
      attrs: {
        "all-page": _vm.fullscreenAllPage,
        "active-class-name": "vis-map-html--fullscreen-on"
      }
    }) : _vm._e(), _vm.locateControl ? _c('v-map-location-control') : _vm._e(), _vm.scaleControl ? _c('v-map-scale-control') : _vm._e()];
  }), _vm._t("tiles", function () {
    return [_c('v-map-layers-control', {
      attrs: {
        "current": _vm.currentTile,
        "overlays": _vm.overlays
      },
      on: {
        "update:current": function ($event) {
          _vm.currentTile = $event;
        }
      }
    }, [_vm.osmLabel ? _c('v-map-osm-tile-layer', {
      attrs: {
        "name": _vm.osmLabel
      }
    }) : _vm._e(), _vm.sputnikLabel ? _c('v-map-sputnik-tile-layer', {
      attrs: {
        "name": _vm.sputnikLabel
      }
    }) : _vm._e(), _vm.mapboxLabel ? _c('v-map-mapbox-tile-layer', {
      attrs: {
        "name": _vm.mapboxLabel
      }
    }) : _vm._e(), _vm.arcGisAeroLabel ? _c('v-map-arc-gis-aero-tile-layer', {
      attrs: {
        "name": _vm.arcGisAeroLabel
      }
    }) : _vm._e(), _vm.arcGisLabel ? _c('v-map-arc-gis-tile-layer', {
      attrs: {
        "name": _vm.arcGisLabel
      }
    }) : _vm._e(), _vm.ocmLabel ? _c('v-map-ocm-tile-layer', {
      attrs: {
        "name": _vm.ocmLabel
      }
    }) : _vm._e(), _vm.yandexTile && _vm.yandexMapLabel ? _c('v-map-yandex-tile-layer', {
      attrs: {
        "name": _vm.yandexMapLabel
      }
    }) : _vm._e(), _vm.googleTile && _vm.googleMapLabel ? _c('v-map-google-tile-layer', {
      attrs: {
        "name": _vm.googleMapLabel
      }
    }) : _vm._e(), _vm.yandexTile && _vm.yandexHybridLabel ? _c('v-map-yandex-tile-layer', {
      attrs: {
        "name": _vm.yandexHybridLabel,
        "type": "publicMapHybrid"
      }
    }) : _vm._e(), _vm.googleTile && _vm.googleHybridLabel ? _c('v-map-google-tile-layer', {
      attrs: {
        "name": _vm.googleHybridLabel,
        "type": "HYBRID"
      }
    }) : _vm._e(), _vm._t("other-tiles"), _vm.cadastreTile && _vm.cadastreLabel ? _c('v-map-cadastre-tile-layer', {
      attrs: {
        "name": _vm.cadastreLabel
      }
    }) : _vm._e(), _vm._l(this.wmsLayers, function (layer) {
      return _c('v-map-wms-tile-layer', {
        key: layer.id,
        attrs: {
          "name": layer.title,
          "url": layer.url,
          "layer-type": layer.layerType,
          "layers": layer.layers,
          "styles": layer.styles,
          "transparent": layer.transparent,
          "format": layer.format,
          "version": layer.version,
          "uppercase": layer.uppercase
        }
      });
    })], 2)];
  }), _vm._t("loading", null, {
    "loading": _vm.loading,
    "ready": _vm.ready,
    "container": _vm.getMapContainer()
  }), _c('v-map-sidebar', {
    ref: "sidebar",
    attrs: {
      "open": _vm.sidebarOpen
    }
  }, [_c('v-map-layer-panel', _vm._l(_vm.layerTree, function (item) {
    return _c('vis-map-tree-layer', {
      key: item.id,
      attrs: {
        "item-data": item
      },
      on: {
        "popup:edit": _vm.onPopupEdit,
        "popup:delete": _vm.onPopupDelete,
        "popup:details": _vm.onPopupDetails,
        "popup:action": _vm.onPopupAction,
        "filter": _vm.onFilter,
        "count:click": _vm.onCountPressed,
        "count:changed": _vm.onCountChanged,
        "cluster:count": _vm.onClusterCountPressed,
        "clientcluster:count": _vm.onClientClusterCountPressed,
        "editor:create": _vm.onEditorCreate,
        "editor:edit": _vm.onEditorEdit,
        "editor:delete": _vm.onEditorDelete,
        "editor:data": _vm.onEditorData,
        "editor:popupedit": _vm.onEditorPopupEdit,
        "object:delete": _vm.onObjectDelete,
        "object:edited": _vm.onObjectEdited,
        "object:editstart": _vm.onObjectEditStart,
        "object:editend": _vm.onObjectEditEnd,
        "tracker:follow": _vm.onTrackerFollow
      },
      scopedSlots: _vm._u([{
        key: "popup-other-content",
        fn: function ({
          layerId,
          layerType,
          content
        }) {
          return [_vm._t("popup-other-content", null, {
            "layerId": layerId,
            "layerType": layerType,
            "content": content
          })];
        }
      }, {
        key: "popup-toolbar-content",
        fn: function ({
          layerId,
          layerType,
          content
        }) {
          return [_vm._t("popup-toolbar-content", null, {
            "layerId": layerId,
            "layerType": layerType,
            "content": content
          })];
        }
      }], null, true)
    });
  }), 1), _c('vis-map-list-panel', {
    attrs: {
      "title": _vm.listPanel.title,
      "count": _vm.listPanel.count,
      "layer-id": _vm.listPanel.layerId,
      "filter-query": _vm.listPanel.filterQuery,
      "icon-name": _vm.listPanel.iconName,
      "cluster-id": _vm.listPanel.clusterId,
      "open": _vm.listPanel.open,
      "data-source": _vm.listPanel.dataSource,
      "no-auth": _vm.noAuth
    },
    on: {
      "update:open": function ($event) {
        return _vm.$set(_vm.listPanel, "open", $event);
      },
      "item-click": _vm.onItemClick
    }
  })], 1), _c('v-map-fit-handler', {
    ref: "fit",
    attrs: {
      "point-around-meters": _vm.itemFitPointAround
    }
  }), _vm._t("default")], 2);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/vis-map-view.vue?vue&type=template&id=6032ae7e&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: external "@rosgidromet/visary-map-vue-rgm"
var visary_map_vue_rgm_ = __webpack_require__("d978");

// EXTERNAL MODULE: ./src/api/visary-api/index.js + 5 modules
var visary_api = __webpack_require__("9252");

// EXTERNAL MODULE: ./src/api/osm-api/index.js + 4 modules
var osm_api = __webpack_require__("195c");

// EXTERNAL MODULE: ./src/utils/logger.js
var logger = __webpack_require__("823b");

// CONCATENATED MODULE: ./src/utils/from-json.js

/* harmony default export */ var from_json = ((jsonStr, def = null) => {
  if (!jsonStr) return def;
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    logger["a" /* default */].error(e);
    return def;
  }
});
// CONCATENATED MODULE: ./src/utils/to-float.js
/* harmony default export */ var to_float = ((str, def = null) => {
  const val = Number.parseFloat(str);
  return Number.isNaN(val) ? def : val;
});
// EXTERNAL MODULE: ./src/components/map/vis-map-tree-layer.vue + 4 modules
var vis_map_tree_layer = __webpack_require__("689e");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-list-panel.vue?vue&type=template&id=44d3ffe6&
var vis_map_list_panelvue_type_template_id_44d3ffe6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-panel', {
    attrs: {
      "open": _vm.open,
      "title": _vm.title,
      "count": _vm.count
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "search",
      fn: function () {
        return [_c('v-map-search', {
          attrs: {
            "value": _vm.searchString
          },
          on: {
            "input": _vm.onSearchInput
          }
        })];
      },
      proxy: true
    }, {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.iconName
        })];
      },
      proxy: true
    }])
  }, [_c('v-map-list', {
    attrs: {
      "items": _vm.listItems
    },
    on: {
      "item-click": _vm.onItemClick
    }
  }), _c('v-map-load-more', {
    ref: "loadMore",
    attrs: {
      "page": _vm.page,
      "data-source": _vm.reloadData
    },
    on: {
      "update:page": function ($event) {
        _vm.page = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        loading
      }) {
        return [loading ? _c('v-map-loading', {
          attrs: {
            "size": "sm"
          }
        }) : _vm._e()];
      }
    }])
  })], 1);
};
var vis_map_list_panelvue_type_template_id_44d3ffe6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/vis-map-list-panel.vue?vue&type=template&id=44d3ffe6&

// EXTERNAL MODULE: ./src/utils/cancel-token.js
var cancel_token = __webpack_require__("021d");

// EXTERNAL MODULE: external "debounce"
var external_debounce_ = __webpack_require__("81f2");
var external_debounce_default = /*#__PURE__*/__webpack_require__.n(external_debounce_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-list-panel.vue?vue&type=script&lang=js&






/* harmony default export */ var vis_map_list_panelvue_type_script_lang_js_ = ({
  name: "vis-map-list-panel",
  components: {
    VMapPanel: visary_map_vue_rgm_["VMapPanel"],
    VMapSearch: visary_map_vue_rgm_["VMapSearch"],
    VMapList: visary_map_vue_rgm_["VMapList"],
    VMapLoadMore: visary_map_vue_rgm_["VMapLoadMore"],
    VMapLoading: visary_map_vue_rgm_["VMapLoading"]
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      default: 0
    },
    layerId: {
      type: String,
      default: null
    },
    filterQuery: {
      type: String,
      default: null
    },
    iconName: {
      type: String,
      default: null
    },
    clusterId: {
      type: String,
      default: null
    },
    noAuth: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      listItems: [],
      page: 1,
      pageSize: 35,
      searchString: null,
      searchDelay: 300
    };
  },
  computed: {
    reloadDataProps() {
      return {
        open: this.open,
        layerId: this.layerId,
        filterQuery: this.filterQuery,
        clusterId: this.clusterId
      };
    }
  },
  watch: {
    reloadDataProps() {
      if (this.open) {
        this.resetAndReloadData();
      }
    }
  },
  created() {
    this.doSearch = external_debounce_default()(() => {
      this.listItems = [];
      this.resetPage();
    }, this.searchDelay);
  },
  destroyed() {
    this.cancelLoadData();
  },
  methods: {
    cancelLoadData() {
      if (this.cancelSource) {
        this.cancelSource.cancel();
        this.cancelSource = null;
      }
    },
    resetAndReloadData() {
      this.searchString = null;
      this.listItems = [];
      this.resetPage();
    },
    resetPage() {
      if (this.page > 1) {
        this.page = 1;
      } else {
        this.$refs.loadMore.fetchData();
      }
    },
    reloadData(pageNum) {
      this.cancelLoadData();
      return this.fetchData(pageNum);
    },
    async fetchData(pageNum) {
      try {
        this.cancelSource = cancel_token["a" /* default */].source();
        let listItems = [];
        if (this.dataSource) {
          listItems = (await this.dataSource(pageNum, this.pageSize, this.searchString, this.cancelSource.token)).map(this.toListItem);
        } else {
          listItems = (await this.fetchObjects(pageNum, this.cancelSource.token)).map(this.toListItem);
        }
        this.listItems.push.apply(this.listItems, listItems);
        return listItems.length;
      } catch (e) {
        if (cancel_token["a" /* default */].isCancel(e)) {
          throw Object(visary_map_vue_rgm_["makeCancel"])(e);
        }
        logger["a" /* default */].error(e);
        return 0;
      }
    },
    fetchObjects(pageNum, cancelToken) {
      if (this.clusterId) {
        return visary_api["a" /* default */].map.getObjectsByCluster(this.clusterId, this.layerId, pageNum, this.pageSize, this.searchString || undefined, this.filterQuery || undefined, cancelToken, this.noAuth);
      } else {
        return visary_api["a" /* default */].map.getObjectsForList(this.layerId, pageNum, this.pageSize, this.searchString || undefined, this.filterQuery || undefined, cancelToken, this.noAuth);
      }
    },
    toListItem({
      ID,
      Title,
      Geometry,
      GetGeometry
    }) {
      return {
        id: ID,
        title: Title,
        geometry: Geometry,
        getGeometry: GetGeometry
      };
    },
    onClose() {
      this.$emit("update:open", false);
    },
    onSearchInput(value) {
      this.searchString = value;
      this.doSearch();
    },
    onItemClick({
      geometry,
      getGeometry
    }) {
      if (!geometry && !getGeometry) return;
      if (typeof getGeometry === "function") {
        geometry = getGeometry();
      }
      this.$emit("item-click", {
        geometry
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/vis-map-list-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_vis_map_list_panelvue_type_script_lang_js_ = (vis_map_list_panelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/map/vis-map-list-panel.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  map_vis_map_list_panelvue_type_script_lang_js_,
  vis_map_list_panelvue_type_template_id_44d3ffe6_render,
  vis_map_list_panelvue_type_template_id_44d3ffe6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_map_list_panel = (component.exports);
// EXTERNAL MODULE: ./src/components/map/utils/layer-type-enum.js
var layer_type_enum = __webpack_require__("c17c");

// CONCATENATED MODULE: ./src/components/map/utils/client-data-source.js




const isEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
class client_data_source_ClientDataSource {
  constructor(noAuth = false) {
    this.filterQuery = null;
    this.excludeList = null;
    this.cancelSource = null;
    this.noAuth = noAuth;
    this.excludePredicate = this.excludePredicate.bind(this);
    this.arrayBufferResponse = false;
  }
  useArrayBufferResponse(inUse) {
    this.arrayBufferResponse = inUse;
  }
  async fetchData(layerId) {
    try {
      this.cancelFetchData();
      this.cancelSource = cancel_token["a" /* default */].source();
      const response = await visary_api["a" /* default */].map.getObjects(layerId, undefined, undefined, this.filterQuery || undefined, this.cancelSource.token, this.noAuth, this.arrayBufferResponse);
      if (this.arrayBufferResponse) {
        return response;
      }
      return response.filter(this.excludePredicate).map(this.toMapObject);
    } catch (e) {
      if (cancel_token["a" /* default */].isCancel(e)) {
        throw Object(visary_map_vue_rgm_["makeCancel"])(e);
      }
      logger["a" /* default */].error(e);
      return [];
    }
  }
  cancelFetchData() {
    if (this.cancelSource) {
      this.cancelSource.cancel();
      this.cancelSource = null;
    }
  }
  toMapObject({
    ID,
    Title,
    Description,
    Geometry
  }) {
    return {
      id: ID,
      title: Title,
      description: Description,
      geometry: Geometry
    };
  }
  setFilterQuery(query) {
    this.filterQuery = query;
  }
  excludePredicate({
    ID
  }) {
    return !this.excludeList || !this.excludeList[ID];
  }
  addExcludeId(id) {
    if (!this.excludeList) {
      this.excludeList = {};
    }
    this.excludeList[id] = true;
  }
  removeExcludeId(id) {
    delete this.excludeList[id];
    if (isEmpty(this.excludeList)) {
      this.excludeList = null;
    }
  }
}
/* harmony default export */ var client_data_source = (client_data_source_ClientDataSource);
// CONCATENATED MODULE: ./src/utils/types.js
function types_isEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
function isDefined(value) {
  return value !== null && value !== undefined;
}
// EXTERNAL MODULE: ./src/utils/timeout.js
var timeout = __webpack_require__("0f0f");

// CONCATENATED MODULE: ./src/components/map/utils/server-data-source.js






const itemType = Object.freeze({
  OBJECT: 1,
  CLUSTER: 2
});
const server_data_source_isEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
class server_data_source_ServerDataSource {
  constructor(noAuth = false) {
    this.filterQuery = null;
    this.excludeList = null;
    this.cancelSource = null;
    this.noAuth = noAuth;
    this.pendingFetchTimeout = null;
    this.pendingFetchRunning = false;
    this.excludePredicate = this.excludePredicate.bind(this);
  }
  setPendingFetchTimeout(timeout) {
    this.pendingFetchTimeout = timeout;
    return this;
  }
  async fetchData(layerId, bbox, zoom) {
    if (isDefined(this.pendingFetchTimeout)) {
      return await this.pendingFetch(layerId, bbox, zoom);
    } else {
      return await this.normalFetch(layerId, bbox, zoom);
    }
  }
  async pendingFetch(layerId, bbox, zoom) {
    if (this.pendingFetchRunning) {
      throw Object(visary_map_vue_rgm_["makeCancel"])("Cancel the request because the previous one has not been executed yet.");
    } else {
      try {
        this.pendingFetchRunning = true;
        await Object(timeout["a" /* default */])(this.pendingFetchTimeout);
        return await this.normalFetch(layerId, bbox, zoom);
      } finally {
        this.pendingFetchRunning = false;
      }
    }
  }
  async normalFetch(layerId, bbox, zoom) {
    try {
      this.cancelFetchData();
      this.cancelSource = cancel_token["a" /* default */].source();
      const response = await visary_api["a" /* default */].map.getObjects(layerId, bbox, zoom, this.filterQuery || undefined, this.cancelSource.token, this.noAuth);
      return response.filter(this.excludePredicate).map(this.toMapObject);
    } catch (e) {
      if (cancel_token["a" /* default */].isCancel(e)) {
        throw Object(visary_map_vue_rgm_["makeCancel"])(e.message);
      }
      logger["a" /* default */].error(e);
      return [];
    }
  }
  cancelFetchData() {
    if (this.cancelSource) {
      this.cancelSource.cancel();
      this.cancelSource = null;
    }
  }
  async fetchCount(layerId) {
    try {
      const count = await visary_api["a" /* default */].map.getObjectCount(layerId, this.filterQuery || undefined, null, this.noAuth);
      return typeof count === "number" ? count : 0;
    } catch (e) {
      logger["a" /* default */].error(e);
      return 0;
    }
  }
  toMapObject({
    ID,
    Title,
    Description,
    Geometry,
    Type,
    Count
  }) {
    if (Type === itemType.CLUSTER) {
      return {
        id: ID,
        geometry: Geometry,
        count: Count || 0,
        isCluster: true
      };
    } else {
      return {
        id: ID,
        title: Title,
        description: Description,
        geometry: Geometry
      };
    }
  }
  setFilterQuery(query) {
    this.filterQuery = query;
  }
  excludePredicate({
    ID,
    Type
  }) {
    return Type === itemType.CLUSTER || !this.excludeList || Type === itemType.OBJECT && !this.excludeList[ID];
  }
  addExcludeId(id) {
    if (!this.excludeList) {
      this.excludeList = {};
    }
    this.excludeList[id] = true;
  }
  removeExcludeId(id) {
    delete this.excludeList[id];
    if (server_data_source_isEmpty(this.excludeList)) {
      this.excludeList = null;
    }
  }
}
/* harmony default export */ var server_data_source = (server_data_source_ServerDataSource);
// CONCATENATED MODULE: ./src/components/map/utils/picket-data-source.js



class picket_data_source_PicketDataSource {
  constructor(layerId, noAuth = false) {
    this.layerId = layerId;
    this.cancelSource = null;
    this.noAuth = noAuth;
  }
  async fetchData(objectId) {
    try {
      this.cancelFetchData();
      this.cancelSource = cancel_token["a" /* default */].source();
      const response = await visary_api["a" /* default */].map.getPicketObjects(this.layerId, objectId, this.cancelSource.token, this.noAuth);
      return response.map(this.toPicketObject).filter(item => !!item);
    } catch (e) {
      if (cancel_token["a" /* default */].isCancel(e)) {
        return;
      }
      logger["a" /* default */].error(e);
      return [];
    }
  }
  cancelFetchData() {
    if (this.cancelSource) {
      this.cancelSource.cancel();
      this.cancelSource = null;
    }
  }
  toPicketObject({
    ID,
    Title,
    Location,
    OffsetFromStart
  }) {
    if (!Location) return null;
    return {
      id: ID,
      title: Title,
      geometry: Location.Disposition,
      offset: OffsetFromStart
    };
  }
}
/* harmony default export */ var picket_data_source = (picket_data_source_PicketDataSource);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./src/api/gistracker-api/index.js + 2 modules
var gistracker_api = __webpack_require__("fac5");

// EXTERNAL MODULE: external "leaflet"
var external_leaflet_ = __webpack_require__("860c");

// CONCATENATED MODULE: ./src/utils/geo-json.js

function pointToGeoJSON(latlng, precision) {
  return {
    type: "Point",
    coordinates: external_leaflet_["GeoJSON"].latLngToCoords(Object(external_leaflet_["latLng"])(latlng), precision)
  };
}
;
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./src/api/signalr/tracker-hub.js
var tracker_hub = __webpack_require__("b0e9");

// CONCATENATED MODULE: ./src/components/map/utils/shared-tracker-hub.js


class shared_tracker_hub_SharedTrackerHub {
  constructor() {
    shared_tracker_hub_SharedTrackerHub.refsCounter++;
  }
  get() {
    if (!shared_tracker_hub_SharedTrackerHub.instance) {
      shared_tracker_hub_SharedTrackerHub.instance = new tracker_hub["TrackerHubBuilder"]().build();
    }
    return shared_tracker_hub_SharedTrackerHub.instance;
  }
  destroy() {
    shared_tracker_hub_SharedTrackerHub.refsCounter--;
    if (shared_tracker_hub_SharedTrackerHub.refsCounter < 0) {
      shared_tracker_hub_SharedTrackerHub.refsCounter = 0;
    }
    if (shared_tracker_hub_SharedTrackerHub.instance && shared_tracker_hub_SharedTrackerHub.refsCounter === 0) {
      shared_tracker_hub_SharedTrackerHub.instance.destroy();
      shared_tracker_hub_SharedTrackerHub.instance = null;
    }
  }
}
Object(defineProperty["a" /* default */])(shared_tracker_hub_SharedTrackerHub, "instance", null);
Object(defineProperty["a" /* default */])(shared_tracker_hub_SharedTrackerHub, "refsCounter", 0);
/* harmony default export */ var shared_tracker_hub = (shared_tracker_hub_SharedTrackerHub);
// CONCATENATED MODULE: ./src/components/map/utils/tracker-data-source.js











const TrackerHubEvents = Object.freeze({
  teledataCreated: "teledataCreated"
});
const TrackerConnState = Object.freeze({
  None: "none",
  Connected: "connected",
  Disconnected: "disconnected"
});
const dataColumns = ["Title", "Description", "TrackerID"];
const dataSkip = 0;
const dataTake = 99999;
class tracker_data_source_TrackerDataSource {
  constructor(noAuth = false) {
    this.noAuth = noAuth;
    this.filterQuery = null;
    this.excludeList = null;
    this.cancelSource = null;
    this.onceReinitPos = false;
    this.excludePredicate = this.excludePredicate.bind(this);
    this.onTrackEvent = this.onTrackEvent.bind(this);
    this.onChangeVisible = this.onChangeVisible.bind(this);
    this.onHubReconnected = this.onHubReconnected.bind(this);
    this.onHubConnectionStateChanged = this.onHubConnectionStateChanged.bind(this);
  }
  init(trackLayer) {
    this.trackLayer = trackLayer;
    this.trackLayer.$on("update:visible", this.onChangeVisible);
    this.tracker = trackLayer.getTracker();
    this.objects = [];
    this.objectsByTrackers = {};
    this.sharedTrackerHub = new shared_tracker_hub();
    this.sharedTrackerHub.get().events.on("reconnected", this.onHubReconnected).on("connection-state", this.onHubConnectionStateChanged);
    this.sharedTrackerHub.get().on(TrackerHubEvents.teledataCreated, this.onTrackEvent);
  }
  subscribe(trackerIds) {
    if (trackerIds.length > 0) {
      this.sharedTrackerHub.get().subscribe(trackerIds);
    }
  }
  unsubscribe(trackerIds) {
    if (trackerIds.length > 0) {
      this.sharedTrackerHub.get().unsubscribe(trackerIds);
    }
  }
  onHubReconnected() {
    this.onceReinitPos = true;
  }
  onHubConnectionStateChanged(connectionState) {
    if (connectionState === tracker_hub["HubConnectionState"].Connected) {
      this.updateTrackersConnectionState(TrackerConnState.Connected);
    } else {
      this.updateTrackersConnectionState(TrackerConnState.Disconnected);
    }
  }
  updateTrackersConnectionState(trackerState) {
    this.objects.forEach(obj => {
      this.updateTrackerConnectionState(obj, trackerState);
    });
  }
  updateTrackerConnectionState(obj, trackerState) {
    var _this$tracker, _this$tracker2;
    const mapObject = (_this$tracker = this.tracker) === null || _this$tracker === void 0 ? void 0 : _this$tracker.getLayerGroupCache().get(obj.id);
    if (mapObject && mapObject.options.data) {
      mapObject.options.data.trackerState = trackerState;
    }
    (_this$tracker2 = this.tracker) === null || _this$tracker2 === void 0 ? void 0 : _this$tracker2.updateState(obj.id, trackerState);
  }
  onChangeVisible(visible) {
    if (!visible) {
      this.trackLayer.clearAndInvalidate();
      this.unsubscribe(this.getTrackerIds());
      this.clearObjects();
    }
  }
  onTrackEvent(message) {
    var _message$speed;
    const trackerId = message === null || message === void 0 ? void 0 : message.trackerId;
    const lat = message === null || message === void 0 ? void 0 : message.latitude;
    const lng = message === null || message === void 0 ? void 0 : message.longitude;
    const speed = (_message$speed = message === null || message === void 0 ? void 0 : message.speed) !== null && _message$speed !== void 0 ? _message$speed : 0;
    const objects = this.objectsByTrackers[trackerId];
    if (objects && objects.length > 0 && isDefined(lat) && isDefined(lng)) {
      for (let i = 0; i < objects.length; i++) {
        this.updateObjectPosition(objects[i], lat, lng, speed);
        this.updateObjectData(objects[i]);
      }
    }
  }
  updateObjectPosition(obj, lat, lng, speed) {
    if (!obj.geometry || !obj.isInitPos) {
      if (!obj.geometry) {
        obj.geometry = pointToGeoJSON([lat, lng]);
        this.trackLayer.addObject(obj);
      } else {
        this.tracker.setPosition(obj.id, [lat, lng]);
      }
      obj.isInitPos = true;
      return;
    }
    if (this.onceReinitPos) {
      this.onceReinitPos = false;
      this.tracker.stopMoving(obj.id).setPosition(obj.id, [lat, lng]);
      return;
    }
    this.tracker.updatePosition(obj.id, [lat, lng], speed);
  }
  updateObjectData(obj) {
    const mapObject = this.tracker.getLayerGroupCache().get(obj.id);
    const options = mapObject === null || mapObject === void 0 ? void 0 : mapObject.options;
    const data = options === null || options === void 0 ? void 0 : options.data;
    if (data && options) {
      var _options$lastSpeed, _options$positionLag;
      data.speed = (_options$lastSpeed = options.lastSpeed) !== null && _options$lastSpeed !== void 0 ? _options$lastSpeed : 0;
      data.positionLag = (_options$positionLag = options.positionLag) !== null && _options$positionLag !== void 0 ? _options$positionLag : 0;
    }
  }
  destroy() {
    var _this$sharedTrackerHu, _this$sharedTrackerHu2, _this$sharedTrackerHu3, _this$trackLayer;
    this.cancelFetchData();
    this.clearObjects();
    (_this$sharedTrackerHu = this.sharedTrackerHub) === null || _this$sharedTrackerHu === void 0 ? void 0 : _this$sharedTrackerHu.get().events.off("reconnected", this.onHubReconnected).off("connection-state", this.onHubConnectionStateChanged);
    (_this$sharedTrackerHu2 = this.sharedTrackerHub) === null || _this$sharedTrackerHu2 === void 0 ? void 0 : _this$sharedTrackerHu2.get().off(TrackerHubEvents.teledataCreated, this.onTrackEvent);
    (_this$sharedTrackerHu3 = this.sharedTrackerHub) === null || _this$sharedTrackerHu3 === void 0 ? void 0 : _this$sharedTrackerHu3.destroy();
    this.sharedTrackerHub = null;
    (_this$trackLayer = this.trackLayer) === null || _this$trackLayer === void 0 ? void 0 : _this$trackLayer.$off("update:visible", this.onChangeVisible);
    this.trackLayer = null;
    this.tracker = null;
  }
  cancelFetchData() {
    if (this.cancelSource) {
      this.cancelSource.cancel();
      this.cancelSource = null;
    }
  }
  async fetchData(layerId) {
    try {
      this.cancelFetchData();
      this.cancelSource = cancel_token["a" /* default */].source();
      const response = await visary_api["a" /* default */].listView.gridData(layerId, dataColumns, dataSkip, dataTake, this.filterQuery || undefined, this.cancelSource.token);
      this.objects = ((response === null || response === void 0 ? void 0 : response.Data) || []).filter(this.excludePredicate).map(this.toMapObject);
      this.objectsByTrackers = this.objects.reduce((res, item) => {
        if (!res[item.trackerId]) res[item.trackerId] = [];
        res[item.trackerId].push(item);
        return res;
      }, {});
      const teledata = await this.fetchLastTeledata(this.getTrackerIds());
      const initedObjects = this.initObjects(this.objectsByTrackers, teledata);
      return initedObjects;
    } catch (e) {
      if (cancel_token["a" /* default */].isCancel(e)) {
        throw Object(visary_map_vue_rgm_["makeCancel"])(e);
      }
      logger["a" /* default */].error(e);
      return [];
    }
  }
  async fetchLastTeledata(trackerIds) {
    try {
      const response = await gistracker_api["a" /* default */].teledata.mostRecent(trackerIds);
      return response || [];
    } catch (e) {
      logger["a" /* default */].error(e);
      return [];
    }
  }
  initObjects(objectsByTrackers, teledata) {
    const result = [];
    for (let i = 0; i < teledata.length; i++) {
      const teledataItem = teledata[i];
      const objects = objectsByTrackers[teledataItem.trackerId];
      if (objects && objects.length > 0) {
        result.push(...this.initGeometryFromTeledata(objects, teledataItem));
      }
    }
    return result;
  }
  initGeometryFromTeledata(objects, teledataItem) {
    const lat = teledataItem === null || teledataItem === void 0 ? void 0 : teledataItem.latitude;
    const lng = teledataItem === null || teledataItem === void 0 ? void 0 : teledataItem.longitude;
    if (!isDefined(lat) || !isDefined(lng)) return [];
    return objects.map(obj => {
      obj.geometry = pointToGeoJSON([lat, lng]);
      return obj;
    });
  }
  beforeFetch() {
    this.unsubscribe(this.getTrackerIds());
    this.clearObjects();
  }
  dataFetched() {
    if (this.objects.length > 0) {
      this.subscribe(this.getTrackerIds());
    }
  }
  getTrackerIds() {
    return this.objects.map(({
      trackerId
    }) => trackerId);
  }
  clearObjects() {
    this.objects = [];
    this.objectsByTrackers = {};
  }
  toMapObject({
    ID,
    Title,
    Description,
    TrackerID
  }) {
    return {
      id: ID,
      title: Title,
      description: Description,
      trackerId: TrackerID,
      geometry: null,
      speed: 0,
      positionLag: 0,
      trackerState: null,
      isInitPos: false
    };
  }
  setFilterQuery(query) {
    this.filterQuery = query;
  }
  excludePredicate({
    ID
  }) {
    return !this.excludeList || !this.excludeList[ID];
  }
  addExcludeId(id) {
    if (!this.excludeList) {
      this.excludeList = {};
    }
    this.excludeList[id] = true;
  }
  removeExcludeId(id) {
    delete this.excludeList[id];
    if (types_isEmpty(this.excludeList)) {
      this.excludeList = null;
    }
  }
}
/* harmony default export */ var tracker_data_source = (tracker_data_source_TrackerDataSource);
// CONCATENATED MODULE: ./src/components/map/utils/raw-data.js
const fieldMap = Object.freeze({
  geometry: {
    from: "Geometry",
    to: "geometry"
  },
  id: {
    from: "ID",
    to: "id"
  },
  title: {
    from: "Title",
    to: "title"
  },
  description: {
    from: "Description",
    to: "description"
  }
});
/* harmony default export */ var raw_data = ({
  fieldMap
});
// EXTERNAL MODULE: ./src/api/index.js + 17 modules
var api = __webpack_require__("365c");

// CONCATENATED MODULE: ./src/components/map/utils/search-mixin.js



const coordsFromGeometry = ({
  type,
  coordinates
}) => {
  if (type === "Point") {
    const latlng = [coordinates[1], coordinates[0]];
    return Object(visary_map_vue_rgm_["formatLatLng"])(latlng);
  }
  return null;
};
const pointArounds = Object.freeze({
  country: 2000000,
  // 2000 km
  region: 100000,
  // 100 km
  place: 100000,
  // 100 km
  district: 100000,
  // 100 km
  admin: 10000 // 10 km
});

/* harmony default export */ var search_mixin = ({
  methods: {
    async searchPlace(query, latlng, zoom) {
      this.cancelSearchRequest();
      this.$_searchCancelSource = cancel_token["a" /* default */].source();
      if (latlng) {
        const result = await api["c" /* mapApi */].search.reverseSearch(latlng, this.reverseSearchHouses, zoom, this.$_searchCancelSource.token);
        return this.toSearchResult(result);
      } else if (query) {
        const result = await api["c" /* mapApi */].search.searchQuery(query, this.searchLimit, this.$_searchCancelSource.token);
        return this.toSearchResult(result);
      } else {
        return [];
      }
    },
    cancelSearchRequest() {
      if (this.$_searchCancelSource) {
        this.$_searchCancelSource.cancel();
        this.$_searchCancelSource = null;
      }
    },
    toSearchResult(result) {
      if (!Array.isArray(result)) {
        return [];
      }
      return result.map(item => {
        var _ref;
        if (!item.geometry || !item.title) {
          return null;
        }
        const pointAround = (_ref = item.geometry.type === "Point" && item.type ? pointArounds[item.type] : undefined) !== null && _ref !== void 0 ? _ref : null;
        return {
          title: item.title,
          description: item.description,
          coords: coordsFromGeometry(item.geometry),
          geometry: item.geometry,
          pointAround
        };
      }).filter(item => !!item);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-view.vue?vue&type=script&lang=js&


const _excluded = ["layerItem", "done"],
  _excluded2 = ["layerItem", "batchDone"],
  _excluded3 = ["layerItem"],
  _excluded4 = ["layerItem"],
  _excluded5 = ["layerItem", "data"];

/* eslint-disable camelcase */


















/* harmony default export */ var vis_map_viewvue_type_script_lang_js_ = ({
  name: "vis-map-view",
  mixins: [search_mixin],
  components: {
    VMap: visary_map_vue_rgm_["VMap"],
    VMapSidebar: visary_map_vue_rgm_["VMapSidebar"],
    VMapLayerPanel: visary_map_vue_rgm_["VMapLayerPanel"],
    VMapMapboxTileLayer: visary_map_vue_rgm_["VMapMapboxTileLayer"],
    VMapOsmTileLayer: visary_map_vue_rgm_["VMapOsmTileLayer"],
    VMapLayersControl: visary_map_vue_rgm_["VMapLayersControl"],
    VisMapTreeLayer: vis_map_tree_layer["default"],
    VMapArcGisAeroTileLayer: visary_map_vue_rgm_["VMapArcGisAeroTileLayer"],
    VMapArcGisTileLayer: visary_map_vue_rgm_["VMapArcGisTileLayer"],
    VMapYandexTileLayer: visary_map_vue_rgm_["VMapYandexTileLayer"],
    VMapOcmTileLayer: visary_map_vue_rgm_["VMapOcmTileLayer"],
    VMapGoogleTileLayer: visary_map_vue_rgm_["VMapGoogleTileLayer"],
    VMapCadastreTileLayer: visary_map_vue_rgm_["VMapCadastreTileLayer"],
    VMapSputnikTileLayer: visary_map_vue_rgm_["VMapSputnikTileLayer"],
    VMapWmsTileLayer: visary_map_vue_rgm_["VMapWmsTileLayer"],
    VisMapListPanel: vis_map_list_panel,
    VMapRulerControl: visary_map_vue_rgm_["VMapRulerControl"],
    VMapHeatmapControl: visary_map_vue_rgm_["VMapHeatmapControl"],
    VMapFullscreenControl: visary_map_vue_rgm_["VMapFullscreenControl"],
    VMapLocationControl: visary_map_vue_rgm_["VMapLocationControl"],
    VMapZoomControl: visary_map_vue_rgm_["VMapZoomControl"],
    VMapPrintControl: visary_map_vue_rgm_["VMapPrintControl"],
    VMapRoutesControl: visary_map_vue_rgm_["VMapRoutesControl"],
    VMapSearchControl: visary_map_vue_rgm_["VMapSearchControl"],
    VMapScaleControl: visary_map_vue_rgm_["VMapScaleControl"],
    VMapFitHandler: visary_map_vue_rgm_["VMapFitHandler"]
  },
  props: {
    presetId: {
      type: Number,
      default: null
    },
    center: {
      type: [Array, Object],
      default: () => [58.686314, 97.745306]
    },
    zoom: {
      type: Number,
      default: 3
    },
    minZoom: {
      type: Number,
      default: 3
    },
    maxZoom: {
      type: Number,
      default: undefined
    },
    bounds: {
      type: [Array, Object],
      default: null
    },
    maxBounds: {
      type: [Array, Object],
      default: () => [[-90, -270], [90, 270]]
    },
    mapOptions: {
      type: Object,
      default: undefined
    },
    maxBoundsViscosity: {
      type: Number,
      default: 1
    },
    autoCenter: {
      type: Boolean,
      default: false
    },
    itemFitPointAround: {
      type: Number,
      default: 500
    },
    useFlyTo: {
      type: Boolean,
      default: false
    },
    tile: {
      type: String,
      default: "Open Street Map"
    },
    overlays: {
      type: Array,
      default: () => []
    },
    yandexTile: {
      type: Boolean,
      default: false
    },
    googleTile: {
      type: Boolean,
      default: false
    },
    cadastreTile: {
      type: Boolean,
      default: true
    },
    filtering: {
      type: Boolean,
      default: false
    },
    zoomControl: {
      type: Boolean,
      default: true
    },
    rulerControl: {
      type: Boolean,
      default: true
    },
    heatmapControl: {
      type: Boolean,
      default: true
    },
    fullscreenControl: {
      type: Boolean,
      default: true
    },
    fullscreenAllPage: {
      type: Boolean,
      default: false
    },
    printControl: {
      type: Boolean,
      default: true
    },
    saveAsImageControl: {
      type: Boolean,
      default: true
    },
    locateControl: {
      type: Boolean,
      default: true
    },
    routesControl: {
      type: Boolean,
      default: true
    },
    searchControl: {
      type: Boolean,
      default: true
    },
    scaleControl: {
      type: Boolean,
      default: true
    },
    sputnikLabel: {
      type: String,
      default: null
    },
    osmLabel: {
      type: String,
      default: "Open Street Map"
    },
    mapboxLabel: {
      type: String,
      default: null
    },
    arcGisAeroLabel: {
      type: String,
      default: "Arc Gis Aero"
    },
    arcGisLabel: {
      type: String,
      default: "Arc Gis"
    },
    ocmLabel: {
      type: String,
      default: "Open Transport"
    },
    yandexMapLabel: {
      type: String,
      default: "Карта Яндекс"
    },
    googleMapLabel: {
      type: String,
      default: "Карта Google"
    },
    yandexHybridLabel: {
      type: String,
      default: "Спутник Яндекс"
    },
    googleHybridLabel: {
      type: String,
      default: "Спутник Google"
    },
    cadastreLabel: {
      type: String,
      default: "Кадастровая карта"
    },
    editorFocus: {
      type: Boolean,
      default: false
    },
    editorAutoOpenPopup: {
      type: Boolean,
      default: true
    },
    editLayerId: {
      type: String,
      default: null
    },
    editDataSource: {
      type: Function,
      default: null
    },
    popupActions: {
      type: [Array, Function],
      default: null
    },
    addressLoading: {
      type: String,
      default: "Определяем адрес..."
    },
    noAuth: {
      type: Boolean,
      default: false
    },
    showPicketTargetTitle: {
      type: Boolean,
      default: true
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    searchLimit: {
      type: Number,
      default: 5
    },
    reverseSearchHouses: {
      type: Boolean,
      default: undefined
    },
    followTracker: {
      type: Boolean,
      default: true
    },
    serverLayerReloadTimeout: {
      type: Number,
      default: 4000
    },
    saveFileName: {
      type: String,
      default: undefined
    },
    printWithSidebar: {
      type: Boolean,
      default: false
    },
    clusterAnimation: {
      type: Boolean,
      default: true
    },
    useSuperCluster: {
      type: Boolean,
      default: false
    },
    useSuperClusterBuf: {
      type: Boolean,
      default: true
    },
    superClusterLog: {
      type: Boolean,
      default: false
    },
    superClusterWorkerFactory: {
      type: Function,
      default: null
    },
    loadingTimeout: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      currentTile: this.tile,
      loading: false,
      ready: false,
      loadingTimer: null,
      noPrintTiles: [this.yandexMapLabel, this.yandexHybridLabel, this.googleMapLabel, this.googleHybridLabel],
      mapZoom: this.zoom,
      mapCenter: this.center,
      wmsLayers: [],
      sidebarOpen: false,
      layerTree: [],
      listPanel: {
        open: false,
        title: null,
        count: 0,
        layerId: null,
        filterQuery: null,
        iconName: null,
        clusterId: null,
        dataSource: null
      }
    };
  },
  computed: {
    printControlVisible() {
      return this.noPrintTiles.indexOf(this.currentTile) === -1;
    },
    mergedMapOptions() {
      return Object(objectSpread2["a" /* default */])({
        maxBoundsViscosity: this.maxBoundsViscosity
      }, this.mapOptions);
    }
  },
  watch: {
    tile() {
      this.currentTile = this.tile;
    },
    zoom() {
      this.mapZoom = this.zoom;
    },
    center() {
      this.mapCenter = this.center;
    },
    presetId() {
      if (this.presetId) {
        this.resetListPanel();
        this.restartLoadingTimer();
        this.fetchData();
      }
    }
  },
  created() {
    if (this.autoCenter) {
      this.fetchSettings();
    }
    if (this.presetId) {
      this.restartLoadingTimer();
      this.fetchData();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ready = true;
    });
  },
  beforeDestroy() {
    this.stopLoadingTimer();
  },
  methods: {
    initSettings(settings) {
      const {
        DefaultZoom,
        DefaultCenterLatitude,
        DefaultCenterLongitude,
        WmsLayers
      } = settings;
      if (typeof DefaultZoom === "number") {
        this.mapZoom = DefaultZoom;
      }
      if (typeof DefaultCenterLatitude === "number" && typeof DefaultCenterLongitude === "number") {
        this.mapCenter = [DefaultCenterLatitude, DefaultCenterLongitude];
      }
      if (Array.isArray(WmsLayers)) {
        this.wmsLayers = WmsLayers.map(this.toWmsLayer);
      }
    },
    toWmsLayer(data) {
      var _data$Parameters$Laye, _data$Parameters, _data$Parameters$Styl, _data$Parameters2, _data$Parameters3, _data$Parameters$Form, _data$Parameters4, _data$Parameters$Vers, _data$Parameters5, _data$Parameters6, _data$Parameters$Crs, _data$Parameters7;
      return {
        id: data.ID,
        title: data.Title,
        url: data.Url,
        layerType: data.Overlay ? "overlay" : undefined,
        layers: (_data$Parameters$Laye = (_data$Parameters = data.Parameters) === null || _data$Parameters === void 0 ? void 0 : _data$Parameters.Layers) !== null && _data$Parameters$Laye !== void 0 ? _data$Parameters$Laye : undefined,
        styles: (_data$Parameters$Styl = (_data$Parameters2 = data.Parameters) === null || _data$Parameters2 === void 0 ? void 0 : _data$Parameters2.Styles) !== null && _data$Parameters$Styl !== void 0 ? _data$Parameters$Styl : undefined,
        transparent: !!((_data$Parameters3 = data.Parameters) !== null && _data$Parameters3 !== void 0 && _data$Parameters3.Transparent),
        format: (_data$Parameters$Form = (_data$Parameters4 = data.Parameters) === null || _data$Parameters4 === void 0 ? void 0 : _data$Parameters4.Format) !== null && _data$Parameters$Form !== void 0 ? _data$Parameters$Form : undefined,
        version: (_data$Parameters$Vers = (_data$Parameters5 = data.Parameters) === null || _data$Parameters5 === void 0 ? void 0 : _data$Parameters5.Version) !== null && _data$Parameters$Vers !== void 0 ? _data$Parameters$Vers : undefined,
        uppercase: !!((_data$Parameters6 = data.Parameters) !== null && _data$Parameters6 !== void 0 && _data$Parameters6.Uppercase),
        crs: (_data$Parameters$Crs = (_data$Parameters7 = data.Parameters) === null || _data$Parameters7 === void 0 ? void 0 : _data$Parameters7.Crs) !== null && _data$Parameters$Crs !== void 0 ? _data$Parameters$Crs : undefined
      };
    },
    restartLoadingTimer() {
      this.stopLoadingTimer();
      this.startLoadingTimer();
    },
    startLoadingTimer() {
      this.loading = true;
      this.loadingTimer = setTimeout(() => {
        this.loading = false;
      }, this.loadingTimeout);
    },
    stopLoadingTimer() {
      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer);
        this.loadingTimer = null;
      }
    },
    getMapContainer() {
      var _this$$refs$map;
      return (_this$$refs$map = this.$refs.map) === null || _this$$refs$map === void 0 ? void 0 : _this$$refs$map.getMap().getContainer();
    },
    async fetchSettings() {
      try {
        const settings = await visary_api["a" /* default */].map.getSettings(null, this.noAuth);
        this.initSettings(settings);
      } catch (e) {
        logger["a" /* default */].error(e);
      }
    },
    async fetchData() {
      try {
        const presetConfig = await this.fetchPreset(this.presetId);
        if (presetConfig.length > 0) {
          this.layerTree = presetConfig;
          this.sidebarOpen = true;
          this.fetchAdditionalConfig(this.layerTree);
        }
      } catch (e) {
        logger["a" /* default */].error(e);
      }
    },
    async fetchPreset(presetId) {
      try {
        return (await visary_api["a" /* default */].map.getPreset(presetId, null, this.noAuth)).map(this.toPresetConfig);
      } catch (e) {
        logger["a" /* default */].error(e);
        return [];
      }
    },
    async fetchLayerConfig(mnemonic) {
      try {
        const {
          Layer: config,
          Type: type
        } = await visary_api["a" /* default */].map.getLayerConfig(mnemonic, null, this.noAuth);
        if (type === "servermaplayerconfig") {
          return this.toServerLayerConfig(config);
        } else if (type === "clientmaplayerconfig") {
          return this.toClientLayerConfig(config);
        } else if (type === "trackermaplayerconfig") {
          return this.toTrackerLayerConfig(config);
        } else {
          return null;
        }
      } catch (e) {
        logger["a" /* default */].error(e);
        return null;
      }
    },
    async fetchAdditionalConfig(layerTree) {
      for (let i = 0; i < layerTree.length; i++) {
        const layerConfig = layerTree[i];
        if (layerConfig.type === layer_type_enum["a" /* default */].GROUP) {
          const {
            children
          } = layerConfig;
          if (children.length > 0) {
            await this.fetchAdditionalConfig(children);
          }
        } else if (layerConfig.type === layer_type_enum["a" /* default */].NONE) {
          const {
            mnemonic
          } = layerConfig;
          const result = await this.fetchLayerConfig(mnemonic);
          if (result) {
            Object.assign(layerConfig, result);
            this.initPopupActions(layerConfig);
          } else {
            layerConfig.disabled = true;
          }
        }
      }
    },
    async fetchRoutes(startLatLng, stopLatLng, zoom) {
      try {
        const response = await osm_api["a" /* default */].routes.findRoutes([startLatLng.lat, startLatLng.lng], [stopLatLng.lat, stopLatLng.lng]);
        return this.processRoutesResponse(response);
      } catch (e) {
        logger["a" /* default */].error(e);
        return [];
      }
    },
    processRoutesResponse(response) {
      if (!Array.isArray(response)) {
        return [];
      }
      const toLatlngs = geometry => {
        if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "LineString" && geometry.coordinates) {
          return external_leaflet_["GeoJSON"].coordsToLatLngs(geometry.coordinates, 0);
        }
        return [];
      };
      return response.map((data, index) => ({
        totalDistance: data.totalDistance,
        totalTime: data.totalTime,
        startPoint: data.startName,
        endPoint: data.endName,
        latlngs: toLatlngs(data.geometry),
        alt: index > 0
      }));
    },
    toPresetConfig(itemData) {
      if (itemData.Layers !== undefined && itemData.Styles !== undefined && itemData.Url !== undefined) {
        return this.toTileConfig(itemData);
      } else if (itemData.Children) {
        return this.toGroupConfig(itemData);
      } else {
        return this.toLayerConfig(itemData);
      }
    },
    toGroupConfig({
      ID,
      Title,
      Icon,
      Children,
      IsExpanded
    }) {
      return {
        id: ID,
        title: Title,
        iconName: Icon ? Icon.Value : null,
        expanded: IsExpanded !== null && IsExpanded !== void 0 ? IsExpanded : true,
        disabled: false,
        type: layer_type_enum["a" /* default */].GROUP,
        children: (Children || []).map(this.toPresetConfig),
        styles: {
          iconColor: Icon ? Icon.Color : null
        }
      };
    },
    toLayerConfig(data) {
      var _toFloat, _toFloat2, _toFloat3, _toFloat4, _toFloat5, _fromJson;
      const {
        Title,
        TitleVisible,
        Mnemonic,
        Icon,
        Editable,
        AllowShapes,
        EnableHeatmap,
        EnableHeatmapControl,
        EnablePicket,
        ShowLineEdges,
        ShowIcon,
        Opacity,
        Background,
        BackgroundStyle,
        BorderColor,
        BorderOpacity,
        BorderWidth,
        BorderNone,
        StripeAngle,
        StripeColor,
        StripeDistance,
        StripeWidth,
        IsVisible,
        HeatMapMinOpacity,
        HeatMapMaxZoom,
        HeatMapMax,
        HeatMapRadius,
        HeatMapBlur,
        HeatMapGradient
      } = data;
      const selected = !this.editLayerId ? false : this.editLayerId === Mnemonic;
      const selection = !this.editLayerId;
      const editEnabled = !this.editLayerId && !!Editable || this.editLayerId === Mnemonic;
      const editDataSource = this.editDataSource ? () => this.editDataSource(Mnemonic) : null;
      let picketDataSourceFn = null;
      if (EnablePicket) {
        const picketDataSource = new picket_data_source(Mnemonic, this.noAuth);
        picketDataSourceFn = id => picketDataSource.fetchData(id);
      }
      const pathStyles = {
        color: Icon ? Icon.Color : null,
        backgroundColor: Background ? Background.Value : null,
        backgroundOpacity: Opacity,
        backgroundStyle: BackgroundStyle,
        borderColor: BorderColor ? BorderColor.Value : null,
        borderWidth: BorderWidth,
        borderOpacity: BorderOpacity,
        borderNone: !!BorderNone,
        stripeColor: StripeColor ? StripeColor.Value : null,
        stripeAngle: StripeAngle,
        stripeDistance: StripeDistance,
        stripeWidth: StripeWidth
      };
      return {
        id: Mnemonic,
        title: Title,
        mnemonic: Mnemonic,
        iconName: Icon ? Icon.Value : null,
        count: 0,
        visible: IsVisible !== null && IsVisible !== void 0 ? IsVisible : true,
        tooltipVisible: !!TitleVisible,
        disabled: false,
        selected,
        selection,
        type: layer_type_enum["a" /* default */].NONE,
        clustering: false,
        clientClustering: false,
        filtering: this.filtering,
        filterActive: false,
        picketEnabled: !!EnablePicket,
        picketDataSource: picketDataSourceFn,
        picketTargetTitleShown: this.showPicketTargetTitle,
        dataSource: null,
        dataSourceInstance: null,
        invalidate: true,
        countInvalidate: true,
        editEnabled,
        editDataSource,
        creationShapes: AllowShapes || undefined,
        canCreate: this.canCreate,
        canEdit: this.canEdit,
        centerMarker: !!ShowIcon,
        styles: Object(objectSpread2["a" /* default */])({
          iconColor: Icon === null || Icon === void 0 ? void 0 : Icon.Color
        }, pathStyles),
        heatmapActive: !!EnableHeatmap,
        heatmapControlEnabled: !!EnableHeatmapControl,
        heatmapMinOpacity: (_toFloat = to_float(HeatMapMinOpacity)) !== null && _toFloat !== void 0 ? _toFloat : undefined,
        heatmapMaxZoom: (_toFloat2 = to_float(HeatMapMaxZoom)) !== null && _toFloat2 !== void 0 ? _toFloat2 : undefined,
        heatmapMaxIntensity: (_toFloat3 = to_float(HeatMapMax)) !== null && _toFloat3 !== void 0 ? _toFloat3 : undefined,
        heatmapRadius: (_toFloat4 = to_float(HeatMapRadius)) !== null && _toFloat4 !== void 0 ? _toFloat4 : undefined,
        heatmapBlur: (_toFloat5 = to_float(HeatMapBlur)) !== null && _toFloat5 !== void 0 ? _toFloat5 : undefined,
        heatmapGradient: (_fromJson = from_json(HeatMapGradient)) !== null && _fromJson !== void 0 ? _fromJson : undefined,
        tileOptions: {},
        popupActions: [],
        showLineEdges: !!ShowLineEdges
      };
    },
    toTileConfig({
      ID,
      Icon,
      IsVisible,
      Layers,
      Styles,
      Url,
      Title
    }) {
      return {
        id: ID,
        title: Title,
        iconName: Icon ? Icon.Value : null,
        count: 0,
        visible: IsVisible !== null && IsVisible !== void 0 ? IsVisible : true,
        disabled: false,
        selected: false,
        selection: !this.editLayerId,
        type: layer_type_enum["a" /* default */].TILE,
        styles: {
          iconColor: Icon === null || Icon === void 0 ? void 0 : Icon.Color
        },
        tileOptions: {
          url: Url,
          layers: Layers,
          styles: Styles,
          transparent: true,
          format: "image/png"
        }
      };
    },
    toServerLayerConfig({
      ClientClusteringEnabled
    }) {
      const dataSource = new server_data_source(this.noAuth);
      return {
        type: layer_type_enum["a" /* default */].SERVER,
        clientClustering: ClientClusteringEnabled,
        dataSourceInstance: dataSource,
        dataSource
      };
    },
    toClientLayerConfig({
      ClusteringEnabled
    }) {
      const dataSource = new client_data_source(this.noAuth);
      dataSource.useArrayBufferResponse(ClusteringEnabled && this.useSuperCluster && this.useSuperClusterBuf);
      return {
        type: layer_type_enum["a" /* default */].CLIENT,
        clustering: ClusteringEnabled,
        clusterAnimation: this.clusterAnimation,
        useSuperCluster: this.useSuperCluster,
        superClusterOptions: {
          indexOptions: {
            log: this.superClusterLog,
            fieldMap: raw_data.fieldMap,
            workerFactory: this.superClusterWorkerFactory
          }
        },
        dataSourceInstance: dataSource,
        dataSource: layerId => dataSource.fetchData(layerId)
      };
    },
    toTrackerLayerConfig(config) {
      const dataSource = new tracker_data_source(this.noAuth);
      return {
        type: layer_type_enum["a" /* default */].TRACKER,
        followTracker: this.followTracker,
        dataSourceInstance: dataSource,
        dataSource
      };
    },
    async initPopupActions(layerItem) {
      if (Array.isArray(this.popupActions)) {
        layerItem.popupActions = this.popupActions;
      } else if (typeof this.popupActions === "function") {
        try {
          layerItem.popupActions = await this.popupActions(layerItem);
        } catch (e) {
          logger["a" /* default */].error(e);
        }
      }
    },
    onFilter(layerItem) {
      const done = filterQuery => {
        layerItem.dataSourceInstance.setFilterQuery(filterQuery);
        layerItem.invalidate = true;
        layerItem.countInvalidate = true;
        layerItem.filterActive = !!filterQuery;
        if (this.listPanel.layerId === layerItem.id && this.listPanel.open) {
          this.listPanel.filterQuery = filterQuery;
        }
      };
      this.$emit("filter", {
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done
      });
    },
    onCountPressed(layerItem, layerGroup) {
      layerItem.visible = true;
      let dataSource = null;
      if (layerItem.type === layer_type_enum["a" /* default */].TRACKER && layerGroup) {
        const data = layerGroup.getLayers().map(layer => {
          const data = layer.options.data;
          return {
            ID: data === null || data === void 0 ? void 0 : data.id,
            Title: data === null || data === void 0 ? void 0 : data.title,
            GetGeometry() {
              return pointToGeoJSON(layer.getLatLng());
            }
          };
        });
        if (data.length) {
          dataSource = this.createLocalListDataSource(data);
        }
      }
      this.openListPanel(layerItem, layerItem.count, null, dataSource);
    },
    onCountChanged({
      layerItem,
      value
    }) {
      if (this.listPanel.layerId === layerItem.id && this.listPanel.open && !this.listPanel.clusterId) {
        this.listPanel.count = layerItem.count;
      }
    },
    onClusterCountPressed(e) {
      const {
        layerItem,
        count,
        propagatedFrom: {
          options: {
            data
          }
        }
      } = e;
      e.preventClick();
      if (data && data.id) {
        this.openListPanel(layerItem, count, data.id);
      }
    },
    async onClientClusterCountPressed(e) {
      const {
        layerItem,
        count,
        cluster
      } = e;
      e.preventClick();
      const toListItem = itemData => ({
        ID: itemData.id,
        Title: itemData.title,
        Geometry: itemData.geometry
      });
      let listData = [];
      if (typeof cluster.getMarkers === "function") {
        listData = cluster.getMarkers().map(({
          options: {
            data
          }
        }) => toListItem(data));
      } else if (typeof cluster.getMarkersDataAsync === "function") {
        listData = (await cluster.getMarkersDataAsync()).map(data => toListItem(data));
      }
      if (listData.length > 0) {
        this.openListPanel(layerItem, count, null, this.createLocalListDataSource(listData));
      }
    },
    createLocalListDataSource(data) {
      return (page, pageSize, searchString) => {
        return new Promise(resolve => {
          const startIndex = (page - 1) * pageSize;
          const endIndex = startIndex + pageSize;
          if (searchString) {
            const lowerSearchString = searchString.toLowerCase();
            const predicate = ({
              Title
            }) => (Title || "").toLowerCase().includes(lowerSearchString);
            resolve(data.filter(predicate).slice(startIndex, endIndex));
          } else {
            resolve(data.slice(startIndex, endIndex));
          }
        });
      };
    },
    openListPanel(layerItem, count, clusterId = null, dataSource = null) {
      const {
        title,
        id,
        iconName,
        dataSourceInstance
      } = layerItem;
      this.listPanel.open = true;
      this.listPanel.title = title;
      this.listPanel.count = count;
      this.listPanel.layerId = id;
      this.listPanel.filterQuery = dataSourceInstance.filterQuery;
      this.listPanel.iconName = iconName;
      this.listPanel.clusterId = clusterId;
      this.listPanel.dataSource = dataSource;
    },
    resetListPanel() {
      this.listPanel.open = false;
      this.listPanel.title = null;
      this.listPanel.count = 0;
      this.listPanel.layerId = null;
      this.listPanel.filterQuery = null;
      this.listPanel.iconName = null;
      this.listPanel.clusterId = null;
      this.listPanel.dataSource = null;
    },
    onItemClick({
      geometry
    }) {
      this.$refs.fit.fitGeometry(geometry);
    },
    onPopupDetails(e) {
      const {
        layerItem,
        popup
      } = e;
      const done = () => {
        layerItem.invalidate = true;
        layerItem.countInvalidate = true;
      };
      this.$emit("popup:details", {
        popup,
        data: Object(objectSpread2["a" /* default */])({}, e.data),
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done
      });
    },
    onPopupAction(e) {
      const {
        layerItem,
        popup
      } = e;
      const done = () => {
        layerItem.invalidate = true;
        layerItem.countInvalidate = true;
      };
      this.$emit("popup:action", {
        popup,
        action: Object(objectSpread2["a" /* default */])({}, e.action),
        data: Object(objectSpread2["a" /* default */])({}, e.data),
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done
      });
    },
    onPopupEdit(e) {
      var _e$popup;
      (_e$popup = e.popup) === null || _e$popup === void 0 ? void 0 : _e$popup.remove();
      const map = this.$refs.map.getMap();
      map.fire("vmap:edit:object", {
        layerId: e.layerItem.id,
        objectId: e.data.id
      });
    },
    onPopupDelete(e) {
      var _e$popup2;
      (_e$popup2 = e.popup) === null || _e$popup2 === void 0 ? void 0 : _e$popup2.remove();
      const map = this.$refs.map.getMap();
      map.fire("vmap:delete:object", {
        layerId: e.layerItem.id,
        objectId: e.data.id
      });
    },
    async onObjectDelete(e) {
      const {
        layerItem,
        data,
        remove,
        done,
        cancel
      } = e;
      try {
        remove();
        await this.deleteObject(layerItem.id, data.id);
        done();
        if (layerItem.count > 0) {
          layerItem.count--;
        }
      } catch (e) {
        cancel();
      }
    },
    async onObjectEdited(e) {
      const {
        layerItem,
        data,
        done,
        cancel
      } = e;
      try {
        await this.updateGeometry(layerItem.id, data.id, data.geometry);
        done();
      } catch (e) {
        cancel();
      }
    },
    onObjectEditStart(e) {
      const {
        layerItem,
        data
      } = e;
      layerItem.dataSourceInstance.addExcludeId(data.id);
    },
    onObjectEditEnd(e) {
      const {
        layerItem,
        data
      } = e;
      layerItem.dataSourceInstance.removeExcludeId(data.id);
    },
    async updateGeometry(layerId, objectId, geometry) {
      try {
        await visary_api["a" /* default */].map.updateGeometry(layerId, objectId, geometry);
      } catch (e) {
        logger["a" /* default */].error(e);
        throw e;
      }
    },
    async deleteObject(layerId, objectId) {
      try {
        await visary_api["a" /* default */].map.deleteObject(layerId, objectId);
      } catch (e) {
        logger["a" /* default */].error(e);
        throw e;
      }
    },
    onEditorCreate(e) {
      const {
          layerItem,
          done: _done
        } = e,
        event = _objectWithoutProperties(e, _excluded);
      const done = () => {
        _done();
        layerItem.invalidate = true;
        layerItem.countInvalidate = true;
      };
      const cancel = () => {
        _done();
      };
      const layer = e.layer;
      const editLayerGroup = e.editLayerGroup;
      const geometry = e.geometry;
      const data = {
        geometry
      };
      layer.options.data = data;
      this.tryFocusEditObject(geometry);
      const fetchAddress = () => {
        return this.fetchAddressForGeometry(data, geometry);
      };
      this.$nextTick(() => {
        if (this.editorAutoOpenPopup) {
          this.openPopupOn(editLayerGroup, layer);
        }
      });
      this.$emit("editor:create", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, event), {}, {
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done,
        cancel,
        fetchAddress
      }));
    },
    onEditorEdit(e) {
      const {
          layerItem,
          batchDone: _done
        } = e,
        event = _objectWithoutProperties(e, _excluded2);
      if (!e.layers[0]) return;
      const done = () => {
        _done();
        layerItem.invalidate = true;
        layerItem.countInvalidate = true;
      };
      const cancel = () => {
        _done();
      };
      const layer = e.layers[0].layer;
      const editLayerGroup = e.editLayerGroup;
      const geometry = e.layers[0].geometry;
      const data = layer.options.data || {};
      data.geometry = geometry;
      layer.options.data = data;
      this.$set(data, "address", null);
      this.tryFocusEditObject(geometry);
      const fetchAddress = () => {
        return this.fetchAddressForGeometry(data, geometry);
      };
      this.$nextTick(() => {
        if (this.editorAutoOpenPopup) {
          this.openPopupOn(editLayerGroup, layer);
        }
      });
      this.$emit("editor:edit", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, event), {}, {
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done,
        cancel,
        fetchAddress
      }));
    },
    onEditorDelete(e) {
      const {
          layerItem
        } = e,
        event = _objectWithoutProperties(e, _excluded3);
      const done = () => {
        layerItem.invalidate = true;
      };
      this.$emit("editor:delete", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, event), {}, {
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        done
      }));
    },
    onEditorData(e) {
      const {
          layerItem
        } = e,
        event = _objectWithoutProperties(e, _excluded4);
      if (this.editorFocus) {
        this.focusMapObjects(e.mapObjects);
      }
      if (e.data[0]) {
        layerItem.dataSourceInstance.addExcludeId(e.data[0].id);
      }
      if (e.mapObjects[0] && this.editorAutoOpenPopup) {
        this.openPopupOn(e.editLayerGroup, e.mapObjects[0]);
      }
      this.$emit("editor:data", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, event), {}, {
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem)
      }));
    },
    onEditorPopupEdit(e) {
      const {
          layerItem,
          data
        } = e,
        event = _objectWithoutProperties(e, _excluded5);
      const fetchAddress = () => this.fetchAddressForGeometry(data, data.geometry);
      this.$emit("editor:popupedit", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, event), {}, {
        data: Object(objectSpread2["a" /* default */])({}, data),
        layerId: layerItem.id,
        layerData: Object(objectSpread2["a" /* default */])({}, layerItem),
        fetchAddress
      }));
    },
    onTrackerFollow(e) {
      const {
        enabled
      } = e;
      this.getAllServerLayers().forEach(serverLayer => {
        serverLayer.dataSourceInstance.setPendingFetchTimeout(enabled ? this.serverLayerReloadTimeout : null);
      });
    },
    getAllServerLayers() {
      return this.getServerLayerRecursive(this.layerTree);
    },
    getServerLayerRecursive(layerTree, result = []) {
      for (let i = 0; i < layerTree.length; i++) {
        const layerConfig = layerTree[i];
        if (layerConfig.type === layer_type_enum["a" /* default */].GROUP) {
          if (layerConfig.children.length > 0) {
            this.getServerLayerRecursive(layerConfig.children, result);
          }
        } else if (layerConfig.type === layer_type_enum["a" /* default */].SERVER) {
          result.push(layerConfig);
        }
      }
      return result;
    },
    async fetchAddressForGeometry(data, geometry) {
      const center = this.getCenterForGeometry(geometry);
      if (!center) return null;
      this.$set(data, "address", this.addressLoading);
      const result = await this.fetchAddress(center.lat, center.lng);
      if (result && result.display_name) {
        this.$set(data, "address", result.display_name);
        return result.display_name;
      } else {
        this.$set(data, "address", null);
        return null;
      }
    },
    async fetchAddress(lat, lon) {
      try {
        return await osm_api["a" /* default */].search.reverseSearch(lat, lon);
      } catch (e) {
        logger["a" /* default */].error(e);
        return null;
      }
    },
    getCenterForGeometry(geometry) {
      try {
        const layer = external_leaflet_["GeoJSON"].geometryToLayer(geometry);
        return this.getMapObjectCenter(layer);
      } catch (e) {
        logger["a" /* default */].error(e);
        return null;
      }
    },
    getMapObjectCenter(layer) {
      const map = this.$refs.map.getMap();
      if (typeof layer.getLatLng === "function") {
        return layer.getLatLng().clone();
      } else {
        layer.setStyle({
          opacity: 0,
          fillOpacity: 0
        }).addTo(map);
        const center = visary_map_vue_rgm_["leafletUtil"].getPathCenter(map, layer);
        layer.remove();
        if (center) {
          return Object(external_leaflet_["latLng"])(center);
        }
      }
      return null;
    },
    openPopupOn(layerGroup, layer) {
      if (typeof layer.getLatLng === "function") {
        layerGroup.openPopup(layer);
      } else {
        try {
          const map = this.$refs.map.getMap();
          const center = visary_map_vue_rgm_["leafletUtil"].getPathCenter(map, layer);
          if (center) {
            layerGroup.openPopup(layer, center);
          }
        } catch (e) {
          logger["a" /* default */].error(e);
        }
      }
    },
    tryFocusEditObject(geometry) {
      if (this.editorFocus) {
        this.$refs.fit.fitGeometry(geometry);
      }
    },
    focusMapObjects(mapObjects) {
      if (!mapObjects.length) return;
      const bounds = Object(external_leaflet_["latLngBounds"])();
      mapObjects.forEach(mapObject => {
        if (typeof mapObject.getLatLng === "function") {
          bounds.extend(mapObject.getLatLng());
        } else if (typeof mapObject.getBounds === "function") {
          bounds.extend(mapObject.getBounds());
        }
      });
      this.$refs.fit.fitBounds(bounds);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/vis-map-view.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_vis_map_viewvue_type_script_lang_js_ = (vis_map_viewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/vis-map-view.vue





/* normalize component */

var vis_map_view_component = Object(componentNormalizer["a" /* default */])(
  map_vis_map_viewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_map_view = (vis_map_view_component.exports);
// CONCATENATED MODULE: ./src/components/map/index.js


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/vis-file-storage.vue?vue&type=template&id=79755521&
var vis_file_storagevue_type_template_id_79755521_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('dx-file-manager', {
    ref: "fileManager",
    staticClass: "vis-file-storage",
    attrs: {
      "file-system-provider": _vm.fileSystemProvider,
      "root-folder-name": _vm.rootFolderName,
      "current-path-keys": _vm.currentPathKeys,
      "customize-detail-columns": _vm.customizeDetailColumns,
      "height": "100%"
    },
    on: {
      "current-directory-changed": _vm.onCurrentDirectoryChanged,
      "context-menu-item-click": _vm.onCommandExec,
      "option-changed": _vm.onOptionChanged,
      "selected-file-opened": _vm.onSelectedFileOpened
    }
  }, [_c('dx-item-view', {
    attrs: {
      "mode": _vm.viewMode
    }
  }), _c('dx-permissions', {
    attrs: {
      "create": true,
      "delete": true,
      "rename": true,
      "upload": true,
      "copy": true,
      "move": true,
      "download": true
    }
  }), _c('dx-toolbar', [_c('dx-item', {
    attrs: {
      "name": "showNavPane",
      "visible": true
    }
  }), _c('dx-item', {
    attrs: {
      "name": "separator"
    }
  }), _vm._l(_vm.toolbarCommands, function (command) {
    return [command.isBeginGroup ? _c('dx-item', {
      key: _vm.getSepKey(command),
      attrs: {
        "name": "separator"
      }
    }) : _vm._e(), _c('dx-item', {
      key: command.key,
      attrs: {
        "visible": _vm.toolbarActions[command.name],
        "name": command.name,
        "widget": command.widget,
        "options": command.options
      }
    })];
  }), _c('dx-item', {
    attrs: {
      "name": "separator",
      "location": "after"
    }
  }), _c('dx-item', {
    attrs: {
      "name": "switchView"
    }
  }), _vm._l(_vm.toolbarSelCommands, function (command) {
    return [command.isBeginGroup ? _c('dx-file-selection-item', {
      key: _vm.getSepKey(command),
      attrs: {
        "name": "separator"
      }
    }) : _vm._e(), _c('dx-file-selection-item', {
      key: command.key,
      attrs: {
        "name": command.name,
        "widget": command.widget,
        "options": command.options
      }
    })];
  }), _c('dx-file-selection-item', {
    attrs: {
      "name": "separator"
    }
  }), _c('dx-file-selection-item', {
    attrs: {
      "name": "clearSelection"
    }
  })], 2), _c('dx-context-menu', _vm._l(_vm.ctxCommands, function (command) {
    return _c('dx-item', {
      key: command.key,
      attrs: {
        "name": command.name,
        "text": command.options ? command.options.text : null,
        "icon": command.options ? command.options.icon : null,
        "begin-group": command.isBeginGroup
      }
    });
  }), 1), _c('dx-upload', {
    attrs: {
      "chunk-size": _vm.maxFileSize,
      "max-file-size": _vm.maxFileSize
    }
  }), _vm.visibleCreateDriveDialog ? _c('vis-create-drive-dialog', {
    on: {
      "save": _vm.onCreateDrive,
      "cancel": function ($event) {
        _vm.visibleCreateDriveDialog = false;
      }
    }
  }) : _vm._e(), _vm.editablePermissionsDrive ? _c('vis-drive-permissions-dialog', {
    attrs: {
      "data-item": _vm.editablePermissionsDrive
    },
    on: {
      "save": _vm.onEditPermissionsDrive,
      "cancel": function ($event) {
        _vm.editablePermissionsDrive = null;
      }
    }
  }) : _vm._e()], 1);
};
var vis_file_storagevue_type_template_id_79755521_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/vis-file-storage.vue?vue&type=template&id=79755521&

// EXTERNAL MODULE: external "devextreme-vue/file-manager"
var file_manager_ = __webpack_require__("fee0");

// EXTERNAL MODULE: external "devextreme/file_management/custom_provider"
var custom_provider_ = __webpack_require__("3b7e");
var custom_provider_default = /*#__PURE__*/__webpack_require__.n(custom_provider_);

// CONCATENATED MODULE: ./src/components/file-storage/enum/file-group.js
/* harmony default export */ var file_group = (Object.freeze({
  MYDRIVE: "mydrive",
  SHARED: "shared",
  RECYCLEBIN: "recyclebin"
}));
// EXTERNAL MODULE: external "devextreme/localization"
var localization_ = __webpack_require__("2cb3");

// CONCATENATED MODULE: ./src/components/file-storage/get-list-groups.js


/* harmony default export */ var get_list_groups = (() => [{
  key: file_group.MYDRIVE,
  name: Object(localization_["formatMessage"])("dxFileManager-groupMyDrives"),
  hasSubDirectories: true,
  isDirectory: true,
  isGroup: true,
  isOwned: true
}, {
  key: file_group.SHARED,
  name: Object(localization_["formatMessage"])("dxFileManager-groupShared"),
  hasSubDirectories: true,
  isDirectory: true,
  isGroup: true,
  isOwned: false
}, {
  key: file_group.RECYCLEBIN,
  name: Object(localization_["formatMessage"])("dxFileManager-groupRecycleBin"),
  hasSubDirectories: false,
  isDirectory: true,
  isGroup: true
}]);
// CONCATENATED MODULE: ./src/components/file-storage/utils/get-drive-id.js
/* harmony default export */ var get_drive_id = (item => {
  const {
    isDrive,
    id,
    driveId
  } = item;
  return isDrive ? id : driveId;
});
// CONCATENATED MODULE: ./src/components/file-storage/enum/item-type.js
/* harmony default export */ var item_type = (Object.freeze({
  DIRECTORY: 'Directory',
  FILE: 'File'
}));
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/get-items.js









const MAX_COUNT_ITEMS = 999;
const cachedUsers = [];
const getUsernameById = async userId => {
  let user = cachedUsers.find(item => item.id === userId);
  if (!user) {
    user = {
      id: userId
    };
    try {
      user.name = (await api["e" /* profileApi */].user.getUserById(userId)).nickName;
    } catch (err) {
      user.name = Object(localization_["formatMessage"])("dxFileManager-ownerUnknown");
    }
    cachedUsers.push(user);
  }
  return user.name;
};
const fetchItems = async (params, permission) => (await api["a" /* filestorageApi */].items.getItems(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, params), {}, {
  take: MAX_COUNT_ITEMS
}))).Items.map(item => ({
  id: item.Id,
  driveId: item.DriveId,
  version: item.Version,
  name: item.Name,
  size: item.Size,
  ownerId: item.CreateBy,
  isDirectory: item.Type === item_type.DIRECTORY,
  hasSubDirectories: item.HasSubDir,
  dateModified: item.ModifyDate,
  extension: item.Extension,
  thumbnail: null,
  permission
}));
const fetchDeletedItems = async params => (await api["a" /* filestorageApi */].items.getDeletedItems(params)).Items.map(item => ({
  id: item.Id,
  driveId: item.DriveId,
  name: item.OriginalName,
  size: item.Size,
  isDirectory: false,
  isDeletedDirectory: item.Type === item_type.DIRECTORY,
  dateModified: item.DeletedDate,
  thumbnail: null
}));
const fetchDrives = async isOwned => (await api["a" /* filestorageApi */].drives.getDrives({
  isOwned
})).Items.map(item => ({
  id: item.DriveId,
  key: item.DriveId,
  name: item.Title,
  ownerId: item.Owner,
  hasSubDirectories: item.HasSubDir,
  isCrypted: item.IsCrypted,
  isDirectory: true,
  isOwned: item.IsOwned,
  isDrive: true,
  thumbnail: null,
  permission: item.Permission
}));
const getItems = async pathInfo => {
  try {
    let items = [];
    const {
      dataItem
    } = pathInfo;
    if (!dataItem) {
      items = get_list_groups();
    } else if (dataItem.isGroup && dataItem.key === file_group.RECYCLEBIN) {
      items = await fetchDeletedItems();
    } else if (dataItem.isGroup) {
      items = await fetchDrives(dataItem.isOwned);
    } else if (dataItem.isDrive) {
      items = await fetchItems({
        driveId: get_drive_id(dataItem)
      }, dataItem.permission);
    } else {
      const params = {
        driveId: get_drive_id(dataItem),
        directoryId: dataItem.id
      };
      items = await fetchItems(params);
    }
    for (const item of items) {
      if (item.ownerId) {
        item.ownerName = await getUsernameById(item.ownerId);
      }
    }
    return items;
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var get_items = (getItems);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/download-items.js



const downloadItems = async items => {
  for (const item of items) {
    try {
      const {
        dataItem
      } = item;
      const params = {
        driveId: get_drive_id(dataItem)
      };
      if (dataItem) params.itemId = dataItem.id;
      const data = await api["a" /* filestorageApi */].file.download(params);
      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = item.name;
      if (dataItem.isDirectory) link.download += '.zip';
      link.click();
    } catch (e) {
      logger["a" /* default */].error(e);
      throw e;
    }
  }
};
/* harmony default export */ var download_items = (downloadItems);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/create-directory.js



const createDirectory = async (parentDir, name) => {
  try {
    const {
      dataItem
    } = parentDir;
    const params = {
      driveId: get_drive_id(dataItem),
      name
    };
    if (!dataItem.isDrive) params.directoryId = dataItem.id;
    await api["a" /* filestorageApi */].items.createDirectory(params);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var create_directory = (createDirectory);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/delete-item.js



const deleteItem = async item => {
  try {
    const {
      dataItem
    } = item;
    const params = {
      driveId: get_drive_id(dataItem),
      items: [dataItem.id],
      force: true
    };
    if (!dataItem.isDrive) params.directoryId = dataItem.id;
    await api["a" /* filestorageApi */].items.deleteItem(params);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var delete_item = (deleteItem);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/rename-item.js


const renameItem = async (item, name) => {
  try {
    const {
      dataItem
    } = item;
    if (dataItem !== null && dataItem !== void 0 && dataItem.isDrive) {
      await api["a" /* filestorageApi */].drives.renameDrive(dataItem.id, name);
    } else {
      const params = {
        driveId: dataItem.driveId,
        name,
        itemId: dataItem.id
      };
      await api["a" /* filestorageApi */].items.rename(params);
    }
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var rename_item = (renameItem);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/move-item.js




const moveItem = async (item, destinationDir) => {
  try {
    if (!destinationDir.dataItem) return;
    const desItem = destinationDir.dataItem;
    const params = {
      driveId: get_drive_id(desItem),
      items: []
    };
    if (!desItem.isDrive) params.directoryId = desItem.id;
    if (item.dataItem) params.items.push(item.dataItem.id);
    await api["a" /* filestorageApi */].items.move(params);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var move_item = (moveItem);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/copy-item.js




const copyItem = async (item, destinationDir) => {
  try {
    if (!destinationDir.dataItem) return;
    const desItem = destinationDir.dataItem;
    const params = {
      driveId: get_drive_id(desItem),
      items: []
    };
    if (!desItem.isDrive) params.directoryId = desItem.id;
    if (item.dataItem) params.items.push(item.dataItem.id);
    await api["a" /* filestorageApi */].items.copy(params);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var copy_item = (copyItem);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/create-drive.js


const createDrive = async newDrive => {
  try {
    await api["a" /* filestorageApi */].drives.createDrive(newDrive);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var create_drive = (createDrive);
// EXTERNAL MODULE: ./src/utils/index.js + 1 modules
var utils = __webpack_require__("ed08");

// CONCATENATED MODULE: ./src/components/file-storage/utils/parse-file-name.js
function parseFileName(filename) {
  const extension = filename.split('.').splice(-1)[0];
  const name = filename.replace(new RegExp('(\\.' + extension + ')$'), '');
  return {
    filename,
    name,
    extension
  };
}
// CONCATENATED MODULE: ./src/components/file-storage/utils/rename-file.js
function renameFile(originalFile, newName) {
  return new File([originalFile], newName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified
  });
}
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/upload-file-chunk.js







const upload_file_chunk_fetchItems = async params => (await api["a" /* filestorageApi */].items.getItems(params)).Items.map(item => ({
  id: item.Id,
  driveId: item.DriveId,
  name: item.Name,
  size: item.Size,
  isDirectory: item.Type === item_type.DIRECTORY,
  hasSubDirectories: item.HasSubDir,
  dateModified: item.ModifyDate,
  thumbnail: null
}));
const uploadFileChunk = async (fileData, chunksInfo, destinationDir) => {
  try {
    if (chunksInfo.chunkIndex === 0) {
      const uploadCancelSource = utils["a" /* cancelToken */].source();
      chunksInfo.customData.uploadCancelSource = uploadCancelSource;
      const {
        dataItem
      } = destinationDir;
      const params = {
        driveId: get_drive_id(dataItem)
      };
      if (!dataItem.isDrive) params.directoryId = dataItem.id;
      const items = await upload_file_chunk_fetchItems(params);
      let fileName = fileData.name;
      const {
        name,
        extension
      } = parseFileName(fileName);
      let i = 1;
      while (items.findIndex(item => fileName === item.name) !== -1) {
        fileName = name + ` (${i++}).` + extension;
      }
      if (fileData.name !== fileName) fileData = renameFile(fileData, fileName);
      params.fileData = fileData;
      await api["a" /* filestorageApi */].file.upload(params, uploadCancelSource.token);
    }
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
const abortFileUpload = (fileData, chunksInfo, destinationDir) => {
  var _chunksInfo$customDat;
  if ((_chunksInfo$customDat = chunksInfo.customData) !== null && _chunksInfo$customDat !== void 0 && _chunksInfo$customDat.uploadCancelSource) {
    chunksInfo.customData.uploadCancelSource.cancel();
  }
};

// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/restore-item.js



const restoreItem = async (item, destinationDir, newName) => {
  try {
    var _item$dataItem;
    const desItem = destinationDir.dataItem;
    const params = {
      id: (_item$dataItem = item.dataItem) === null || _item$dataItem === void 0 ? void 0 : _item$dataItem.id,
      driveId: get_drive_id(desItem),
      newName
    };
    if (!desItem.isDrive) params.newDirectoryId = desItem.id;
    await api["a" /* filestorageApi */].items.restoreItem(params);
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var restore_item = (restoreItem);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/set-shared-drive.js


const setSharedDrive = async (dataItem, permissions) => {
  try {
    await api["a" /* filestorageApi */].drives.updateDrive({
      id: dataItem.id,
      name: dataItem.name,
      label: dataItem.name,
      permissions
    });
  } catch (e) {
    logger["a" /* default */].error(e);
    throw e;
  }
};
/* harmony default export */ var set_shared_drive = (setSharedDrive);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__("b7ef");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.at.js
var es_typed_array_at = __webpack_require__("907a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-last.js
var es_typed_array_find_last = __webpack_require__("986a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-last-index.js
var es_typed_array_find_last_index = __webpack_require__("1d02");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__("3c5d");

// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/get-thumbnail.js









const CSS_CLASS_ICON = ["dx-icon", "dx-filemanager-thumbnails-item-thumbnail"];
const CSS_CUSTOM_THUMBNAIL = "vis-thumbnail";
const MAX_COUNT_CACHE_THUMBNAILS = 20;
const cacheThumbnails = [];
const getThumbnail = async (fileItem, el) => {
  try {
    var _cacheThumbnails$find;
    const {
      dataItem
    } = fileItem;
    if (!dataItem) {
      return null;
    }
    const {
      driveId,
      id
    } = dataItem;
    let thumbnail = (_cacheThumbnails$find = cacheThumbnails.find(item => item.driveId === driveId && item.id === id)) === null || _cacheThumbnails$find === void 0 ? void 0 : _cacheThumbnails$find.thumbnail;
    if (!thumbnail) {
      const {
        data,
        type
      } = await api["a" /* filestorageApi */].preview.downloadPreview({
        driveId,
        itemId: id
      });
      const base64Img = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      thumbnail = `data:${type};base64,${base64Img}`;
      cacheThumbnails.push({
        driveId,
        id,
        thumbnail
      });
      if (cacheThumbnails.length > MAX_COUNT_CACHE_THUMBNAILS) {
        cacheThumbnails.shift();
      }
    }
    const icon = el.querySelector(`i.${CSS_CLASS_ICON.join(".")}`);
    if (!icon) {
      return;
    }
    const img = document.createElement("img");
    img.classList.add(...CSS_CLASS_ICON);
    img.src = thumbnail;
    icon.replaceWith(img);
    el.classList.add(CSS_CUSTOM_THUMBNAIL);
  } catch (err) {
    logger["a" /* default */].error(err);
  }
};
/* harmony default export */ var get_thumbnail = (getThumbnail);
// CONCATENATED MODULE: ./src/components/file-storage/provider-methods/index.js













// CONCATENATED MODULE: ./src/components/file-storage/create-file-system.js



function createFileSystemProvider(params) {
  return new custom_provider_default.a(Object(objectSpread2["a" /* default */])({
    getItems: get_items,
    downloadItems: download_items,
    createDirectory: create_directory,
    deleteItem: delete_item,
    renameItem: rename_item,
    moveItem: move_item,
    copyItem: copy_item,
    uploadFileChunk: uploadFileChunk,
    abortFileUpload: abortFileUpload,
    hasSubDirectoriesExpr({
      hasSubDirectories
    }) {
      return hasSubDirectories || false;
    }
  }, params));
}
// CONCATENATED MODULE: ./src/components/file-storage/utils/show-proxy-dialog.js
/* harmony default export */ var show_proxy_dialog = ((dialog, {
  title,
  buttonTxt,
  showProps
}) => {
  return new Promise(resolve => {
    const onDialogClosedOrig = dialog._onClosedAction.bind(dialog);
    const titleOrig = dialog._popup.option("title");
    const buttonTxtOrig = dialog._popup.option("toolbarItems[0].options.text");
    if (title) {
      dialog._setTitle(title);
    }
    if (buttonTxt) {
      dialog._setButtonText(buttonTxt);
    }
    dialog._onClosedAction = result => {
      dialog._onClosedAction = onDialogClosedOrig;
      dialog._setTitle(titleOrig);
      dialog._setButtonText(buttonTxtOrig);
      resolve(result === null || result === void 0 ? void 0 : result.dialogResult);
    };
    dialog.show(showProps);
  });
});
// CONCATENATED MODULE: ./src/components/file-storage/enum/command.js
/* harmony default export */ var enum_command = (Object.freeze({
  CREATE_DIR: "create",
  CREATE_DRIVE: "createDrive",
  RESTORE: "restore",
  DOWNLOAD: "download",
  RENAME: "rename",
  SHARED_DRIVE: "sharedDrive",
  COPY: "copy",
  MOVE: "move",
  DELETE: "delete",
  UPLOAD: "upload",
  REFRESH: "refresh"
}));
// CONCATENATED MODULE: ./src/components/file-storage/get-commands.js


/* harmony default export */ var get_commands = (() => [{
  name: enum_command.CREATE_DIR
}, {
  name: enum_command.CREATE_DRIVE,
  widget: "dxButton",
  options: {
    text: Object(localization_["formatMessage"])("dxFileManager-commandCreateDrive"),
    icon: "far fa-hdd"
  }
}, {
  name: enum_command.UPLOAD,
  isBeginGroup: true
}, {
  name: enum_command.RESTORE,
  isSelectedFile: true,
  widget: "dxButton",
  options: {
    text: Object(localization_["formatMessage"])("dxFileManager-commandRestore"),
    icon: "far fa-history"
  }
}, {
  name: enum_command.DOWNLOAD,
  isSelectedFile: true
}, {
  name: enum_command.RENAME,
  isBeginGroup: true,
  isSelectedFile: true
}, {
  name: enum_command.SHARED_DRIVE,
  isSelectedFile: true,
  widget: "dxButton",
  options: {
    text: Object(localization_["formatMessage"])("dxFileManager-commandSharedDrive"),
    icon: "far fa-user-plus"
  }
}, {
  name: enum_command.COPY,
  isSelectedFile: true
}, {
  name: enum_command.MOVE,
  isSelectedFile: true
}, {
  name: enum_command.DELETE,
  isSelectedFile: true
}, {
  name: enum_command.REFRESH
}]);
// CONCATENATED MODULE: ./src/components/file-storage/enum/view-mode.js
/* harmony default export */ var view_mode = (Object.freeze({
  DETAILS: "details",
  THUMBNAILS: "thumbnails"
}));
// CONCATENATED MODULE: ./src/components/file-storage/enum/drive-permission.js
/* harmony default export */ var drive_permission = (Object.freeze({
  READ: "Read",
  WRITE: "Write",
  ADMIN: "Admin"
}));
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-create-drive-dialog.vue?vue&type=template&id=2154c38a&scoped=true&
var vis_create_drive_dialogvue_type_template_id_2154c38a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-dialog', {
    attrs: {
      "title": _vm.title,
      "save-btn-txt": _vm.saveBtnTxt
    },
    on: {
      "save": _vm.save,
      "update:visible": _vm.onVisibleUpdate
    }
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('dx-form', {
    ref: "form",
    attrs: {
      "form-data": _vm.formData,
      "colCount": 2
    }
  }, [_c('dx-item-form', {
    attrs: {
      "data-field": "name",
      "colSpan": 2
    }
  }, [_c('dx-label', {
    attrs: {
      "text": _vm.nameLbl,
      "location": "top"
    }
  }), _c('dx-required-rule', {
    attrs: {
      "message": _vm.nameRequired
    }
  })], 1), _c('dx-item-form', {
    attrs: {
      "data-field": "isCrypted",
      "editor-type": "dxCheckBox"
    }
  }, [_c('dx-label', {
    attrs: {
      "text": _vm.isCryptedLbl
    }
  })], 1), _c('dx-item-form', {
    attrs: {
      "data-field": "hasHistory",
      "editor-type": "dxCheckBox"
    }
  }, [_c('dx-label', {
    attrs: {
      "text": _vm.hasHistoryLbl
    }
  })], 1), _c('dx-item-form', {
    attrs: {
      "data-field": "hasRecycleBin",
      "editor-type": "dxCheckBox"
    }
  }, [_c('dx-label', {
    attrs: {
      "text": _vm.hasRecycleBinLbl
    }
  })], 1)], 1)], 1), _c('div', [_c('h3', {
    staticClass: "permission-title"
  }, [_vm._v(_vm._s(_vm.sharedDriveTitle))]), _c('vis-drive-permissions', {
    attrs: {
      "permissions": _vm.permissions
    }
  })], 1)]);
};
var vis_create_drive_dialogvue_type_template_id_2154c38a_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-create-drive-dialog.vue?vue&type=template&id=2154c38a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-dialog.vue?vue&type=template&id=531201bc&scoped=true&
var vis_dialogvue_type_template_id_531201bc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('dx-popup', {
    ref: "popup",
    attrs: {
      "visible": _vm.visiblePopup,
      "title": _vm.title,
      "width": _vm.width,
      "min-width": _vm.minWidth,
      "max-width": _vm.maxWidth,
      "height": _vm.height,
      "close-on-outside-click": true
    },
    on: {
      "update:visible": function ($event) {
        _vm.visiblePopup = $event;
      }
    }
  }, [_vm._t("default"), _c('dx-toolbar', {
    staticClass: "footer"
  }, [_c('dx-item', {
    attrs: {
      "widget": "dxButton",
      "disabled": _vm.isDisableSave,
      "options": _vm.saveButtonOptions,
      "location": "after"
    }
  }), _c('dx-item', {
    attrs: {
      "widget": "dxButton",
      "options": _vm.cancelButtonOptions,
      "location": "after"
    }
  })], 1)], 2);
};
var vis_dialogvue_type_template_id_531201bc_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-dialog.vue?vue&type=template&id=531201bc&scoped=true&

// EXTERNAL MODULE: external "devextreme-vue/popup"
var popup_ = __webpack_require__("8451");

// EXTERNAL MODULE: external "devextreme-vue/toolbar"
var toolbar_ = __webpack_require__("5411");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-dialog.vue?vue&type=script&lang=js&



/* harmony default export */ var vis_dialogvue_type_script_lang_js_ = ({
  name: "vis-dialog",
  components: {
    DxPopup: popup_["DxPopup"],
    DxToolbar: toolbar_["DxToolbar"],
    DxItem: toolbar_["DxItem"]
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "45rem"
    },
    minWidth: {
      type: String,
      default: "18rem"
    },
    maxWidth: {
      type: String,
      default: "95vw"
    },
    height: {
      type: String,
      default: "auto"
    },
    saveBtnTxt: {
      type: String,
      default: () => Object(localization_["formatMessage"])("dxFileManager-dialogSaveBtn")
    },
    isDisableSave: {
      type: Boolean,
      default: false
    },
    cancelBtnTxt: {
      type: String,
      default: () => Object(localization_["formatMessage"])("dxFileManager-dialogCancelBtn")
    }
  },
  computed: {
    visiblePopup: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    saveButtonOptions() {
      return {
        text: this.saveBtnTxt,
        onClick: this.save
      };
    },
    cancelButtonOptions() {
      return {
        text: this.cancelBtnTxt,
        onClick: () => {
          this.visiblePopup = false;
        }
      };
    }
  },
  methods: {
    save() {
      this.$emit("save");
    },
    updatePosition() {
      this.$refs.popup.instance.repaint();
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialogs_vis_dialogvue_type_script_lang_js_ = (vis_dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/dialogs/vis-dialog.vue?vue&type=style&index=0&id=531201bc&prod&scoped=true&lang=css&
var vis_dialogvue_type_style_index_0_id_531201bc_prod_scoped_true_lang_css_ = __webpack_require__("1429");

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-dialog.vue






/* normalize component */

var vis_dialog_component = Object(componentNormalizer["a" /* default */])(
  dialogs_vis_dialogvue_type_script_lang_js_,
  vis_dialogvue_type_template_id_531201bc_scoped_true_render,
  vis_dialogvue_type_template_id_531201bc_scoped_true_staticRenderFns,
  false,
  null,
  "531201bc",
  null
  
)

/* harmony default export */ var vis_dialog = (vis_dialog_component.exports);
// EXTERNAL MODULE: external "devextreme-vue/form"
var form_ = __webpack_require__("4022");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-drive-permissions.vue?vue&type=template&id=70c83544&scoped=true&
var vis_drive_permissionsvue_type_template_id_70c83544_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('dx-list', {
    attrs: {
      "data-source": _vm.listPermissions,
      "allow-item-deleting": true,
      "no-data-text": _vm.noDataLbl
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        data: item
      }) {
        return [_c('vis-drive-permissions-item', {
          attrs: {
            "id-profile": item.id,
            "is-user": item.isUser,
            "name": item.name,
            "permission": item.permission
          },
          on: {
            "update:name": function ($event) {
              return _vm.$set(item, "name", $event);
            },
            "update:permission": function ($event) {
              return _vm.$set(item, "permission", $event);
            }
          }
        })];
      }
    }])
  }), _c('div', {
    staticClass: "new-permission"
  }, [!_vm.isAddNewPermission ? _c('dx-button', {
    attrs: {
      "text": _vm.addBtnLbl
    },
    on: {
      "click": function ($event) {
        _vm.isAddNewPermission = true;
      }
    }
  }) : _c('vis-add-drive-permission', {
    attrs: {
      "skip-profiles": _vm.listPermissions
    },
    on: {
      "add-drive-permission": _vm.onAddPermission,
      "cancel": function ($event) {
        _vm.isAddNewPermission = false;
      }
    }
  })], 1)], 1);
};
var vis_drive_permissionsvue_type_template_id_70c83544_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions.vue?vue&type=template&id=70c83544&scoped=true&

// EXTERNAL MODULE: external "devextreme-vue/list"
var list_ = __webpack_require__("2b03");
var list_default = /*#__PURE__*/__webpack_require__.n(list_);

// EXTERNAL MODULE: external "devextreme-vue/button"
var button_ = __webpack_require__("f2e6");
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue?vue&type=template&id=ea7f87c0&scoped=true&
var vis_drive_permissions_itemvue_type_template_id_ea7f87c0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "list-permissions-item"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('dx-load-indicator', {
    attrs: {
      "visible": _vm.isLoading
    }
  }), _c('span', [_vm._v(_vm._s(_vm.profileName))])], 1), _c('vis-select-permission', {
    model: {
      value: _vm.profilePermission,
      callback: function ($$v) {
        _vm.profilePermission = $$v;
      },
      expression: "profilePermission"
    }
  })], 1);
};
var vis_drive_permissions_itemvue_type_template_id_ea7f87c0_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue?vue&type=template&id=ea7f87c0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-select-permission.vue?vue&type=template&id=97de7f2a&
var vis_select_permissionvue_type_template_id_97de7f2a_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('dx-select-box', {
    attrs: {
      "data-source": _vm.listAccess,
      "value": _vm.value,
      "value-expr": "value",
      "display-expr": "viewValue"
    },
    on: {
      "selection-changed": _vm.changed
    }
  });
};
var vis_select_permissionvue_type_template_id_97de7f2a_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-select-permission.vue?vue&type=template&id=97de7f2a&

// EXTERNAL MODULE: external "devextreme-vue/select-box"
var select_box_ = __webpack_require__("7ffb");
var select_box_default = /*#__PURE__*/__webpack_require__.n(select_box_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-select-permission.vue?vue&type=script&lang=js&




/* harmony default export */ var vis_select_permissionvue_type_script_lang_js_ = ({
  name: "vis-select-permission",
  components: {
    DxSelectBox: select_box_default.a
  },
  props: {
    value: {
      type: String,
      default: drive_permission.READ
    }
  },
  computed: {
    listAccess() {
      const list = [{
        value: drive_permission.READ,
        viewValue: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsRead")
      }, {
        value: drive_permission.WRITE,
        viewValue: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsWrite")
      }, {
        value: drive_permission.ADMIN,
        viewValue: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsAdmin")
      }];
      if (list.findIndex(item => item.value === this.value) < 0) {
        list.push({
          value: this.value,
          viewValue: this.value
        });
      }
      return list;
    }
  },
  methods: {
    changed(e) {
      this.$emit("input", e.selectedItem.value);
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-select-permission.vue?vue&type=script&lang=js&
 /* harmony default export */ var drive_permissions_vis_select_permissionvue_type_script_lang_js_ = (vis_select_permissionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-select-permission.vue





/* normalize component */

var vis_select_permission_component = Object(componentNormalizer["a" /* default */])(
  drive_permissions_vis_select_permissionvue_type_script_lang_js_,
  vis_select_permissionvue_type_template_id_97de7f2a_render,
  vis_select_permissionvue_type_template_id_97de7f2a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_select_permission = (vis_select_permission_component.exports);
// EXTERNAL MODULE: external "devextreme-vue/load-indicator"
var load_indicator_ = __webpack_require__("58cc");
var load_indicator_default = /*#__PURE__*/__webpack_require__.n(load_indicator_);

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/allProfiles.js

/* harmony default export */ var allProfiles = ({
  id: 0,
  get name() {
    return Object(localization_["formatMessage"])("dxFileManager-drivePermissionsAll");
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue?vue&type=script&lang=js&







/* harmony default export */ var vis_drive_permissions_itemvue_type_script_lang_js_ = ({
  name: "vis-drive-permissions-item",
  components: {
    VisSelectPermission: vis_select_permission,
    DxLoadIndicator: load_indicator_default.a
  },
  props: {
    idProfile: {
      type: Number,
      required: true
    },
    isUser: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: null
    },
    permission: {
      type: String,
      default: drive_permission.READ
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    profilePermission: {
      get() {
        return this.permission;
      },
      set(value) {
        this.$emit("update:permission", value);
      }
    },
    profileName: {
      get() {
        return this.name;
      },
      set(value) {
        return this.$emit("update:name", value);
      }
    }
  },
  created() {
    this.updateName();
  },
  methods: {
    async updateName() {
      if (!this.profileName) {
        this.isLoading = true;
        if (this.isUser) {
          await this.loadUserName();
        } else {
          await this.loadGroupName();
        }
        this.isLoading = false;
      }
    },
    async loadUserName() {
      try {
        const user = await api["e" /* profileApi */].user.getUserById(this.idProfile);
        this.profileName = user.nickName;
      } catch (err) {
        this.profileName = Object(localization_["formatMessage"])("dxFileManager-drivePermissionsUnknownUser");
        logger["a" /* default */].error(err);
      }
    },
    async loadGroupName() {
      try {
        if (this.idProfile === allProfiles.id) {
          this.profileName = allProfiles.name;
          return;
        }
        const user = await api["e" /* profileApi */].group.getGroupById(this.idProfile);
        this.profileName = user.title;
      } catch (err) {
        this.profileName = Object(localization_["formatMessage"])("dxFileManager-drivePermissionsUnknownGroup");
        logger["a" /* default */].error(err);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var drive_permissions_vis_drive_permissions_itemvue_type_script_lang_js_ = (vis_drive_permissions_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue?vue&type=style&index=0&id=ea7f87c0&prod&scoped=true&lang=scss&
var vis_drive_permissions_itemvue_type_style_index_0_id_ea7f87c0_prod_scoped_true_lang_scss_ = __webpack_require__("f03a");

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions-item.vue






/* normalize component */

var vis_drive_permissions_item_component = Object(componentNormalizer["a" /* default */])(
  drive_permissions_vis_drive_permissions_itemvue_type_script_lang_js_,
  vis_drive_permissions_itemvue_type_template_id_ea7f87c0_scoped_true_render,
  vis_drive_permissions_itemvue_type_template_id_ea7f87c0_scoped_true_staticRenderFns,
  false,
  null,
  "ea7f87c0",
  null
  
)

/* harmony default export */ var vis_drive_permissions_item = (vis_drive_permissions_item_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue?vue&type=template&id=75507717&scoped=true&
var vis_add_drive_permissionvue_type_template_id_75507717_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h4', {
    staticClass: "add-permissions-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "add-permissions-container"
  }, [_c('dx-select-box', {
    attrs: {
      "placeholder": _vm.choosePlaceholder,
      "grouped": true,
      "data-source": _vm.listProfiles,
      "search-enabled": true,
      "search-timeout": _vm.searchTimeout,
      "display-expr": "name",
      "value-expr": "value"
    },
    on: {
      "selection-changed": _vm.onSelectionChanged
    }
  }), _c('vis-select-permission', {
    model: {
      value: _vm.permission,
      callback: function ($$v) {
        _vm.permission = $$v;
      },
      expression: "permission"
    }
  }), _c('div', {
    staticClass: "actions"
  }, [_c('dx-button', {
    attrs: {
      "text": _vm.addBtnTxt,
      "disabled": !_vm.profile
    },
    on: {
      "click": _vm.add
    }
  }), _c('dx-button', {
    attrs: {
      "text": _vm.cancelBtnTxt
    },
    on: {
      "click": _vm.cancel
    }
  })], 1)], 1)]);
};
var vis_add_drive_permissionvue_type_template_id_75507717_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue?vue&type=template&id=75507717&scoped=true&

// EXTERNAL MODULE: external "devextreme/data/data_source"
var data_source_ = __webpack_require__("6e03");
var data_source_default = /*#__PURE__*/__webpack_require__.n(data_source_);

// EXTERNAL MODULE: external "devextreme/data/custom_store"
var custom_store_ = __webpack_require__("5aa8");
var custom_store_default = /*#__PURE__*/__webpack_require__.n(custom_store_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue?vue&type=script&lang=js&












const SEARCH_TIMEOUT = 250;
/* harmony default export */ var vis_add_drive_permissionvue_type_script_lang_js_ = ({
  name: "vis-add-drive-permission",
  components: {
    DxSelectBox: select_box_default.a,
    DxButton: button_default.a,
    VisSelectPermission: vis_select_permission
  },
  props: {
    searchTimeout: {
      type: Number,
      default: SEARCH_TIMEOUT
    },
    skipProfiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      permission: drive_permission.READ,
      listProfiles: [],
      profile: null,
      title: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsAddAccess"),
      choosePlaceholder: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsChooseProfile"),
      addBtnTxt: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsAddBtn"),
      cancelBtnTxt: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsCancelBtn")
    };
  },
  created() {
    this.listProfiles = new data_source_default.a({
      paginate: false,
      store: new custom_store_default.a({
        key: "Product_ID",
        load: ({
          searchValue
        }) => this.getProfiles(searchValue)
      })
    });
  },
  methods: {
    add() {
      this.$emit("add-drive-permission", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this.profile), {}, {
        permission: this.permission
      }));
    },
    cancel() {
      this.$emit("cancel");
    },
    async getProfiles(searchValue, pageSize = 20) {
      const usersReq = {
        select: "id,nickName",
        take: pageSize
      };
      const groupsReq = {
        select: "id,title",
        take: pageSize
      };
      let list = [];
      if (searchValue) {
        usersReq.filter = `nickName:${searchValue}`;
        groupsReq.filter = `title:${searchValue}`;
      } else if (!this.skipProfiles.find(item => item.id === allProfiles.id)) {
        list.push({
          key: "",
          items: [Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, allProfiles), {}, {
            isUser: false,
            value: "all"
          })]
        });
      }
      try {
        const res = await Promise.all([api["e" /* profileApi */].user.getUsers(usersReq), api["e" /* profileApi */].group.getGroups(groupsReq)]);
        const users = res[0].records.filter(item => {
          return !this.skipProfiles.find(profile => profile.id === item.id && profile.isUser);
        }).map(item => ({
          id: item.id,
          isUser: true,
          value: `user:${item.id}`,
          name: item.nickName
        }));
        const groups = res[1].groups.filter(item => {
          return !this.skipProfiles.find(profile => profile.id === item.id && !profile.isUser);
        }).map(item => ({
          id: item.id,
          isUser: false,
          value: `group:${item.id}`,
          name: item.title
        }));
        if (users.length) {
          list = list.concat({
            key: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsUsers"),
            isGroup: false,
            items: users
          });
        }
        if (groups.length) {
          list = list.concat({
            key: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsGroups"),
            isGroup: true,
            items: groups
          });
        }
      } catch (err) {
        logger["a" /* default */].error(err);
      }
      return list;
    },
    onSelectionChanged(e) {
      this.profile = e.selectedItem;
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue?vue&type=script&lang=js&
 /* harmony default export */ var drive_permissions_vis_add_drive_permissionvue_type_script_lang_js_ = (vis_add_drive_permissionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue?vue&type=style&index=0&id=75507717&prod&scoped=true&lang=scss&
var vis_add_drive_permissionvue_type_style_index_0_id_75507717_prod_scoped_true_lang_scss_ = __webpack_require__("1203");

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-add-drive-permission.vue






/* normalize component */

var vis_add_drive_permission_component = Object(componentNormalizer["a" /* default */])(
  drive_permissions_vis_add_drive_permissionvue_type_script_lang_js_,
  vis_add_drive_permissionvue_type_template_id_75507717_scoped_true_render,
  vis_add_drive_permissionvue_type_template_id_75507717_scoped_true_staticRenderFns,
  false,
  null,
  "75507717",
  null
  
)

/* harmony default export */ var vis_add_drive_permission = (vis_add_drive_permission_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/drive-permissions/vis-drive-permissions.vue?vue&type=script&lang=js&






/* harmony default export */ var vis_drive_permissionsvue_type_script_lang_js_ = ({
  name: "vis-drive-permissions",
  components: {
    DxList: list_default.a,
    DxButton: button_default.a,
    VisAddDrivePermission: vis_add_drive_permission,
    VisDrivePermissionsItem: vis_drive_permissions_item
  },
  props: {
    permissions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isAddNewPermission: false,
      noDataLbl: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsNoData"),
      addBtnLbl: Object(localization_["formatMessage"])("dxFileManager-drivePermissionsAddAccess")
    };
  },
  computed: {
    listPermissions() {
      return this.permissions;
    }
  },
  methods: {
    onAddPermission(permission) {
      this.listPermissions.push(permission);
      this.isAddNewPermission = false;
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions.vue?vue&type=script&lang=js&
 /* harmony default export */ var drive_permissions_vis_drive_permissionsvue_type_script_lang_js_ = (vis_drive_permissionsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions.vue?vue&type=style&index=0&id=70c83544&prod&scoped=true&lang=scss&
var vis_drive_permissionsvue_type_style_index_0_id_70c83544_prod_scoped_true_lang_scss_ = __webpack_require__("8a06");

// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/vis-drive-permissions.vue






/* normalize component */

var vis_drive_permissions_component = Object(componentNormalizer["a" /* default */])(
  drive_permissions_vis_drive_permissionsvue_type_script_lang_js_,
  vis_drive_permissionsvue_type_template_id_70c83544_scoped_true_render,
  vis_drive_permissionsvue_type_template_id_70c83544_scoped_true_staticRenderFns,
  false,
  null,
  "70c83544",
  null
  
)

/* harmony default export */ var vis_drive_permissions = (vis_drive_permissions_component.exports);
// CONCATENATED MODULE: ./src/components/file-storage/drive-permissions/index.js


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-create-drive-dialog.vue?vue&type=script&lang=js&




/* harmony default export */ var vis_create_drive_dialogvue_type_script_lang_js_ = ({
  name: "vis-create-drive-dialog",
  components: {
    VisDialog: vis_dialog,
    DxRequiredRule: form_["DxRequiredRule"],
    DxForm: form_["DxForm"],
    DxItemForm: form_["DxItem"],
    DxLabel: form_["DxLabel"],
    VisDrivePermissions: vis_drive_permissions
  },
  data() {
    return {
      formData: {
        name: "",
        isCrypted: false,
        hasHistory: false,
        hasRecycleBin: false
      },
      permissions: [],
      title: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupTitle"),
      saveBtnTxt: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupCreateBtn"),
      nameLbl: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupName"),
      nameRequired: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupNameRequired"),
      isCryptedLbl: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupCrypted"),
      hasHistoryLbl: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupHistory"),
      hasRecycleBinLbl: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupRecycleBin"),
      sharedDriveTitle: Object(localization_["formatMessage"])("dxFileManager-newDrivePopupSharedDrive")
    };
  },
  methods: {
    save() {
      const validation = this.$refs.form.instance.validate();
      if (validation.isValid) {
        const data = {
          name: this.formData.name.trim(),
          isCrypted: this.formData.isCrypted,
          hasHistory: this.formData.hasHistory,
          hasRecycleBin: this.formData.hasRecycleBin,
          permissions: this.permissions
        };
        this.$emit("save", data);
      }
    },
    onVisibleUpdate(value) {
      if (!value) {
        this.$emit("cancel");
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-create-drive-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialogs_vis_create_drive_dialogvue_type_script_lang_js_ = (vis_create_drive_dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/dialogs/vis-create-drive-dialog.vue?vue&type=style&index=0&id=2154c38a&prod&lang=scss&scoped=true&
var vis_create_drive_dialogvue_type_style_index_0_id_2154c38a_prod_lang_scss_scoped_true_ = __webpack_require__("f1a1");

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-create-drive-dialog.vue






/* normalize component */

var vis_create_drive_dialog_component = Object(componentNormalizer["a" /* default */])(
  dialogs_vis_create_drive_dialogvue_type_script_lang_js_,
  vis_create_drive_dialogvue_type_template_id_2154c38a_scoped_true_render,
  vis_create_drive_dialogvue_type_template_id_2154c38a_scoped_true_staticRenderFns,
  false,
  null,
  "2154c38a",
  null
  
)

/* harmony default export */ var vis_create_drive_dialog = (vis_create_drive_dialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue?vue&type=template&id=251e9f26&scoped=true&
var vis_drive_permissions_dialogvue_type_template_id_251e9f26_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('vis-dialog', {
    ref: "dialog",
    attrs: {
      "title": _vm.title,
      "is-disable-save": _vm.isLoading
    },
    on: {
      "save": _vm.save,
      "update:visible": _vm.onVisibleUpdate
    }
  }, [_c('div', [_vm.isLoading ? _c('div', {
    staticClass: "loading-block"
  }, [_c('dx-load-indicator')], 1) : _c('vis-drive-permissions', {
    attrs: {
      "permissions": _vm.permissions
    }
  })], 1)]);
};
var vis_drive_permissions_dialogvue_type_template_id_251e9f26_scoped_true_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue?vue&type=template&id=251e9f26&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue?vue&type=script&lang=js&






/* harmony default export */ var vis_drive_permissions_dialogvue_type_script_lang_js_ = ({
  name: "vis-drive-permissions-dialog",
  components: {
    VisDialog: vis_dialog,
    VisDrivePermissions: vis_drive_permissions,
    DxLoadIndicator: load_indicator_default.a
  },
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: Object(localization_["formatMessage"])("dxFileManager-sharedDrivePopupTitle", this.dataItem.name),
      isLoading: false,
      permissions: []
    };
  },
  created() {
    this.loadPermissions();
  },
  methods: {
    async loadPermissions() {
      this.isLoading = true;
      try {
        const drive = await api["a" /* filestorageApi */].drives.getDriveById(this.dataItem.id);
        this.permissions = drive.Permissions.map(item => ({
          id: item.Id,
          isUser: item.IsUser,
          permission: item.Permission
        }));
      } catch (err) {
        logger["a" /* default */].error(err);
      } finally {
        this.isLoading = false;
        this.$nextTick(() => {
          this.$refs.dialog.updatePosition();
        });
      }
    },
    save() {
      this.$emit("save", this.permissions);
    },
    onVisibleUpdate(value) {
      if (!value) {
        this.$emit("cancel");
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var dialogs_vis_drive_permissions_dialogvue_type_script_lang_js_ = (vis_drive_permissions_dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue?vue&type=style&index=0&id=251e9f26&prod&scoped=true&lang=css&
var vis_drive_permissions_dialogvue_type_style_index_0_id_251e9f26_prod_scoped_true_lang_css_ = __webpack_require__("1deb");

// CONCATENATED MODULE: ./src/components/file-storage/dialogs/vis-drive-permissions-dialog.vue






/* normalize component */

var vis_drive_permissions_dialog_component = Object(componentNormalizer["a" /* default */])(
  dialogs_vis_drive_permissions_dialogvue_type_script_lang_js_,
  vis_drive_permissions_dialogvue_type_template_id_251e9f26_scoped_true_render,
  vis_drive_permissions_dialogvue_type_template_id_251e9f26_scoped_true_staticRenderFns,
  false,
  null,
  "251e9f26",
  null
  
)

/* harmony default export */ var vis_drive_permissions_dialog = (vis_drive_permissions_dialog_component.exports);
// CONCATENATED MODULE: ./src/components/file-storage/dialogs/index.js



// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/file-storage/vis-file-storage.vue?vue&type=script&lang=js&













const CSS_CTX_NAMESPACE = "vis-file-storage-ctx";
const CSS_DIALOG_NAMESPACE = "vis-file-storage-dialog";
const MAX_FILE_SIZE = 2147483648; // 2Gb

/* harmony default export */ var vis_file_storagevue_type_script_lang_js_ = ({
  name: "vis-file-storage",
  components: {
    DxFileManager: file_manager_["DxFileManager"],
    DxItemView: file_manager_["DxItemView"],
    DxPermissions: file_manager_["DxPermissions"],
    DxToolbar: file_manager_["DxToolbar"],
    DxContextMenu: file_manager_["DxContextMenu"],
    DxItem: file_manager_["DxItem"],
    DxFileSelectionItem: file_manager_["DxFileSelectionItem"],
    DxUpload: file_manager_["DxUpload"],
    VisCreateDriveDialog: vis_create_drive_dialog,
    VisDrivePermissionsDialog: vis_drive_permissions_dialog
  },
  props: {
    maxFileSize: {
      type: Number,
      default: MAX_FILE_SIZE
    }
  },
  data() {
    return {
      fileSystemProvider: createFileSystemProvider(),
      currentPathKeys: [file_group.MYDRIVE],
      toolbarActions: {
        [enum_command.UPLOAD]: false,
        [enum_command.CREATE_DIR]: false,
        [enum_command.CREATE_DRIVE]: true
      },
      viewMode: view_mode.THUMBNAILS,
      commands: get_commands(),
      rootFolderName: Object(localization_["formatMessage"])("dxFileManager-rootFolder"),
      connectionErrorLbl: Object(localization_["formatMessage"])("dxFileManager-errorConnectionServer"),
      visibleCreateDriveDialog: false,
      editablePermissionsDrive: null
    };
  },
  computed: {
    toolbarCommands() {
      return this.commands.filter(item => !item.isSelectedFile).map(item => this.transformCommand(item, "tb_"));
    },
    toolbarSelCommands() {
      return this.commands.filter(item => item.isSelectedFile).map(item => this.transformCommand(item, "tbs_"));
    },
    ctxCommands() {
      return this.commands.map(item => {
        return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, item), {}, {
          key: "ctx_" + item.name
        });
      });
    }
  },
  mounted() {
    this.initCustomFeatures();
  },
  methods: {
    getFileManager() {
      return this.$refs.fileManager.instance;
    },
    initCustomFeatures() {
      var _chooseDirectoryDialo;
      const fileManager = this.getFileManager();
      this.createProxyCtx(fileManager._itemViewContextMenu);
      this.createProxyCtx(fileManager._filesTreeViewContextMenu, true);
      const _toolbar = fileManager._toolbar;
      const isToolbarItemAvailableOrig = _toolbar._isToolbarItemAvailable.bind(_toolbar);
      _toolbar._isToolbarItemAvailable = (toolbarItem, fileItems) => {
        return this.isCommandAvailableProxy(toolbarItem, fileItems, isToolbarItemAvailableOrig);
      };
      const _chooseDirectoryDialog = fileManager._editing._dialogManager._chooseDirectoryDialog;
      const _getLocationsToProcessOrig = _chooseDirectoryDialog._getLocationsToProcess.bind(_chooseDirectoryDialog);
      _chooseDirectoryDialog._getLocationsToProcess = isDisabled => {
        const res = _getLocationsToProcessOrig(isDisabled);
        const filesTreeView = _chooseDirectoryDialog._filesTreeView;
        res.locationKeysToDisable.push("FIK_");
        for (const [, value] of Object.entries(file_group)) {
          const key = `FIK_${value}`;
          res.locationKeysToDisable.push(key);
          const fileItem = filesTreeView._getNodeByKey(key);
          filesTreeView.toggleDirectoryExpandedStateRecursive(fileItem, isDisabled);
        }
        return res;
      };
      (_chooseDirectoryDialo = _chooseDirectoryDialog._popup._$wrapper[0]) === null || _chooseDirectoryDialo === void 0 ? void 0 : _chooseDirectoryDialo.classList.add(CSS_DIALOG_NAMESPACE);
      const _controller = fileManager._controller;
      const createDirectoryInfoOrig = _controller._createDirectoryInfo.bind(_controller);
      _controller._createDirectoryInfo = (fileItem, parentDirectoryInfo) => {
        const info = createDirectoryInfoOrig(fileItem, parentDirectoryInfo);
        info.icon = this.getIconByFileItem(fileItem);
        return info;
      };
      const createFileInfoOrig = _controller._createFileInfo.bind(_controller);
      _controller._createFileInfo = (fileItem, parentDirectoryInfo) => {
        const info = createFileInfoOrig(fileItem, parentDirectoryInfo);
        info.icon = this.getIconByFileItem(fileItem, info.icon);
        return info;
      };
      this.loadThumbnails();
      _controller._rootDirectoryInfo.icon = "far fa-cloud";
      fileManager._filesTreeView.refresh();
    },
    customizeDetailColumns(columns) {
      columns.push({
        alignment: "right",
        caption: Object(localization_["formatMessage"])("dxFileManager-owner"),
        visibleIndex: 2,
        calculateCellValue: rowData => {
          var _rowData$fileItem$dat, _rowData$fileItem, _rowData$fileItem$dat2;
          return (_rowData$fileItem$dat = (_rowData$fileItem = rowData.fileItem) === null || _rowData$fileItem === void 0 ? void 0 : (_rowData$fileItem$dat2 = _rowData$fileItem.dataItem) === null || _rowData$fileItem$dat2 === void 0 ? void 0 : _rowData$fileItem$dat2.ownerName) !== null && _rowData$fileItem$dat !== void 0 ? _rowData$fileItem$dat : "-";
        }
      });
      const nameCol = columns.find(item => item.dataField === "name");
      if (nameCol) {
        nameCol.width = "38%";
      }
      const sizeCol = columns.find(item => item.dataField === "size");
      if (sizeCol) {
        sizeCol.width = null;
        sizeCol.hidingPriority = null;
        const calcOrig = sizeCol.calculateCellValue;
        sizeCol.calculateCellValue = rowData => {
          var _rowData$fileItem2, _rowData$fileItem2$da;
          if ((_rowData$fileItem2 = rowData.fileItem) !== null && _rowData$fileItem2 !== void 0 && (_rowData$fileItem2$da = _rowData$fileItem2.dataItem) !== null && _rowData$fileItem2$da !== void 0 && _rowData$fileItem2$da.isDirectory) {
            return "-";
          }
          return calcOrig(rowData);
        };
      }
      const dateChangeCol = columns.find(item => item.dataField === "dateModified");
      if (dateChangeCol) {
        dateChangeCol.width = null;
        dateChangeCol.alignment = "right";
        dateChangeCol.hidingPriority = null;
        dateChangeCol.format = "shortDateShortTime";
        dateChangeCol.calculateCellValue = rowData => {
          var _rowData$fileItem3, _rowData$fileItem4, _rowData$fileItem5;
          if ((_rowData$fileItem3 = rowData.fileItem) !== null && _rowData$fileItem3 !== void 0 && _rowData$fileItem3.dataItem.isGroup || (_rowData$fileItem4 = rowData.fileItem) !== null && _rowData$fileItem4 !== void 0 && _rowData$fileItem4.dataItem.isDrive) {
            return "-";
          }
          return (_rowData$fileItem5 = rowData.fileItem) === null || _rowData$fileItem5 === void 0 ? void 0 : _rowData$fileItem5.dateModified;
        };
      }
      return columns;
    },
    onOptionChanged({
      fullName,
      value
    }) {
      if (fullName === "itemView.mode") {
        queueMicrotask(() => {
          const fileManager = this.getFileManager();
          this.createProxyCtx(fileManager._itemViewContextMenu);
          if (value === view_mode.DETAILS) {
            const contextMenuView = fileManager._itemView._filesView._views.contextMenuView;
            const getWidgetContainerClassOrig = contextMenuView.getWidgetContainerClass.bind(contextMenuView);
            contextMenuView.getWidgetContainerClass = () => {
              return getWidgetContainerClassOrig() + " " + CSS_CTX_NAMESPACE;
            };
            contextMenuView._renderCore();
          } else {
            this.loadThumbnails();
          }
        });
      }
    },
    transformCommand(item, prefKey) {
      const newItem = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, item), {}, {
        key: prefKey + item.name
      });
      if (newItem.widget) {
        newItem.options = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, newItem.options), {}, {
          onClick: () => {
            const fileManager = this.getFileManager();
            const selected = fileManager.getSelectedItems();
            this.onCommandExec({
              itemData: {
                name: item.name
              },
              fileSystemItem: selected[0]
            });
          }
        });
      }
      return newItem;
    },
    getSepKey(command) {
      return "sep_" + command.key;
    },
    onCurrentDirectoryChanged({
      directory
    }) {
      for (const key in this.toolbarActions) {
        this.toolbarActions[key] = this.getCommandAvailable(key, [{
          fileItem: directory
        }]);
      }
      if (directory.key === file_group.RECYCLEBIN) {
        const fileManager = this.getFileManager();
        fileManager._controller.refresh();
      }
    },
    createProxyCtx(ctxMenu, fromTree = false, cssOptionName = "cssClass") {
      const isContextMenuItemAvailableOrig = ctxMenu._isContextMenuItemAvailable.bind(ctxMenu);
      ctxMenu._isContextMenuItemAvailable = (menuItem, fileItems) => {
        return this.isCommandAvailableProxy(menuItem, fileItems, isContextMenuItemAvailableOrig, fromTree);
      };
      const ctxCssClass = ctxMenu._contextMenu.option(cssOptionName);
      ctxMenu._contextMenu.option(cssOptionName, ctxCssClass + " " + CSS_CTX_NAMESPACE);
    },
    isCommandAvailableProxy(item, fileItems, isCommandAvailableOrig, fromTree = false) {
      let onItem = true;
      if (!fileItems || !fileItems.length) {
        const fileManager = this.getFileManager();
        const curDir = fileManager.getCurrentDirectory();
        fileItems = [{
          fileItem: curDir
        }];
        onItem = false;
      }
      const isAvailable = this.getCommandAvailable(item.name, fileItems, onItem, fromTree);
      if (isAvailable !== null) {
        return isAvailable;
      }
      return isCommandAvailableOrig(item, fileItems);
    },
    getCommandAvailable(command, fileItems, onItem = false, fromTree = false) {
      if (fileItems.find(item => {
        var _item$fileItem;
        return (_item$fileItem = item.fileItem) === null || _item$fileItem === void 0 ? void 0 : _item$fileItem.isParentFolder;
      })) {
        return false;
      }
      const dataItems = fileItems.map(item => {
        var _item$fileItem2;
        return (_item$fileItem2 = item.fileItem) === null || _item$fileItem2 === void 0 ? void 0 : _item$fileItem2.dataItem;
      }).filter(item => !!item);
      let parentDirKey = null;
      if (dataItems.length > 0) {
        var _fileItems$0$parentDi, _fileItems$0$parentDi2;
        parentDirKey = (_fileItems$0$parentDi = fileItems[0].parentDirectory) === null || _fileItems$0$parentDi === void 0 ? void 0 : (_fileItems$0$parentDi2 = _fileItems$0$parentDi.fileItem) === null || _fileItems$0$parentDi2 === void 0 ? void 0 : _fileItems$0$parentDi2.key;
      }
      switch (command) {
        case enum_command.CREATE_DIR:
          return Boolean(dataItems.length === 1 && dataItems[0].isDirectory && !dataItems[0].isGroup && (!onItem || fromTree) && dataItems[0].permission !== drive_permission.READ);
        case enum_command.CREATE_DRIVE:
          return Boolean(dataItems.length === 1 && dataItems[0].isGroup && dataItems[0].key === file_group.MYDRIVE);
        case enum_command.UPLOAD:
          return Boolean(dataItems.length === 1 && dataItems[0].isDirectory && !dataItems[0].isGroup && (!onItem || fromTree) && dataItems[0].permission !== drive_permission.READ);
        case enum_command.RENAME:
          return Boolean(dataItems.length === 1 && !dataItems[0].isGroup && parentDirKey !== file_group.RECYCLEBIN && onItem && (dataItems[0].isDrive && dataItems[0].isOwned || !dataItems[0].isDrive && dataItems[0].permission !== drive_permission.READ));
        case enum_command.SHARED_DRIVE:
          return Boolean(dataItems.length === 1 && dataItems[0].isDrive && onItem && dataItems[0].permission === drive_permission.ADMIN);
        case enum_command.DOWNLOAD:
          return Boolean(onItem && dataItems.length > 0 && !dataItems.find(item => item.isGroup || item.isDrive || parentDirKey === file_group.RECYCLEBIN));
        case enum_command.DELETE:
        case enum_command.COPY:
        case enum_command.MOVE:
          return Boolean(onItem && dataItems.length > 0 && !dataItems.find(item => item.isGroup || item.isDrive || parentDirKey === file_group.RECYCLEBIN || item.permission === drive_permission.READ));
        case enum_command.RESTORE:
          return Boolean(dataItems.length === 1 && parentDirKey === file_group.RECYCLEBIN);
        case enum_command.REFRESH:
          return Boolean(!onItem || fromTree || !dataItems.find(item => !item.isGroup));
      }
      return null;
    },
    async onCreateDrive(data) {
      this.visibleCreateDriveDialog = false;
      const imageUrl = this.getIconByFileItem({
        dataItem: Object(objectSpread2["a" /* default */])({
          isDrive: true
        }, data)
      });
      const driveName = data === null || data === void 0 ? void 0 : data.name;
      this.runCustomNotifyAction({
        operationMessage: Object(localization_["formatMessage"])("dxFileManager-newDriveAction", driveName),
        operationDetails: {
          commonText: driveName,
          imageUrl
        },
        completeMessage: Object(localization_["formatMessage"])("dxFileManager-newDriveComplete", driveName),
        errorMessage: Object(localization_["formatMessage"])("dxFileManager-newDriveErr", driveName),
        errorDetail: {
          commonErrorText: Object(localization_["formatMessage"])("dxFileManager-newDriveErrCommon"),
          detailErrorText: Object(localization_["formatMessage"])("dxFileManager-errorDefault")
        },
        action: async () => {
          await create_drive(data);
        }
      });
    },
    async onEditPermissionsDrive(data) {
      const dataItem = this.editablePermissionsDrive;
      this.editablePermissionsDrive = null;
      const imageUrl = this.getIconByFileItem({
        dataItem
      });
      const driveName = dataItem.name;
      this.runCustomNotifyAction({
        operationMessage: Object(localization_["formatMessage"])("dxFileManager-sharedDriveAction", driveName),
        operationDetails: {
          commonText: driveName,
          imageUrl
        },
        completeMessage: Object(localization_["formatMessage"])("dxFileManager-sharedDriveComplete", driveName),
        errorMessage: Object(localization_["formatMessage"])("dxFileManager-sharedDriveErr", driveName),
        errorDetail: {
          commonErrorText: Object(localization_["formatMessage"])("dxFileManager-sharedDriveErrCommon"),
          detailErrorText: Object(localization_["formatMessage"])("dxFileManager-errorDefault")
        },
        action: async () => {
          await set_shared_drive(dataItem, data);
        }
      });
    },
    async showRestoreItemPopup() {
      var _choosingDir$folder;
      const fileManager = this.getFileManager();
      const selections = fileManager.getSelectedItems();
      if (!selections.length) {
        return;
      }
      const fileItem = selections[0];
      const items = await fileManager._controller._getCurrentItemsInternal();
      const file = items.find(item => item.fileItem === fileItem);
      const dialogManager = fileManager._editing._dialogManager;
      const choosingDir = await show_proxy_dialog(dialogManager.getMoveDialog([file]), {
        title: Object(localization_["formatMessage"])("dxFileManager-restorePopupChooseTitle"),
        buttonTxt: Object(localization_["formatMessage"])("dxFileManager-restorePopupChooseBtn")
      });
      if (!choosingDir) {
        return;
      }
      const destFileItem = (_choosingDir$folder = choosingDir.folder) === null || _choosingDir$folder === void 0 ? void 0 : _choosingDir$folder.fileItem;
      const destName = destFileItem === null || destFileItem === void 0 ? void 0 : destFileItem.name;
      const updatingName = await show_proxy_dialog(dialogManager.getRenameItemDialog(), {
        title: Object(localization_["formatMessage"])("dxFileManager-restorePopupRenameTitle"),
        buttonTxt: Object(localization_["formatMessage"])("dxFileManager-restorePopupRenameBtn"),
        showProps: fileItem.name
      });
      if (!updatingName) {
        return;
      }
      const newName = updatingName.name;
      fileManager._clearSelection();
      const imageUrl = this.getIconByFileItem(fileItem);
      this.runCustomNotifyAction({
        operationMessage: Object(localization_["formatMessage"])("dxFileManager-restoreAction", destName),
        operationDetails: {
          commonText: newName,
          imageUrl
        },
        completeMessage: Object(localization_["formatMessage"])("dxFileManager-restoreComplete", destName),
        errorMessage: Object(localization_["formatMessage"])("dxFileManager-restoreErr", destName),
        errorDetail: {
          commonErrorText: Object(localization_["formatMessage"])("dxFileManager-restoreErrCommon"),
          detailErrorText: Object(localization_["formatMessage"])("dxFileManager-errorDefault")
        },
        action: async () => {
          await restore_item(fileItem, destFileItem, newName);
        }
      });
    },
    onCommandExec({
      itemData,
      fileSystemItem
    }) {
      if (!(itemData !== null && itemData !== void 0 && itemData.name)) {
        return;
      }
      switch (itemData.name) {
        case enum_command.CREATE_DRIVE:
          this.visibleCreateDriveDialog = true;
          break;
        case enum_command.RESTORE:
          this.showRestoreItemPopup();
          break;
        case enum_command.SHARED_DRIVE:
          this.editablePermissionsDrive = fileSystemItem === null || fileSystemItem === void 0 ? void 0 : fileSystemItem.dataItem;
          break;
      }
    },
    async runCustomNotifyAction({
      operationMessage,
      operationDetails,
      completeMessage,
      errorMessage,
      errorDetail,
      action,
      withoutUpdate
    }) {
      const fileManager = this.getFileManager();
      const notifications = fileManager._notificationControl;
      const info = notifications.addOperation(operationMessage);
      const itemIndex = 0;
      notifications.addOperationDetails(info, [Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, operationDetails), {}, {
        info
      })]);
      try {
        await action();
        notifications.completeOperationItem(info, itemIndex);
        notifications.completeOperation(info, completeMessage);
        if (!withoutUpdate) {
          await fileManager._controller.refresh();
          fileManager._filesTreeView.refresh();
        }
      } catch {
        notifications.addOperationDetailsError(info, Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, errorDetail), {}, {
          itemIndex
        }));
        notifications.completeOperation(info, errorMessage, true);
      }
    },
    loadThumbnails() {
      const fileManager = this.$refs.fileManager.instance;
      const itemList = fileManager._itemView._itemList;
      const renderOrig = itemList._render.bind(itemList);
      itemList._render = () => {
        renderOrig();
        const items = itemList._getItems();
        for (const item of items) {
          var _item$fileItem3;
          const dataItem = (_item$fileItem3 = item.fileItem) === null || _item$fileItem3 === void 0 ? void 0 : _item$fileItem3.dataItem;
          if (!(dataItem !== null && dataItem !== void 0 && dataItem.isDirectory) && !(dataItem !== null && dataItem !== void 0 && dataItem.isDeletedDirectory)) {
            const el = itemList.getItemElementByItem(item);
            if (el.length) {
              get_thumbnail(item.fileItem, el[0]);
            }
          }
        }
      };
    },
    getIconByFileItem(fileItem, icon = "far fa-folder") {
      var _fileItem$dataItem, _fileItem$dataItem2, _fileItem$dataItem3, _fileItem$dataItem4;
      if ((_fileItem$dataItem = fileItem.dataItem) !== null && _fileItem$dataItem !== void 0 && _fileItem$dataItem.isGroup) {
        switch ((_fileItem$dataItem2 = fileItem.dataItem) === null || _fileItem$dataItem2 === void 0 ? void 0 : _fileItem$dataItem2.key) {
          case file_group.MYDRIVE:
            icon = "far fa-server";
            break;
          case file_group.SHARED:
            icon = "far fa-users";
            break;
          case file_group.RECYCLEBIN:
            icon = "far fa-trash";
            break;
        }
      } else if ((_fileItem$dataItem3 = fileItem.dataItem) !== null && _fileItem$dataItem3 !== void 0 && _fileItem$dataItem3.isDrive) {
        icon = "far fa-hdd";
        if (fileItem.dataItem.isCrypted) {
          icon += " crypted-drive";
        }
      } else if ((_fileItem$dataItem4 = fileItem.dataItem) !== null && _fileItem$dataItem4 !== void 0 && _fileItem$dataItem4.isDeletedDirectory) {
        icon = "far fa-folder";
      }
      return icon;
    },
    async onSelectedFileOpened({
      file
    }) {
      const fileManager = this.getFileManager();
      const curDir = fileManager.getCurrentDirectory();
      if (curDir.key === file_group.RECYCLEBIN) {
        return;
      }
      const list = await fileManager._controller.getCurrentItems();
      this.$emit("file-opened", {
        file: file === null || file === void 0 ? void 0 : file.dataItem,
        dirItems: list.map(item => {
          var _item$fileItem4;
          return (_item$fileItem4 = item.fileItem) === null || _item$fileItem4 === void 0 ? void 0 : _item$fileItem4.dataItem;
        })
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/file-storage/vis-file-storage.vue?vue&type=script&lang=js&
 /* harmony default export */ var file_storage_vis_file_storagevue_type_script_lang_js_ = (vis_file_storagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/file-storage/vis-file-storage.vue?vue&type=style&index=0&id=79755521&prod&lang=scss&
var vis_file_storagevue_type_style_index_0_id_79755521_prod_lang_scss_ = __webpack_require__("7629");

// CONCATENATED MODULE: ./src/components/file-storage/vis-file-storage.vue






/* normalize component */

var vis_file_storage_component = Object(componentNormalizer["a" /* default */])(
  file_storage_vis_file_storagevue_type_script_lang_js_,
  vis_file_storagevue_type_template_id_79755521_render,
  vis_file_storagevue_type_template_id_79755521_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_file_storage = (vis_file_storage_component.exports);
// EXTERNAL MODULE: ./src/components/file-storage/localization/ru.json
var ru = __webpack_require__("a558");

// EXTERNAL MODULE: ./src/components/file-storage/localization/en.json
var en = __webpack_require__("6c28");

// CONCATENATED MODULE: ./src/components/file-storage/localization/index.js


/* harmony default export */ var localization = ({
  ru: ru,
  en: en
});
// CONCATENATED MODULE: ./src/components/file-storage/index.js



Object(localization_["loadMessages"])(localization);

// CONCATENATED MODULE: ./src/components/index.js



/***/ }),

/***/ "2b03":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/list");

/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2cb3":
/***/ (function(module, exports) {

module.exports = require("devextreme/localization");

/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3511":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "365c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ visary_api["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ filestorage_api; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ map_api; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ osm_api["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ gistracker_api["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ signalr; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ profile_api; });

// EXTERNAL MODULE: ./src/api/visary-api/index.js + 5 modules
var visary_api = __webpack_require__("9252");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: ./src/utils/configure-params-serializer.js
var configure_params_serializer = __webpack_require__("d49b");

// CONCATENATED MODULE: ./src/api/filestorage-api/repository.js


let axiosInstance = null;
const configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  axiosInstance = axios;
};
/* harmony default export */ var repository = ({
  get instance() {
    if (!axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return axiosInstance;
  }
});
// EXTERNAL MODULE: external "devextreme/core/utils/dependency_injector"
var dependency_injector_ = __webpack_require__("2214");
var dependency_injector_default = /*#__PURE__*/__webpack_require__.n(dependency_injector_);

// CONCATENATED MODULE: ./src/api/filestorage-api/info.js


/* harmony default export */ var info = (dependency_injector_default()({
  getInfo: async (cancelToken = null) => (await repository.instance.get(`info/current`, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/filestorage-api/drives.js


/* harmony default export */ var drives = (dependency_injector_default()({
  getDrives: async ({
    isFavorite,
    isPrimary,
    isOwned,
    isTotalCount,
    driveId,
    owner,
    skip,
    take,
    desc,
    order
  } = {}, cancelToken = null) => (await repository.instance.get(`drives`, {
    cancelToken,
    params: {
      is_favorite: isFavorite,
      is_primary: isPrimary,
      is_owned: isOwned,
      drive_id: driveId,
      owner,
      skip,
      take,
      total_count: isTotalCount,
      desc,
      order
    }
  })).data,
  getDriveById: async (driveId, cancelToken = null) => (await repository.instance.get(`drives/by_id/${driveId}`, {
    cancelToken
  })).data,
  createDrive: async ({
    isCrypted,
    hasHistory,
    hasRecycleBin,
    name,
    label,
    permissions,
    itemsDefaultPermissions
  } = {}, cancelToken = null) => (await repository.instance.post(`drives`, {
    HasHistory: hasHistory,
    HasRecycleBin: hasRecycleBin,
    IsCrypted: isCrypted,
    ItemsDefaultPermissions: itemsDefaultPermissions || [],
    Label: label,
    Name: name,
    Permissions: permissions || []
  }, {
    cancelToken
  })).data,
  renameDrive: async (driveId, newName, cancelToken = null) => (await repository.instance.put(`drives/by_id/${driveId}/name`, {
    customName: newName
  }, {
    cancelToken
  })).data,
  updateDrive: async ({
    id,
    name,
    label,
    permissions,
    itemsDefaultPermissions
  } = {}, cancelToken = null) => (await repository.instance.put(`drives/by_id/${id}/edit`, {
    id,
    name,
    label,
    permissions,
    itemsDefaultPermissions: itemsDefaultPermissions || []
  }, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/filestorage-api/items.js


/* harmony default export */ var filestorage_api_items = (dependency_injector_default()({
  getItems: async ({
    driveId,
    directoryId,
    take,
    skip,
    totalCount,
    order,
    desc,
    orderDirectory,
    type
  } = {}, cancelToken = null) => (await repository.instance.get(`items`, {
    cancelToken,
    params: {
      drive_id: driveId,
      directory_id: directoryId,
      take,
      skip,
      total_count: totalCount,
      order,
      desc,
      order_directory: orderDirectory,
      type
    }
  })).data,
  createDirectory: async ({
    driveId,
    directoryId,
    name
  } = {}, cancelToken = null) => (await repository.instance.post(`items`, {
    Name: name
  }, {
    cancelToken,
    params: {
      drive_id: driveId,
      directory_id: directoryId
    }
  })).data,
  deleteItem: async ({
    driveId,
    items,
    force
  } = {}, cancelToken = null) => (await repository.instance.delete(`items`, {
    cancelToken,
    params: {
      drive_id: driveId
    },
    data: {
      items,
      force
    }
  })).data,
  rename: async ({
    driveId,
    itemId,
    name
  } = {}, cancelToken = null) => (await repository.instance.post(`items/rename`, {
    newName: name
  }, {
    cancelToken,
    params: {
      drive_id: driveId,
      item_id: itemId
    }
  })).data,
  move: async ({
    driveId,
    directoryId,
    items
  } = {}, cancelToken = null) => (await repository.instance.post(`items/move`, {
    items
  }, {
    cancelToken,
    params: {
      drive_id: driveId,
      directory_id: directoryId
    }
  })).data,
  copy: async ({
    driveId,
    directoryId,
    items
  } = {}, cancelToken = null) => (await repository.instance.post(`items/copy`, {
    items
  }, {
    cancelToken,
    params: {
      drive_id: driveId,
      directory_id: directoryId
    }
  })).data,
  getDeletedItems: async ({
    totalCount,
    take,
    skip,
    order,
    desc
  } = {}, cancelToken = null) => (await repository.instance.get(`items/deleted`, {
    params: {
      total_count: totalCount,
      take,
      skip,
      order,
      desc
    },
    cancelToken
  })).data,
  restoreItem: async ({
    id,
    driveId,
    newDirectoryId,
    newName
  } = {}, cancelToken = null) => (await repository.instance.post(`items/deleted/restore`, {
    id,
    driveId,
    newDirectoryId,
    newName
  }, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/filestorage-api/file.js


/* harmony default export */ var file = (dependency_injector_default()({
  upload: async ({
    driveId,
    directoryId,
    fileData
  } = {}, cancelToken = null) => (await repository.instance.post(`files/upload`, (() => {
    const formData = new FormData();
    formData.append('upload', fileData);
    return formData;
  })(), {
    cancelToken,
    params: {
      drive_id: driveId,
      directory_id: directoryId
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })).data,
  download: async ({
    driveId,
    itemId
  } = {}, cancelToken = null) => (await repository.instance.get(`files/download`, {
    cancelToken,
    responseType: 'blob',
    params: {
      drive_id: driveId,
      item_id: itemId
    }
  })).data
}));
// EXTERNAL MODULE: ./src/api/filestorage-api/link.js
var filestorage_api_link = __webpack_require__("1d41");
var link_default = /*#__PURE__*/__webpack_require__.n(filestorage_api_link);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./src/utils/timeout.js
var timeout = __webpack_require__("0f0f");

// CONCATENATED MODULE: ./src/enum/preview-size.js
/* harmony default export */ var preview_size = (Object.freeze({
  SMALL: "s",
  MIDDLE: "m",
  LARGE: "l"
}));
// CONCATENATED MODULE: ./src/api/filestorage-api/preview.js






const DEFAULT_TIMEOUT_ATTEMPT = 2000;
const DEFAULT_MAX_COUNT_ATTEMPT = 3;
async function downloadPreview({
  driveId,
  itemId,
  size,
  timeoutAttempt,
  maxCountAttempt
} = {}, cancelToken = null) {
  var _timeoutAttempt, _maxCountAttempt;
  timeoutAttempt = (_timeoutAttempt = timeoutAttempt) !== null && _timeoutAttempt !== void 0 ? _timeoutAttempt : DEFAULT_TIMEOUT_ATTEMPT;
  maxCountAttempt = (_maxCountAttempt = maxCountAttempt) !== null && _maxCountAttempt !== void 0 ? _maxCountAttempt : DEFAULT_MAX_COUNT_ATTEMPT;
  const res = await repository.instance.get(`/preview/download`, {
    cancelToken,
    responseType: "arraybuffer",
    params: {
      drive_id: driveId,
      item_id: itemId,
      size: size || preview_size.MIDDLE
    }
  });
  if (res.status === 200) {
    return {
      data: res.data,
      type: res.headers["content-type"]
    };
  }
  if (res.status !== 202 || !maxCountAttempt) {
    throw new Error(`Preview is not loaded. Status: ${res.status}`);
  }
  await Object(timeout["a" /* default */])(timeoutAttempt);
  return downloadPreview(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, arguments[0]), {}, {
    timeoutAttempt: timeoutAttempt * 2,
    maxCountAttempt: maxCountAttempt - 1
  }), cancelToken);
}
/* harmony default export */ var preview = (dependency_injector_default()({
  downloadPreview
}));
// CONCATENATED MODULE: ./src/api/filestorage-api/index.js







/* harmony default export */ var filestorage_api = ({
  configure: configure,
  info: info,
  drives: drives,
  items: filestorage_api_items,
  file: file,
  link: link_default.a,
  preview: preview
});
// CONCATENATED MODULE: ./src/api/map-api/repository.js


let repository_axiosInstance = null;
const repository_configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  repository_axiosInstance = axios;
};
/* harmony default export */ var map_api_repository = ({
  get instance() {
    if (!repository_axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return repository_axiosInstance;
  }
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// CONCATENATED MODULE: ./src/api/map-api/converters.js

function convertSputnikSearchResponse(response) {
  const {
    result
  } = response;
  if (!result) return [];
  const {
    address
  } = result;
  const ret = [];
  (address || []).forEach(({
    type,
    features
  }) => {
    if (type === "FeatureCollection" && Array.isArray(features)) {
      Array.prototype.push.apply(ret, features.map(convertSputnikSearchItem));
    }
  });
  return ret.filter(item => !!item);
}
function convertSputnikSearchItem({
  properties,
  geometry
}) {
  geometry = geometry.type === "GeometryCollection" ? geometry.geometries[0] : geometry;
  if (!geometry) return null;
  return {
    title: properties.title,
    description: properties.description,
    geometry,
    type: properties.type
  };
}
function convertOsmSearchResponse(response) {
  if (Array.isArray(response)) {
    return response.map(convertOsmSearchItem);
  } else if (response) {
    return [convertOsmSearchItem(response)];
  }
  return [];
}

// eslint-disable-next-line camelcase
function convertOsmSearchItem({
  display_name,
  type,
  lat,
  lon
}) {
  return {
    title: display_name,
    description: null,
    geometry: {
      type: "Point",
      coordinates: [parseFloat(lon), parseFloat(lat)]
    },
    type: convertOsmSearchResultType(type)
  };
}
const searchResultType = Object.freeze({
  Admin: "admin",
  District: "district",
  Place: "place",
  Region: "region",
  Country: "country"
});
const osmSearchResultType = Object.freeze({
  Town: "town",
  City: "city",
  Administrative: "administrative"
});
const osmSearchResultTypeMap = {
  [osmSearchResultType.City]: searchResultType.Region,
  [osmSearchResultType.Town]: searchResultType.Region,
  [osmSearchResultType.Administrative]: searchResultType.Country
};
function convertOsmSearchResultType(osmType) {
  return osmSearchResultTypeMap[osmType];
}
// CONCATENATED MODULE: ./src/api/map-api/search.js



/* harmony default export */ var search = (dependency_injector_default()({
  searchQuery: async (query, limit = 10, cancelToken = null) => convertOsmSearchResponse((await map_api_repository.instance.get(`search`, {
    baseURL: "https://nominatim.openstreetmap.org",
    cancelToken,
    params: {
      q: query,
      format: "json",
      limit,
      polygon_geojson: 0,
      "accept-language": "ru_RU",
      _noAuth: true
    }
  })).data),
  reverseSearch: async (latlng, houses = undefined, zoom = undefined, cancelToken = null) => convertOsmSearchResponse((await map_api_repository.instance.get(`reverse`, {
    baseURL: "https://nominatim.openstreetmap.org",
    cancelToken,
    params: {
      format: "json",
      lat: latlng[0] != null ? latlng[0] : undefined,
      lon: latlng[1] != null ? latlng[1] : undefined,
      zoom: undefined,
      "accept-language": "ru_RU",
      polygon_geojson: 0,
      _noAuth: true
    }
  })).data)
}));
// CONCATENATED MODULE: ./src/api/map-api/index.js


/* harmony default export */ var map_api = ({
  configure: repository_configure,
  search: search
});
// EXTERNAL MODULE: ./src/api/osm-api/index.js + 4 modules
var osm_api = __webpack_require__("195c");

// EXTERNAL MODULE: ./src/api/gistracker-api/index.js + 2 modules
var gistracker_api = __webpack_require__("fac5");

// EXTERNAL MODULE: ./src/api/signalr/tracker-hub.js
var tracker_hub = __webpack_require__("b0e9");

// CONCATENATED MODULE: ./src/api/signalr/index.js

/* harmony default export */ var signalr = ({
  trackerHub: tracker_hub
});
// CONCATENATED MODULE: ./src/api/profile-api/repository.js


let profile_api_repository_axiosInstance = null;
const profile_api_repository_configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  profile_api_repository_axiosInstance = axios;
};
/* harmony default export */ var profile_api_repository = ({
  get instance() {
    if (!profile_api_repository_axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return profile_api_repository_axiosInstance;
  }
});
// CONCATENATED MODULE: ./src/api/profile-api/user.js


/* harmony default export */ var user = (dependency_injector_default()({
  getUsers: async ({
    filter,
    select,
    skip,
    take,
    sort,
    ids
  } = {}, cancelToken = null) => (await profile_api_repository.instance.get(`list/person`, {
    cancelToken,
    params: {
      filter,
      select,
      start: skip,
      count: take,
      sort: sort || "nickName:asc",
      ids
    }
  })).data,
  getUserById: async (userId, cancelToken = null) => (await profile_api_repository.instance.get(`crud/person/${userId}`, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/profile-api/group.js


/* harmony default export */ var group = (dependency_injector_default()({
  getGroups: async ({
    filter,
    select,
    skip,
    take,
    sort,
    ids
  } = {}, cancelToken = null) => (await profile_api_repository.instance.get(`group/getall`, {
    params: {
      filter,
      select,
      start: skip,
      count: take,
      sort: sort || "title:asc",
      ids
    },
    cancelToken
  })).data,
  getGroupById: async (groupId, cancelToken = null) => (await profile_api_repository.instance.get(`groupcrud/${groupId}`, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/profile-api/index.js



/* harmony default export */ var profile_api = ({
  configure: profile_api_repository_configure,
  user: user,
  group: group
});
// CONCATENATED MODULE: ./src/api/index.js









/***/ }),

/***/ "3775":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3a34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var isArray = __webpack_require__("e8b5");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3b7e":
/***/ (function(module, exports) {

module.exports = require("devextreme/file_management/custom_provider");

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3c5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var ArrayBufferViewCore = __webpack_require__("ebb5");
var lengthOfArrayLike = __webpack_require__("07fa");
var toOffset = __webpack_require__("182d");
var toIndexedObject = __webpack_require__("7b0b");
var fails = __webpack_require__("d039");

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ "4022":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/form");

/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "4b11":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "52f9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5411":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/toolbar");

/***/ }),

/***/ "5530":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("14d9");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ade3");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.26.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "58cc":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/load-indicator");

/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5aa8":
/***/ (function(module, exports) {

module.exports = require("devextreme/data/custom_store");

/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "689e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"907b593e-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-tree-layer.vue?vue&type=template&id=65af0e18&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isGroupLayer(_vm.itemData) ? _c('v-map-group-layer', {
    attrs: {
      "title": _vm.itemData.title,
      "expanded": _vm.itemData.expanded,
      "disabled": _vm.itemData.disabled,
      "styles": _vm.itemData.styles
    },
    scopedSlots: _vm._u([_vm.itemData.iconName ? {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.itemData.iconName
        })];
      },
      proxy: true
    } : null], null, true)
  }, _vm._l(_vm.itemData.children, function (item) {
    return _c('vis-map-tree-layer', {
      key: item.id,
      attrs: {
        "item-data": item
      },
      on: {
        "popup:details": function ($event) {
          return _vm.$emit('popup:details', $event);
        },
        "popup:edit": function ($event) {
          return _vm.$emit('popup:edit', $event);
        },
        "popup:delete": function ($event) {
          return _vm.$emit('popup:delete', $event);
        },
        "popup:action": function ($event) {
          return _vm.$emit('popup:action', $event);
        },
        "filter": function ($event) {
          return _vm.$emit('filter', $event);
        },
        "count:click": function ($event) {
          return _vm.$emit('count:click', $event);
        },
        "count:changed": function ($event) {
          return _vm.$emit('count:changed', $event);
        },
        "cluster:count": function ($event) {
          return _vm.$emit('cluster:count', $event);
        },
        "clientcluster:count": function ($event) {
          return _vm.$emit('clientcluster:count', $event);
        },
        "editor:create": function ($event) {
          return _vm.$emit('editor:create', $event);
        },
        "editor:edit": function ($event) {
          return _vm.$emit('editor:edit', $event);
        },
        "editor:delete": function ($event) {
          return _vm.$emit('editor:delete', $event);
        },
        "editor:data": function ($event) {
          return _vm.$emit('editor:data', $event);
        },
        "editor:popupedit": function ($event) {
          return _vm.$emit('editor:popupedit', $event);
        },
        "object:edited": function ($event) {
          return _vm.$emit('object:edited', $event);
        },
        "object:editstart": function ($event) {
          return _vm.$emit('object:editstart', $event);
        },
        "object:editend": function ($event) {
          return _vm.$emit('object:editend', $event);
        },
        "object:delete": function ($event) {
          return _vm.$emit('object:delete', $event);
        },
        "tracker:follow": function ($event) {
          return _vm.$emit('tracker:follow', $event);
        }
      },
      scopedSlots: _vm._u([{
        key: "popup-other-content",
        fn: function ({
          layerId,
          layerType,
          content
        }) {
          return [_vm._t("popup-other-content", null, {
            "content": content,
            "layerId": layerId,
            "layerType": layerType
          })];
        }
      }, {
        key: "popup-toolbar-content",
        fn: function ({
          layerId,
          layerType,
          content
        }) {
          return [_vm._t("popup-toolbar-content", null, {
            "content": content,
            "layerId": layerId,
            "layerType": layerType
          })];
        }
      }], null, true)
    });
  }), 1) : _vm.isEmptyLayer(_vm.itemData) ? _c('v-map-empty-layer', {
    attrs: {
      "title": _vm.itemData.title,
      "visible": _vm.itemData.visible,
      "selected": _vm.itemData.selected,
      "selection": _vm.itemData.selection,
      "disabled": _vm.itemData.disabled,
      "filtering": _vm.itemData.filtering,
      "filter-active": _vm.itemData.filterActive,
      "styles": _vm.itemData.styles
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.itemData, "visible", $event);
      },
      "update:selected": function ($event) {
        return _vm.$set(_vm.itemData, "selected", $event);
      },
      "filter": _vm.onFilter,
      "count:click": _vm.onCountPressed
    },
    scopedSlots: _vm._u([_vm.itemData.iconName ? {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.itemData.iconName
        })];
      },
      proxy: true
    } : null], null, true)
  }) : _vm.isClientLayer(_vm.itemData) ? _c('v-map-client-layer', {
    attrs: {
      "id": _vm.itemData.id,
      "title": _vm.itemData.title,
      "visible": _vm.itemData.visible,
      "selected": _vm.itemData.selected,
      "selection": _vm.itemData.selection,
      "invalidate": _vm.itemData.invalidate,
      "count": _vm.itemData.count,
      "disabled": _vm.itemData.disabled,
      "filtering": _vm.itemData.filtering,
      "filter-active": _vm.itemData.filterActive,
      "clustering": _vm.itemData.clustering,
      "cluster-animation": _vm.itemData.clusterAnimation,
      "use-super-cluster": _vm.itemData.useSuperCluster,
      "super-cluster-options": _vm.itemData.superClusterOptions,
      "data-source": _vm.itemData.dataSource,
      "styles": _vm.itemData.styles,
      "center-marker": _vm.itemData.centerMarker
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.itemData, "visible", $event);
      },
      "update:selected": function ($event) {
        return _vm.$set(_vm.itemData, "selected", $event);
      },
      "update:invalidate": function ($event) {
        return _vm.$set(_vm.itemData, "invalidate", $event);
      },
      "filter": _vm.onFilter,
      "count:click": _vm.onCountPressed,
      "update:count": _vm.onCountChanged,
      "cluster:count": _vm.onClientClusterCountPressed
    },
    scopedSlots: _vm._u([_vm.itemData.iconName ? {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.itemData.iconName
        })];
      },
      proxy: true
    } : null, {
      key: "popup",
      fn: function () {
        return [_c('v-map-popup', {
          ref: "popup",
          on: {
            "close": _vm.onPopupClose
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              content
            }) {
              return [_c('v-map-popup-content', {
                attrs: {
                  "title": content.title,
                  "description": content.description,
                  "icon-color": _vm.itemData.styles.iconColor,
                  "show-details": "",
                  "show-edit": _vm.itemData.editEnabled,
                  "show-delete": _vm.itemData.editEnabled,
                  "with-confirm-delete": "",
                  "actions": _vm.itemData.popupActions,
                  "actions-open": _vm.popupActionsOpen,
                  "show-confirm-delete": _vm.popupShowConfirmDelete
                },
                on: {
                  "update:actionsOpen": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "update:actions-open": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "update:showConfirmDelete": function ($event) {
                    _vm.popupShowConfirmDelete = $event;
                  },
                  "update:show-confirm-delete": function ($event) {
                    _vm.popupShowConfirmDelete = $event;
                  },
                  "details": function ($event) {
                    return _vm.onPopupDetails(content);
                  },
                  "edit": function ($event) {
                    return _vm.onPopupEdit(content);
                  },
                  "delete": function ($event) {
                    return _vm.onPopupDelete(content);
                  },
                  "action": function ($event) {
                    return _vm.onPopupAction($event, content);
                  }
                },
                scopedSlots: _vm._u([_vm.itemData.iconName ? {
                  key: "icon",
                  fn: function () {
                    return [_c('i', {
                      class: _vm.itemData.iconName
                    })];
                  },
                  proxy: true
                } : null, {
                  key: "action-icon",
                  fn: function ({
                    action
                  }) {
                    return [_c('i', {
                      class: action.icon === 'delete' ? 'fal fa-trash-alt' : action.icon
                    })];
                  }
                }, _vm.$scopedSlots['popup-other-content'] ? {
                  key: "other-content",
                  fn: function () {
                    return [_vm._t("popup-other-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null, _vm.$scopedSlots['popup-toolbar-content'] ? {
                  key: "toolbar-description",
                  fn: function () {
                    return [_vm._t("popup-toolbar-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null], null, true)
              })];
            }
          }])
        })];
      },
      proxy: true
    }], null, true)
  }, [_c('v-map-heatmap-observer', {
    attrs: {
      "enabled": _vm.itemData.heatmapControlEnabled && _vm.itemData.selected,
      "control-visible": _vm.itemData.selected,
      "control-active": _vm.itemData.heatmapActive
    },
    on: {
      "update:controlActive": function ($event) {
        return _vm.$set(_vm.itemData, "heatmapActive", $event);
      },
      "update:control-active": function ($event) {
        return _vm.$set(_vm.itemData, "heatmapActive", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        active
      }) {
        return [_c('v-map-heatmap-handler', {
          attrs: {
            "visible": active,
            "max-zoom": _vm.itemData.heatmapMaxZoom,
            "min-opacity": _vm.itemData.heatmapMinOpacity,
            "radius": _vm.itemData.heatmapRadius,
            "blur": _vm.itemData.heatmapBlur,
            "max-intensity": _vm.itemData.heatmapMaxIntensity,
            "gradient": _vm.itemData.heatmapGradient
          }
        })];
      }
    }])
  }), _vm.itemData.editEnabled && _vm.itemData.selected ? _c('v-map-edit-handler', {
    ref: "editor",
    attrs: {
      "creation-shapes": _vm.itemData.creationShapes,
      "data-source": _vm.itemData.editDataSource,
      "popup-icon-color": _vm.itemData.styles.iconColor,
      "can-edit": _vm.itemData.canEdit,
      "can-create": _vm.itemData.canCreate
    },
    on: {
      "create": _vm.onEditorCreate,
      "edit": _vm.onEditorEdit,
      "delete": _vm.onEditorDelete,
      "data": _vm.onEditorData
    },
    scopedSlots: _vm._u([{
      key: "popup",
      fn: function () {
        return [_c('v-map-popup', {
          attrs: {
            "class-name": "vis-map-editor-popup"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              content
            }) {
              return [_c('v-map-popup-content', {
                attrs: {
                  "title": content.title,
                  "description": content.address,
                  "icon-color": _vm.itemData.styles.iconColor,
                  "show-edit": !content.address,
                  "edit-title": _vm.editorPopupEditTitle
                },
                on: {
                  "edit": function ($event) {
                    return _vm.onEditorPopupEdit(content);
                  }
                },
                scopedSlots: _vm._u([_vm.itemData.iconName ? {
                  key: "icon",
                  fn: function () {
                    return [_c('i', {
                      class: _vm.itemData.iconName
                    })];
                  },
                  proxy: true
                } : null], null, true)
              })];
            }
          }], null, false, 3752897087)
        })];
      },
      proxy: true
    }], null, false, 396499108)
  }) : _vm._e(), _vm.itemData.picketEnabled ? _c('v-map-picket-handler', {
    attrs: {
      "show-closest-pickets": "",
      "show-target-title": _vm.itemData.picketTargetTitleShown,
      "data-source": _vm.itemData.picketDataSource
    }
  }) : _vm._e(), _c('v-map-edit-object-handler', {
    on: {
      "edited": _vm.onObjectEdited,
      "edit-start": _vm.onObjectEditStart,
      "edit-end": _vm.onObjectEditEnd
    }
  }), _c('v-map-delete-object-handler', {
    on: {
      "delete": _vm.onObjectDelete
    }
  }), _vm.itemData.showLineEdges ? _c('v-map-line-point-handler', {
    attrs: {
      "show-edge-points": ""
    }
  }) : _vm._e()], 1) : _vm.isServerLayer(_vm.itemData) ? _c('v-map-server-layer', {
    attrs: {
      "id": _vm.itemData.id,
      "title": _vm.itemData.title,
      "visible": _vm.itemData.visible,
      "selected": _vm.itemData.selected,
      "selection": _vm.itemData.selection,
      "invalidate": _vm.itemData.invalidate,
      "count-invalidate": _vm.itemData.countInvalidate,
      "count": _vm.itemData.count,
      "disabled": _vm.itemData.disabled,
      "filtering": _vm.itemData.filtering,
      "filter-active": _vm.itemData.filterActive,
      "clientClustering": _vm.itemData.clientClustering,
      "data-source": _vm.itemData.dataSource,
      "styles": _vm.itemData.styles,
      "center-marker": _vm.itemData.centerMarker
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.itemData, "visible", $event);
      },
      "update:selected": function ($event) {
        return _vm.$set(_vm.itemData, "selected", $event);
      },
      "update:invalidate": function ($event) {
        return _vm.$set(_vm.itemData, "invalidate", $event);
      },
      "update:countInvalidate": function ($event) {
        return _vm.$set(_vm.itemData, "countInvalidate", $event);
      },
      "update:count-invalidate": function ($event) {
        return _vm.$set(_vm.itemData, "countInvalidate", $event);
      },
      "filter": _vm.onFilter,
      "count:click": _vm.onCountPressed,
      "update:count": _vm.onCountChanged,
      "cluster:count": _vm.onClusterCountPressed
    },
    scopedSlots: _vm._u([_vm.itemData.iconName ? {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.itemData.iconName
        })];
      },
      proxy: true
    } : null, {
      key: "popup",
      fn: function () {
        return [_c('v-map-popup', {
          ref: "popup",
          on: {
            "close": _vm.onPopupClose
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              content
            }) {
              return [_c('v-map-popup-content', {
                attrs: {
                  "title": content.title,
                  "description": content.description,
                  "icon-color": _vm.itemData.styles.iconColor,
                  "show-details": "",
                  "show-edit": _vm.itemData.editEnabled,
                  "show-delete": _vm.itemData.editEnabled,
                  "with-confirm-delete": "",
                  "actions": _vm.itemData.popupActions,
                  "actions-open": _vm.popupActionsOpen,
                  "show-confirm-delete": _vm.popupShowConfirmDelete
                },
                on: {
                  "update:actionsOpen": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "update:actions-open": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "update:showConfirmDelete": function ($event) {
                    _vm.popupShowConfirmDelete = $event;
                  },
                  "update:show-confirm-delete": function ($event) {
                    _vm.popupShowConfirmDelete = $event;
                  },
                  "details": function ($event) {
                    return _vm.onPopupDetails(content);
                  },
                  "edit": function ($event) {
                    return _vm.onPopupEdit(content);
                  },
                  "delete": function ($event) {
                    return _vm.onPopupDelete(content);
                  },
                  "action": function ($event) {
                    return _vm.onPopupAction($event, content);
                  }
                },
                scopedSlots: _vm._u([_vm.itemData.iconName ? {
                  key: "icon",
                  fn: function () {
                    return [_c('i', {
                      class: _vm.itemData.iconName
                    })];
                  },
                  proxy: true
                } : null, {
                  key: "action-icon",
                  fn: function ({
                    action
                  }) {
                    return [_c('i', {
                      class: action.icon === 'delete' ? 'fal fa-trash-alt' : action.icon
                    })];
                  }
                }, _vm.$scopedSlots['popup-other-content'] ? {
                  key: "other-content",
                  fn: function () {
                    return [_vm._t("popup-other-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null, _vm.$scopedSlots['popup-toolbar-content'] ? {
                  key: "toolbar-description",
                  fn: function () {
                    return [_vm._t("popup-toolbar-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null], null, true)
              })];
            }
          }])
        })];
      },
      proxy: true
    }], null, true)
  }, [_c('v-map-heatmap-observer', {
    attrs: {
      "enabled": _vm.itemData.heatmapControlEnabled && _vm.itemData.selected,
      "control-visible": _vm.itemData.selected,
      "control-active": _vm.itemData.heatmapActive
    },
    on: {
      "update:controlActive": function ($event) {
        return _vm.$set(_vm.itemData, "heatmapActive", $event);
      },
      "update:control-active": function ($event) {
        return _vm.$set(_vm.itemData, "heatmapActive", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        active
      }) {
        return [_c('v-map-heatmap-handler', {
          attrs: {
            "visible": active,
            "max-zoom": _vm.itemData.heatmapMaxZoom,
            "min-opacity": _vm.itemData.heatmapMinOpacity,
            "radius": _vm.itemData.heatmapRadius,
            "blur": _vm.itemData.heatmapBlur,
            "max-intensity": _vm.itemData.heatmapMaxIntensity,
            "gradient": _vm.itemData.heatmapGradient
          }
        })];
      }
    }])
  }), _vm.itemData.editEnabled && _vm.itemData.selected ? _c('v-map-edit-handler', {
    ref: "editor",
    attrs: {
      "creation-shapes": _vm.itemData.creationShapes,
      "data-source": _vm.itemData.editDataSource,
      "popup-icon-color": _vm.itemData.styles.iconColor,
      "can-edit": _vm.itemData.canEdit,
      "can-create": _vm.itemData.canCreate
    },
    on: {
      "create": _vm.onEditorCreate,
      "edit": _vm.onEditorEdit,
      "delete": _vm.onEditorDelete,
      "data": _vm.onEditorData
    },
    scopedSlots: _vm._u([{
      key: "popup",
      fn: function () {
        return [_c('v-map-popup', {
          attrs: {
            "class-name": "vis-map-editor-popup"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              content
            }) {
              return [_c('v-map-popup-content', {
                attrs: {
                  "title": content.title,
                  "description": content.address,
                  "icon-color": _vm.itemData.styles.iconColor,
                  "show-edit": !content.address,
                  "edit-title": _vm.editorPopupEditTitle
                },
                on: {
                  "edit": function ($event) {
                    return _vm.onEditorPopupEdit(content);
                  }
                },
                scopedSlots: _vm._u([_vm.itemData.iconName ? {
                  key: "icon",
                  fn: function () {
                    return [_c('i', {
                      class: _vm.itemData.iconName
                    })];
                  },
                  proxy: true
                } : null], null, true)
              })];
            }
          }], null, false, 3752897087)
        })];
      },
      proxy: true
    }], null, false, 396499108)
  }) : _vm._e(), _vm.itemData.picketEnabled ? _c('v-map-picket-handler', {
    attrs: {
      "show-closest-pickets": "",
      "show-target-title": _vm.itemData.picketTargetTitleShown,
      "data-source": _vm.itemData.picketDataSource
    }
  }) : _vm._e(), _c('v-map-edit-object-handler', {
    on: {
      "edited": _vm.onObjectEdited,
      "edit-start": _vm.onObjectEditStart,
      "edit-end": _vm.onObjectEditEnd
    }
  }), _c('v-map-delete-object-handler', {
    on: {
      "delete": _vm.onObjectDelete
    }
  }), _vm.itemData.showLineEdges ? _c('v-map-line-point-handler', {
    attrs: {
      "show-edge-points": ""
    }
  }) : _vm._e()], 1) : _vm.isWmsLayer(_vm.itemData) ? _c('v-map-wms-layer', {
    attrs: {
      "id": _vm.itemData.id,
      "title": _vm.itemData.title,
      "visible": _vm.itemData.visible,
      "selected": _vm.itemData.selected,
      "selection": _vm.itemData.selection,
      "disabled": _vm.itemData.disabled,
      "styles": _vm.itemData.styles,
      "wms-url": _vm.itemData.tileOptions.url,
      "wms-layers": _vm.itemData.tileOptions.layers,
      "wms-styles": _vm.itemData.tileOptions.styles,
      "wms-transparent": _vm.itemData.tileOptions.transparent,
      "wms-format": _vm.itemData.tileOptions.format
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.itemData, "visible", $event);
      },
      "update:selected": function ($event) {
        return _vm.$set(_vm.itemData, "selected", $event);
      }
    }
  }) : _vm.isTrackerLayer(_vm.itemData) ? _c('v-map-track-layer', {
    ref: "trackLayer",
    attrs: {
      "id": _vm.itemData.id,
      "title": _vm.itemData.title,
      "visible": _vm.itemData.visible,
      "selected": _vm.itemData.selected,
      "selection": _vm.itemData.selection,
      "invalidate": _vm.itemData.invalidate,
      "count": _vm.itemData.count,
      "disabled": _vm.itemData.disabled,
      "filtering": _vm.itemData.filtering,
      "filter-active": _vm.itemData.filterActive,
      "data-source": _vm.itemData.dataSource,
      "styles": _vm.itemData.styles,
      "tracker-options": {
        usePositionCorrection: true,
        zeroSpeedCorrection: true
      }
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.itemData, "visible", $event);
      },
      "update:selected": function ($event) {
        return _vm.$set(_vm.itemData, "selected", $event);
      },
      "update:invalidate": function ($event) {
        return _vm.$set(_vm.itemData, "invalidate", $event);
      },
      "filter": _vm.onFilter,
      "count:click": _vm.onCountPressed,
      "update:count": _vm.onCountChanged
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_vm.itemData.followTracker ? _c('v-map-follow-handler', {
          on: {
            "follow-start": _vm.onFollowTrackerStart,
            "follow-end": _vm.onFollowTrackerEnd
          }
        }) : _vm._e(), _vm.itemData.tooltipVisible ? _c('v-map-tooltip-handler') : _vm._e()];
      },
      proxy: true
    }, _vm.itemData.iconName ? {
      key: "icon",
      fn: function () {
        return [_c('i', {
          class: _vm.itemData.iconName
        })];
      },
      proxy: true
    } : null, {
      key: "popup",
      fn: function () {
        return [_c('v-map-popup', {
          ref: "popup",
          attrs: {
            "auto-pan": false
          },
          on: {
            "close": _vm.onPopupClose
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              content
            }) {
              return [_c('v-map-popup-content', {
                attrs: {
                  "title": content.title,
                  "description": content.description,
                  "icon-color": _vm.itemData.styles.iconColor,
                  "show-details": "",
                  "actions": _vm.itemData.popupActions,
                  "actions-open": _vm.popupActionsOpen
                },
                on: {
                  "update:actionsOpen": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "update:actions-open": function ($event) {
                    _vm.popupActionsOpen = $event;
                  },
                  "details": function ($event) {
                    return _vm.onPopupDetails(content);
                  },
                  "action": function ($event) {
                    return _vm.onPopupAction($event, content);
                  }
                },
                scopedSlots: _vm._u([_vm.itemData.iconName ? {
                  key: "icon",
                  fn: function () {
                    return [_c('i', {
                      class: _vm.itemData.iconName
                    })];
                  },
                  proxy: true
                } : null, {
                  key: "action-icon",
                  fn: function ({
                    action
                  }) {
                    return [_c('i', {
                      class: action.icon
                    })];
                  }
                }, _vm.$scopedSlots['popup-other-content'] ? {
                  key: "other-content",
                  fn: function () {
                    return [_vm._t("popup-other-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null, _vm.$scopedSlots['popup-toolbar-content'] ? {
                  key: "toolbar-description",
                  fn: function () {
                    return [_vm._t("popup-toolbar-content", null, {
                      "content": content,
                      "layerId": _vm.itemData.id,
                      "layerType": _vm.itemData.type
                    })];
                  },
                  proxy: true
                } : null], null, true)
              })];
            }
          }])
        })];
      },
      proxy: true
    }], null, true)
  }) : _vm._e();
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/vis-map-tree-layer.vue?vue&type=template&id=65af0e18&

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: external "@rosgidromet/visary-map-vue-rgm"
var visary_map_vue_rgm_ = __webpack_require__("d978");

// EXTERNAL MODULE: ./src/components/map/utils/layer-type-enum.js
var layer_type_enum = __webpack_require__("c17c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/vis-map-tree-layer.vue?vue&type=script&lang=js&



/* harmony default export */ var vis_map_tree_layervue_type_script_lang_js_ = ({
  name: "vis-map-tree-layer",
  components: {
    VMapGroupLayer: visary_map_vue_rgm_["VMapGroupLayer"],
    VMapClientLayer: visary_map_vue_rgm_["VMapClientLayer"],
    VMapServerLayer: visary_map_vue_rgm_["VMapServerLayer"],
    VMapTrackLayer: visary_map_vue_rgm_["VMapTrackLayer"],
    VMapEmptyLayer: visary_map_vue_rgm_["VMapEmptyLayer"],
    VMapWmsLayer: visary_map_vue_rgm_["VMapWmsLayer"],
    VMapHeatmapObserver: visary_map_vue_rgm_["VMapHeatmapObserver"],
    VMapHeatmapHandler: visary_map_vue_rgm_["VMapHeatmapHandler"],
    VMapEditHandler: visary_map_vue_rgm_["VMapEditHandler"],
    VMapPopup: visary_map_vue_rgm_["VMapPopup"],
    VMapPopupContent: visary_map_vue_rgm_["VMapPopupContent"],
    VMapPicketHandler: visary_map_vue_rgm_["VMapPicketHandler"],
    VMapFollowHandler: visary_map_vue_rgm_["VMapFollowHandler"],
    VMapEditObjectHandler: visary_map_vue_rgm_["VMapEditObjectHandler"],
    VMapDeleteObjectHandler: visary_map_vue_rgm_["VMapDeleteObjectHandler"],
    VMapTooltipHandler: visary_map_vue_rgm_["VMapTooltipHandler"],
    VMapLinePointHandler: visary_map_vue_rgm_["VMapLinePointHandler"],
    VisMapTreeLayer: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "689e"))
  },
  props: {
    itemData: {
      type: Object,
      required: true
    },
    editorPopupEditTitle: {
      type: String,
      default: "Определить адрес"
    }
  },
  data() {
    return {
      popupActionsOpen: false,
      popupShowConfirmDelete: false
    };
  },
  methods: {
    isGroupLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].GROUP;
    },
    isServerLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].SERVER;
    },
    isClientLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].CLIENT;
    },
    isEmptyLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].NONE;
    },
    isWmsLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].TILE;
    },
    isTrackerLayer({
      type
    }) {
      return type === layer_type_enum["a" /* default */].TRACKER;
    },
    onPopupDetails(data) {
      var _this$$refs$popup;
      this.$emit("popup:details", {
        data,
        layerItem: this.itemData,
        popup: (_this$$refs$popup = this.$refs.popup) === null || _this$$refs$popup === void 0 ? void 0 : _this$$refs$popup.mapObject
      });
    },
    onPopupEdit(data) {
      var _this$$refs$popup2;
      this.$emit("popup:edit", {
        data,
        layerItem: this.itemData,
        popup: (_this$$refs$popup2 = this.$refs.popup) === null || _this$$refs$popup2 === void 0 ? void 0 : _this$$refs$popup2.mapObject
      });
    },
    onPopupDelete(data) {
      var _this$$refs$popup3;
      this.$emit("popup:delete", {
        data,
        layerItem: this.itemData,
        popup: (_this$$refs$popup3 = this.$refs.popup) === null || _this$$refs$popup3 === void 0 ? void 0 : _this$$refs$popup3.mapObject
      });
    },
    onPopupAction(action, data) {
      var _this$$refs$popup4;
      this.$emit("popup:action", {
        action,
        data,
        layerItem: this.itemData,
        popup: (_this$$refs$popup4 = this.$refs.popup) === null || _this$$refs$popup4 === void 0 ? void 0 : _this$$refs$popup4.mapObject
      });
    },
    onPopupClose() {
      this.popupActionsOpen = false;
      this.popupShowConfirmDelete = false;
    },
    onObjectEdited(e) {
      this.$emit("object:edited", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData
      }));
    },
    onObjectEditStart(e) {
      this.$emit("object:editstart", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData
      }));
    },
    onObjectEditEnd(e) {
      this.$emit("object:editend", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData
      }));
    },
    onObjectDelete(e) {
      this.$emit("object:delete", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData
      }));
    },
    onFilter(e) {
      this.$emit("filter", this.itemData);
    },
    onCountPressed(e) {
      var _this$$refs$trackLaye;
      const layerGroup = (_this$$refs$trackLaye = this.$refs.trackLayer) === null || _this$$refs$trackLaye === void 0 ? void 0 : _this$$refs$trackLaye.getMapObject();
      this.$emit("count:click", this.itemData, layerGroup);
    },
    onCountChanged(value) {
      // eslint-disable-next-line vue/no-mutating-props
      this.itemData.count = value;
      this.$emit("count:changed", {
        layerItem: this.itemData,
        value
      });
    },
    onClusterCountPressed(e) {
      this.$emit("cluster:count", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData,
        preventClick: () => {
          e.preventClick();
        }
      }));
    },
    onClientClusterCountPressed(e) {
      this.$emit("clientcluster:count", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData,
        preventClick: () => {
          e.preventClick();
        }
      }));
    },
    onEditorCreate(e) {
      this.$emit("editor:create", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData,
        editLayerGroup: this.$refs.editor.editLayerGroup
      }));
    },
    onEditorEdit(e) {
      this.$emit("editor:edit", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData,
        editLayerGroup: this.$refs.editor.editLayerGroup
      }));
    },
    onEditorDelete(e) {
      this.$emit("editor:delete", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData
      }));
    },
    onEditorData(e) {
      this.$emit("editor:data", Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, e), {}, {
        layerItem: this.itemData,
        editLayerGroup: this.$refs.editor.editLayerGroup
      }));
    },
    onEditorPopupEdit(data) {
      this.$emit("editor:popupedit", {
        data,
        layerItem: this.itemData
      });
    },
    onFollowTrackerStart() {
      this.$emit("tracker:follow", {
        enabled: true,
        layerItem: this.itemData
      });
    },
    onFollowTrackerEnd() {
      this.$emit("tracker:follow", {
        enabled: false,
        layerItem: this.itemData
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/vis-map-tree-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_vis_map_tree_layervue_type_script_lang_js_ = (vis_map_tree_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/vis-map-tree-layer.vue?vue&type=style&index=0&id=65af0e18&prod&lang=scss&
var vis_map_tree_layervue_type_style_index_0_id_65af0e18_prod_lang_scss_ = __webpack_require__("955f");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/map/vis-map-tree-layer.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  map_vis_map_tree_layervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vis_map_tree_layer = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "69b9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("cdce");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6c28":
/***/ (function(module) {

module.exports = JSON.parse("{\"dxFileManager-rootFolder\":\"File storage\",\"dxFileManager-commandCreateDrive\":\"New drive\",\"dxFileManager-commandSharedDrive\":\"Shared access\",\"dxFileManager-commandRestore\":\"Restore\",\"dxFileManager-groupMyDrives\":\"My drives\",\"dxFileManager-groupShared\":\"Shared\",\"dxFileManager-groupRecycleBin\":\"Network recycle bin\",\"dxFileManager-owner\":\"Author\",\"dxFileManager-ownerUnknown\":\"Unknown\",\"dxFileManager-restorePopupChooseTitle\":\"Restore to\",\"dxFileManager-restorePopupChooseBtn\":\"Restore\",\"dxFileManager-restorePopupRenameTitle\":\"Change name\",\"dxFileManager-restorePopupRenameBtn\":\"Change\",\"dxFileManager-restoreAction\":\"Restoring an item to {0}\",\"dxFileManager-restoreComplete\":\"Restored an item to {0}\",\"dxFileManager-restoreErr\":\"Item was not restored to {0}\",\"dxFileManager-restoreErrCommon\":\"Item was not restored\",\"dxFileManager-dialogSaveBtn\":\"Save\",\"dxFileManager-dialogCancelBtn\":\"Cancel\",\"dxFileManager-newDriveAction\":\"Creation drive {0}\",\"dxFileManager-newDriveComplete\":\"Created an drive {0}\",\"dxFileManager-newDriveErr\":\"Drive {0} was not created\",\"dxFileManager-newDriveErrCommon\":\"Drive was not created\",\"dxFileManager-newDrivePopupTitle\":\"New drive\",\"dxFileManager-newDrivePopupCreateBtn\":\"Create\",\"dxFileManager-newDrivePopupName\":\"Name of drive\",\"dxFileManager-newDrivePopupNameRequired\":\"Name of drive is required\",\"dxFileManager-newDrivePopupCrypted\":\"Crypted\",\"dxFileManager-newDrivePopupHistory\":\"Enable history\",\"dxFileManager-newDrivePopupRecycleBin\":\"Network recycle bin\",\"dxFileManager-newDrivePopupSharedDrive\":\"Shared access\",\"dxFileManager-sharedDrivePopupTitle\":\"Shared access - {0}\",\"dxFileManager-sharedDriveAction\":\"Setting up shared access of {0}\",\"dxFileManager-sharedDriveComplete\":\"Shared access of {0} is configured\",\"dxFileManager-sharedDriveErr\":\"Shared access of {0} was not configured\",\"dxFileManager-sharedDriveErrCommon\":\"Shared access was not configured\",\"dxFileManager-drivePermissionsAll\":\"All\",\"dxFileManager-drivePermissionsAddAccess\":\"Add access\",\"dxFileManager-drivePermissionsChooseProfile\":\"Choose user or group\",\"dxFileManager-drivePermissionsAddBtn\":\"Add\",\"dxFileManager-drivePermissionsCancelBtn\":\"Cancel\",\"dxFileManager-drivePermissionsUsers\":\"Users\",\"dxFileManager-drivePermissionsGroups\":\"Groups\",\"dxFileManager-drivePermissionsUnknownUser\":\"Unknown user\",\"dxFileManager-drivePermissionsUnknownGroup\":\"Unknown group\",\"dxFileManager-drivePermissionsNoData\":\"Access is not configured\",\"dxFileManager-drivePermissionsRead\":\"Read\",\"dxFileManager-drivePermissionsWrite\":\"Write\",\"dxFileManager-drivePermissionsAdmin\":\"Administrator\"}");

/***/ }),

/***/ "6c7d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6e03":
/***/ (function(module, exports) {

module.exports = require("devextreme/data/data_source");

/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7234":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7629":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_file_storage_vue_vue_type_style_index_0_id_79755521_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3775");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_file_storage_vue_vue_type_style_index_0_id_79755521_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_file_storage_vue_vue_type_style_index_0_id_79755521_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7944":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "796d":
/***/ (function(module, exports) {

module.exports = require("qs");

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7d7e":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "7ffb":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/select-box");

/***/ }),

/***/ "81f2":
/***/ (function(module, exports) {

module.exports = require("debounce");

/***/ }),

/***/ "823b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  error: messageOrError => {
    if (console.error) {
      console.error(messageOrError);
    } else if (console.log) {
      console.log(messageOrError);
    }
  },
  info(message, ...args) {
    if (console.info) {
      console.info(message, ...args);
    }
  }
});

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8451":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/popup");

/***/ }),

/***/ "860c":
/***/ (function(module, exports) {

module.exports = require("leaflet");

/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8a06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_vue_vue_type_style_index_0_id_70c83544_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1a63");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_vue_vue_type_style_index_0_id_70c83544_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_vue_vue_type_style_index_0_id_70c83544_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8ea1":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "907a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("ebb5");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIntegerOrInfinity = __webpack_require__("5926");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9252":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: ./src/utils/configure-params-serializer.js
var configure_params_serializer = __webpack_require__("d49b");

// CONCATENATED MODULE: ./src/api/visary-api/repository.js


let axiosInstance = null;
const configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  axiosInstance = axios;
};
/* harmony default export */ var repository = ({
  get instance() {
    if (!axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return axiosInstance;
  }
});
// EXTERNAL MODULE: external "devextreme/core/utils/dependency_injector"
var dependency_injector_ = __webpack_require__("2214");
var dependency_injector_default = /*#__PURE__*/__webpack_require__.n(dependency_injector_);

// CONCATENATED MODULE: ./src/api/visary-api/map.js


/* harmony default export */ var map = (dependency_injector_default()({
  getSettings: async (cancelToken = null, noAuth = false) => (await repository.instance.get(`map/setting`, {
    cancelToken,
    params: {
      _noAuth: noAuth || undefined
    }
  })).data,
  getPreset: async (presetId, cancelToken = null, noAuth = false) => (await repository.instance.get(`map/preset/${presetId}`, {
    cancelToken,
    params: {
      _noAuth: noAuth || undefined
    }
  })).data,
  getLayerConfig: async (mnemonic, cancelToken = null, noAuth = false) => (await repository.instance.get(`maplayer/${mnemonic}`, {
    cancelToken,
    params: {
      _noAuth: noAuth || undefined
    }
  })).data,
  getObjects: async (mnemonic, bbox, zoom, filterQuery, cancelToken = null, noAuth = false, respAsArrayBuffer = false) => (await repository.instance.get(`map_query/${mnemonic}/objects`, {
    cancelToken,
    params: {
      bbox,
      zoom,
      filterQuery,
      _noAuth: noAuth || undefined
    },
    responseType: respAsArrayBuffer ? "arraybuffer" : "json"
  })).data,
  getObjectCount: async (mnemonic, filterQuery, cancelToken = null, noAuth = false) => (await repository.instance.get(`map_query/${mnemonic}/count`, {
    cancelToken,
    params: {
      filterQuery,
      _noAuth: noAuth || undefined
    }
  })).data,
  getObjectsForList: async (mnemonic, page, pageSize, searchString, filterQuery, cancelToken = null, noAuth = false) => (await repository.instance.get(`map_query/${mnemonic}/pages`, {
    cancelToken,
    params: {
      page,
      pageSize,
      searchString,
      filterQuery,
      _noAuth: noAuth || undefined
    }
  })).data,
  getObjectsByCluster: async (clusterId, mnemonic, page, pageSize, searchString, filterQuery, cancelToken = null, noAuth = false) => (await repository.instance.get(`map_query/${mnemonic}/cluster/${clusterId}`, {
    cancelToken,
    params: {
      page,
      pageSize,
      searchString,
      filterQuery,
      _noAuth: noAuth || undefined
    }
  })).data,
  getPicketObjects: async (mnemonic, objectId, cancelToken = null, noAuth = false) => (await repository.instance.get(`picket/${mnemonic}/${objectId}`, {
    cancelToken,
    params: {
      _noAuth: noAuth || undefined
    }
  })).data,
  updateGeometry: async (mnemonic, objectId, geometry, cancelToken = null) => (await repository.instance.post(`map_modify/${mnemonic}/update_disposition/${objectId}`, geometry, {
    cancelToken
  })).data,
  deleteObject: async (mnemonic, objectId, cancelToken = null) => (await repository.instance.delete(`map_modify/${mnemonic}/delete/${objectId}`, {
    cancelToken
  })).data
}));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: external "@mapbox/polyline"
var polyline_ = __webpack_require__("ff9b");
var polyline_default = /*#__PURE__*/__webpack_require__.n(polyline_);

// CONCATENATED MODULE: ./src/api/visary-api/converters.js



function convertSputnikRoutesResponse(response) {
  var _altGeometries, _altSummaries;
  let {
    route_geometry: routeGeometry,
    route_summary: routeSummary,
    alternative_summaries: altSummaries,
    alternative_geometries: altGeometries
  } = response;
  if (!routeGeometry) {
    return [];
  }
  const summary = data => {
    const {
      end_point: endName,
      start_point: startName,
      total_time: totalTime,
      total_distance: totalDistance
    } = data || {};
    return {
      totalDistance,
      totalTime,
      startName,
      endName
    };
  };
  const routes = [];
  const swap = (arr, i1, i2) => {
    const tmp = arr[i1];
    arr[i1] = arr[i2];
    arr[i2] = tmp;
  };
  const toGeoJSON = g => {
    const coordinates = polyline_default.a.decode(g, 6);
    coordinates.forEach(latlng => {
      swap(latlng, 0, 1);
    });
    return {
      type: "LineString",
      coordinates
    };
  };
  routes.push(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, summary(routeSummary)), {}, {
    geometry: toGeoJSON(routeGeometry)
  }));
  altGeometries = (_altGeometries = altGeometries) !== null && _altGeometries !== void 0 ? _altGeometries : [];
  altSummaries = (_altSummaries = altSummaries) !== null && _altSummaries !== void 0 ? _altSummaries : [];
  altGeometries.forEach((altGeometry, i) => {
    routes.push(Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, summary(altSummaries[i])), {}, {
      geometry: toGeoJSON(altGeometry)
    }));
  });
  return routes;
}
// CONCATENATED MODULE: ./src/api/visary-api/routes.js



/* harmony default export */ var visary_api_routes = (dependency_injector_default()({
  findRoutes: async (startLatLng, stopLatLng, cancelToken = null) => convertSputnikRoutesResponse((await repository.instance.get("map_routes/road", {
    params: {
      loc: [`${startLatLng[0]},${startLatLng[1]}`, `${stopLatLng[0]},${stopLatLng[1]}`],
      alt: true
    },
    cancelToken
  })).data)
}));
// CONCATENATED MODULE: ./src/api/visary-api/list-view.js


/* harmony default export */ var list_view = (dependency_injector_default()({
  gridData: async (mnemonic, columns, skip, take, filterQuery, cancelToken = null) => (await repository.instance.post(`listview/${mnemonic}`, {
    Mnemonic: mnemonic,
    Hidden: false,
    Columns: columns,
    PageSkip: skip,
    PageSize: take,
    ExtraFilter: filterQuery
  }, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/visary-api/index.js




/* harmony default export */ var visary_api = __webpack_exports__["a"] = ({
  configure: configure,
  map: map,
  routes: visary_api_routes,
  listView: list_view
});

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "955f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_map_tree_layer_vue_vue_type_style_index_0_id_65af0e18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0faf");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_map_tree_layer_vue_vue_type_style_index_0_id_65af0e18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_map_tree_layer_vue_vue_type_style_index_0_id_65af0e18_prod_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "986a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__("ebb5");
var $findLast = __webpack_require__("a258").findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a258":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE == 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),

/***/ "a558":
/***/ (function(module) {

module.exports = JSON.parse("{\"dxFileManager-rootFolder\":\"Файловое хранилище\",\"dxFileManager-commandCreateDrive\":\"Новый диск\",\"dxFileManager-commandSharedDrive\":\"Общий доступ\",\"dxFileManager-commandRestore\":\"Восстановить\",\"dxFileManager-groupMyDrives\":\"Мои диски\",\"dxFileManager-groupShared\":\"Общие\",\"dxFileManager-groupRecycleBin\":\"Сетевая корзина\",\"dxFileManager-owner\":\"Автор\",\"dxFileManager-ownerUnknown\":\"Неизвестный\",\"dxFileManager-restorePopupChooseTitle\":\"Восстановить в\",\"dxFileManager-restorePopupChooseBtn\":\"Выбрать\",\"dxFileManager-restorePopupRenameTitle\":\"Изменить название\",\"dxFileManager-restorePopupRenameBtn\":\"Изменить\",\"dxFileManager-restoreAction\":\"Восстанавливается элемент в {0}\",\"dxFileManager-restoreComplete\":\"Элемент восстановлен в {0}\",\"dxFileManager-restoreErr\":\"Не удалось восстановить элемент в {0}\",\"dxFileManager-restoreErrCommon\":\"Не удалось восстановить элемент\",\"dxFileManager-dialogSaveBtn\":\"Сохранить\",\"dxFileManager-dialogCancelBtn\":\"Отмена\",\"dxFileManager-newDriveAction\":\"Создается новый диск {0}\",\"dxFileManager-newDriveComplete\":\"Новый диск {0} создан\",\"dxFileManager-newDriveErr\":\"Не удалось создать новый диск {0}\",\"dxFileManager-newDriveErrCommon\":\"Не удалось создать новый диск\",\"dxFileManager-newDrivePopupTitle\":\"Новый диск\",\"dxFileManager-newDrivePopupCreateBtn\":\"Создать\",\"dxFileManager-newDrivePopupName\":\"Название диска\",\"dxFileManager-newDrivePopupNameRequired\":\"Название диска обязательно\",\"dxFileManager-newDrivePopupCrypted\":\"Защищенный\",\"dxFileManager-newDrivePopupHistory\":\"Включить историю\",\"dxFileManager-newDrivePopupRecycleBin\":\"Сетевая корзина\",\"dxFileManager-newDrivePopupSharedDrive\":\"Общий доступ\",\"dxFileManager-sharedDrivePopupTitle\":\"Общий доступ - {0}\",\"dxFileManager-sharedDriveAction\":\"Настройка общего доступа для {0}\",\"dxFileManager-sharedDriveComplete\":\"Общий доступ для {0} настроен\",\"dxFileManager-sharedDriveErr\":\"Не удалось настроить общий доступ для {0}\",\"dxFileManager-sharedDriveErrCommon\":\"Не удалось настроить общий доступ\",\"dxFileManager-drivePermissionsAll\":\"Все\",\"dxFileManager-drivePermissionsAddAccess\":\"Добавить доступ\",\"dxFileManager-drivePermissionsChooseProfile\":\"Выберите пользователя или группу\",\"dxFileManager-drivePermissionsAddBtn\":\"Добавить\",\"dxFileManager-drivePermissionsCancelBtn\":\"Отмена\",\"dxFileManager-drivePermissionsUsers\":\"Пользователи\",\"dxFileManager-drivePermissionsGroups\":\"Группы\",\"dxFileManager-drivePermissionsUnknownUser\":\"Неизвестный пользователь\",\"dxFileManager-drivePermissionsUnknownGroup\":\"Неизвестная группа\",\"dxFileManager-drivePermissionsNoData\":\"Доступ не настроен\",\"dxFileManager-drivePermissionsRead\":\"Чтение\",\"dxFileManager-drivePermissionsWrite\":\"Запись\",\"dxFileManager-drivePermissionsAdmin\":\"Администратор\"}");

/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "aabb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "ade3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ "aeb0":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "b0e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HubConnectionState", function() { return HubConnectionState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackerHubEvents", function() { return TrackerHubEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackerHub", function() { return TrackerHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackerHubBuilder", function() { return TrackerHubBuilder; });
/* harmony import */ var _Users_distillery_Documents_Work_roshydromet_packages_visary_infrastructure_vue_v1_2_0_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ade3");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("14d9");
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d9e2");
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("823b");
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e06c");
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_4__);





const HubConnectionState = Object.freeze({
  Disconnected: "Disconnected",
  Connecting: "Connecting",
  Connected: "Connected",
  Disconnecting: "Disconnecting",
  Reconnecting: "Reconnecting"
});
const TrackerHubEvents = Object.freeze({
  teledataCreated: "teledataCreated"
});
class TrackerHub extends eventemitter3__WEBPACK_IMPORTED_MODULE_4___default.a {
  constructor(connection) {
    super();
    this.connection = connection;
    this.trackerIds = new Set();
    this.whenReadyCallbacks = [];
    this.events = new eventemitter3__WEBPACK_IMPORTED_MODULE_4___default.a();
    this.onReconnecting = this.onReconnecting.bind(this);
    this.onReconnected = this.onReconnected.bind(this);
    this.onClose = this.onClose.bind(this);
    this.connection.onreconnecting(this.onReconnecting);
    this.connection.onreconnected(this.onReconnected);
    this.connection.onclose(this.onClose);
    this.start();
  }
  async start() {
    try {
      await this.connection.start();
      this.events.emit("connection-state", this.connection.state);
      this.setReady();
    } catch (e) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].error(e);
    }
  }
  subscribe(trackerIds) {
    return this.subscribeWhenReady(trackerIds);
  }
  unsubscribe(trackerIds) {
    return this.unsubscribeWhenReady(trackerIds);
  }
  async subscribeWhenReady(trackerIds) {
    try {
      await this.invokeWhenReady("listenTrackers", trackerIds, [TrackerHubEvents.teledataCreated]);
      this.addTrackers(trackerIds);
    } catch (e) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].error(e);
    }
  }
  async unsubscribeWhenReady(trackerIds) {
    try {
      await this.invokeWhenReady("unlistenTrackers", trackerIds, [TrackerHubEvents.teledataCreated]);
      this.removeTrackers(trackerIds);
    } catch (e) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].error(e);
    }
  }
  async invokeWhenReady(methodName, ...args) {
    if (this.isReady) {
      return this.connection.invoke(methodName, ...args);
    } else {
      return this.ready().then(() => {
        return this.connection.invoke(methodName, ...args);
      });
    }
  }
  ready() {
    return new Promise(resolve => {
      if (this.isReady) {
        return resolve();
      }
      this.whenReadyCallbacks.push(resolve);
    });
  }
  setReady() {
    while (this.whenReadyCallbacks.length) {
      var _this$whenReadyCallba;
      (_this$whenReadyCallba = this.whenReadyCallbacks.pop()) === null || _this$whenReadyCallba === void 0 ? void 0 : _this$whenReadyCallba();
    }
  }
  get isReady() {
    var _this$connection;
    return ((_this$connection = this.connection) === null || _this$connection === void 0 ? void 0 : _this$connection.state) === HubConnectionState.Connected;
  }
  addTrackers(trackerIds) {
    trackerIds.forEach(trackerId => {
      this.trackerIds.add(trackerId);
    });
  }
  removeTrackers(trackerIds) {
    trackerIds.forEach(trackerId => {
      this.trackerIds.delete(trackerId);
    });
  }
  onReconnecting() {
    var _this$events, _this$connection2;
    (_this$events = this.events) === null || _this$events === void 0 ? void 0 : _this$events.emit("connection-state", (_this$connection2 = this.connection) === null || _this$connection2 === void 0 ? void 0 : _this$connection2.state);
  }
  onReconnected() {
    this.subscribeWhenReady([...this.trackerIds]);
    this.setReady();
    this.events.emit("reconnected");
    this.events.emit("connection-state", this.connection.state);
  }
  onClose(error) {
    var _this$events2, _this$connection3;
    if (error) {
      _utils_logger__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].error(`[TrackerHub]: Connection closed due to error "${error}".`);
    } else {
      _utils_logger__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].info("[TrackerHub]: Connection closed.");
    }
    (_this$events2 = this.events) === null || _this$events2 === void 0 ? void 0 : _this$events2.emit("connection-state", (_this$connection3 = this.connection) === null || _this$connection3 === void 0 ? void 0 : _this$connection3.state);
  }
  on(eventName, listener) {
    var _this$connection4;
    (_this$connection4 = this.connection) === null || _this$connection4 === void 0 ? void 0 : _this$connection4.on(eventName, listener);
  }
  off(eventName, listener) {
    var _this$connection5;
    (_this$connection5 = this.connection) === null || _this$connection5 === void 0 ? void 0 : _this$connection5.off(eventName, listener);
  }
  stop() {
    var _this$connection6;
    (_this$connection6 = this.connection) === null || _this$connection6 === void 0 ? void 0 : _this$connection6.stop();
  }
  destroy() {
    var _this$events3, _this$connection7;
    (_this$events3 = this.events) === null || _this$events3 === void 0 ? void 0 : _this$events3.removeAllListeners();
    this.events = null;
    (_this$connection7 = this.connection) === null || _this$connection7 === void 0 ? void 0 : _this$connection7.stop();
    this.connection = null;
    this.trackerIds.clear();
    this.whenReadyCallbacks = [];
  }
}
class TrackerHubBuilder {
  static setHubConnectionBuilder(builder) {
    TrackerHubBuilder.builder = builder;
  }
  build() {
    if (!TrackerHubBuilder.builder) {
      throw new Error("HubConnectionBuilder not found. Please call TrackerHubBuilder::setHubConnectionBuilder for set builder.");
    }
    const connection = TrackerHubBuilder.builder.build();
    return new TrackerHub(connection);
  }
}
Object(_Users_distillery_Documents_Work_roshydromet_packages_visary_infrastructure_vue_v1_2_0_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(TrackerHubBuilder, "builder", null);

/***/ }),

/***/ "b42e":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b635":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assets_scss_infrastructure_style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("52f9");
/* harmony import */ var _assets_scss_infrastructure_style_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_assets_scss_infrastructure_style_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2af9");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VisMapView", function() { return _components__WEBPACK_IMPORTED_MODULE_1__["VisMapView"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VisFileStorage", function() { return _components__WEBPACK_IMPORTED_MODULE_1__["VisFileStorage"]; });

/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ed08");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logger", function() { return _utils__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "cancelToken", function() { return _utils__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "configureParamsSerializer", function() { return _utils__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mapLocale", function() { return _utils__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1b62");
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_mixins__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _mixins__WEBPACK_IMPORTED_MODULE_3__) if(["default","VisMapView","VisFileStorage","logger","cancelToken","configureParamsSerializer","mapLocale"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _mixins__WEBPACK_IMPORTED_MODULE_3__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("365c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "visaryApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filestorageApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mapApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "osmApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "gisTrackerApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "signalr", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "profileApi", function() { return _api__WEBPACK_IMPORTED_MODULE_4__["e"]; });



const install = Vue => {
  for (const component in _components__WEBPACK_IMPORTED_MODULE_1__) {
    Vue.component(_components__WEBPACK_IMPORTED_MODULE_1__[component].name, _components__WEBPACK_IMPORTED_MODULE_1__[component]);
  }
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  install
});





/***/ }),

/***/ "b696":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b7ef":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var createPropertyDescriptor = __webpack_require__("5c6c");
var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var anInstance = __webpack_require__("19aa");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var DOMExceptionConstants = __webpack_require__("cf98");
var clearErrorStack = __webpack_require__("0d26");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c17c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (Object.freeze({
  NONE: 0,
  GROUP: 1,
  SERVER: 2,
  CLIENT: 3,
  TILE: 4,
  TRACKER: 5
}));

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThisRaw = __webpack_require__("7d7e");

var toString = uncurryThisRaw({}.toString);
var stringSlice = uncurryThisRaw(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cdce":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "cebe":
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "cf98":
/***/ (function(module, exports) {

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d49b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("796d");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["a"] = (axios => {
  axios.defaults.paramsSerializer = params => qs__WEBPACK_IMPORTED_MODULE_0___default.a.stringify(params, {
    arrayFormat: "repeat"
  });
});

/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var lengthOfArrayLike = __webpack_require__("07fa");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d978":
/***/ (function(module, exports) {

module.exports = require("@rosgidromet/visary-map-vue-rgm");

/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var isNullOrUndefined = __webpack_require__("7234");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "e06c":
/***/ (function(module, exports) {

module.exports = require("eventemitter3");

/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("c6b6");
var uncurryThisRaw = __webpack_require__("7d7e");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThisRaw(fn);
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var proxyAccessor = __webpack_require__("aeb0");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("0d26");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "ebb5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__("4b11");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var classof = __webpack_require__("f5df");
var tryToString = __webpack_require__("0d51");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineProperty = __webpack_require__("9bf2").f;
var isPrototypeOf = __webpack_require__("3a9b");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var wellKnownSymbol = __webpack_require__("b622");
var uid = __webpack_require__("90e3");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ "ed08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ logger["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ cancel_token["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ configure_params_serializer["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ map_locale; });

// EXTERNAL MODULE: ./src/utils/logger.js
var logger = __webpack_require__("823b");

// EXTERNAL MODULE: ./src/utils/cancel-token.js
var cancel_token = __webpack_require__("021d");

// EXTERNAL MODULE: ./src/utils/configure-params-serializer.js
var configure_params_serializer = __webpack_require__("d49b");

// EXTERNAL MODULE: external "@rosgidromet/visary-map-vue-rgm"
var visary_map_vue_rgm_ = __webpack_require__("d978");

// CONCATENATED MODULE: ./src/utils/map-locale.js

/* harmony default export */ var map_locale = (visary_map_vue_rgm_["locale"].setLocale);
// CONCATENATED MODULE: ./src/utils/index.js






/***/ }),

/***/ "f03a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_item_vue_vue_type_style_index_0_id_ea7f87c0_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7944");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_item_vue_vue_type_style_index_0_id_ea7f87c0_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_drive_permissions_item_vue_vue_type_style_index_0_id_ea7f87c0_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f1a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_create_drive_dialog_vue_vue_type_style_index_0_id_2154c38a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aabb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_create_drive_dialog_vue_vue_type_style_index_0_id_2154c38a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vis_create_drive_dialog_vue_vue_type_style_index_0_id_2154c38a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f2e6":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/button");

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8cd":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ "fac5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: ./src/utils/configure-params-serializer.js
var configure_params_serializer = __webpack_require__("d49b");

// CONCATENATED MODULE: ./src/api/gistracker-api/repository.js


let axiosInstance = null;
const configure = axios => {
  Object(configure_params_serializer["a" /* default */])(axios);
  axiosInstance = axios;
};
/* harmony default export */ var repository = ({
  get instance() {
    if (!axiosInstance) {
      throw new Error("This repository not configured. Call configure method.");
    }
    return axiosInstance;
  }
});
// EXTERNAL MODULE: external "devextreme/core/utils/dependency_injector"
var dependency_injector_ = __webpack_require__("2214");
var dependency_injector_default = /*#__PURE__*/__webpack_require__.n(dependency_injector_);

// CONCATENATED MODULE: ./src/api/gistracker-api/teledata.js


/* harmony default export */ var teledata = (dependency_injector_default()({
  mostRecent: async (trackerIds, cancelToken = null) => (await repository.instance.get(`crud/teledata/mostRecent/${encodeURIComponent(trackerIds.join(","))}`, {
    cancelToken
  })).data
}));
// CONCATENATED MODULE: ./src/api/gistracker-api/index.js


/* harmony default export */ var gistracker_api = __webpack_exports__["a"] = ({
  configure: configure,
  teledata: teledata
});

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setPublicPath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1eb2");
/* harmony import */ var _entry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b635");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _entry__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _entry__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));


/* harmony default export */ __webpack_exports__["default"] = (_entry__WEBPACK_IMPORTED_MODULE_1__["default"]);



/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("04f8");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fee0":
/***/ (function(module, exports) {

module.exports = require("devextreme-vue/file-manager");

/***/ }),

/***/ "ff9b":
/***/ (function(module, exports) {

module.exports = require("@mapbox/polyline");

/***/ })

/******/ });
//# sourceMappingURL=visary-infrastructure-vue.common.js.map